export const en = {
    translation: {
        "project_selector.favorites": "Favorites",
        "project_selector.suggested": "Suggested projects",
        "project_selector.search_results": "Search results",
        "project_selector.projects": "Projects",
        "project_selector.no_projects_found": "No projects found",
        "project_selector.no_projects_to_show": "No projects to show",
        "project_selector.offer": "Offer",
        "project_selector.sub_of": "Under",
        "project_list.scope.projects": "Projects",
        "project_list.scope.offers": "Offers",
        "project_list.scope.all": "All",
        "project_list.badge.offer": "Offer",
        "project_list.badge.subproject": "Subproject",
        "project_list.sub_of": "Part of",
        "project.parent_project": "Parent project",
        "project.parent_project.none": "No parent project",
        "Case guide": "Case guide",
        "Guider": "Guides",
        "Guider tilgjengelig": "Guides available",
        "guider": "guides",
        "Velg hvilken guide du vil bruke for etterspurt info.": "Choose which guide to use for requested info.",
        "Velg hvilken guide du vil starte for denne saken.": "Choose which guide to start for this case.",
        "Dupliser guide": "Duplicate guide",
        "kopi": "copy",
        "Uten navn": "Untitled",
        "Rapportguide": "Report guide",
        "Rapportguider": "Report guides",
        "Opprett og rediger guidede flyter for rapportarbeid.": "Create and edit guided flows for report work.",
        "Guideomfang": "Guide scope",
        "Velg om du vil redigere generelle rapportguider eller guider for en spesifikk rapporttype.": "Choose whether to edit general report guides or guides for a specific report type.",
        "Tilbake til serviceinnstillinger": "Back to service settings",
        "Generelle rapportguider": "General report guides",
        "Opprett og rediger guidede flyter for rapportarbeid på egen side.": "Create and edit guided report flows on a dedicated page.",
        "Åpne rapportguider": "Open report guides",
        "Caseguider": "Case guides",
        "Opprett og rediger guidede flyter for saker.": "Create and edit guided flows for cases.",
        "Guideomfang case": "Guide scope (case type)",
        "Velg case type for å redigere guideflyten.": "Select a case type to edit its guide flow.",
        "Case guides scope intro":
          "Choose whether to edit general case guides (all types) or guides scoped to one case type — same pattern as report guides.",
        "Generelle caseguider": "General case guides",
        "Generell caseguide": "General",
        "Case guide scope general hint": "Configure flows that apply to every case type.",
        "Case guide scope type hint":
          "Type-specific guides are listed first, followed by general guides that apply to all types.",
        "Tilbake til caseinnstillinger": "Back to case settings",
        "Åpne caseguider": "Open case guides",
        "Opprett og rediger guidede flyter for saker på egen side.": "Create and edit guided case flows on a dedicated page.",
        "Ingen case typer er opprettet ennå.": "No case types have been created yet.",
        "Caseguide-bygger på egen side": "The case guide flow builder opens on a dedicated page.",
        "Åpne guidebygger": "Open guide builder",
        "Case guide options connect to effect nodes":
          "Answer options only store label and value. Use Connect on an option to link to an effect node on the canvas (labels, priority, due date, etc.).",
        "Velg rapportguide": "Select report guide",
        "Velg guiden som passer best med oppdraget.": "Select the guide that best fits the assignment.",
        "Velg guide": "Select guide",
        "Ny rapportguide": "New report guide",
        "Ny guide": "New guide",
        "Inaktiv": "Inactive",
        "Generell": "General",
        "Generell rapportguide": "General report guide",
        "Kan brukes på alle rapporttyper": "Can be used on all report types",
        "spørsmål": "questions",
        "Avslutt etter dette svaret": "End after this answer",
        "Guide builder": "Guide builder",
        "Effekter": "Effects",
        "Effekt": "Effect",
        "Effect-node": "Effect node",
        "Guide flow palette effect id line": "Adds a canvas node with this effect id:",
        "Guide flow effect editor palette link": "Same palette block / effect id",
        "Guide flow option connection": "This answer connects to",
        "Rapporttekst": "Report text",
        "Intern tekst": "Internal text",
        "Case oppfølging": "Case follow-up",
        "Sjekkliste": "Checklist",
        "Videre": "Continue",
        "Avslutt etter denne effekten": "End after this effect",
        "Rediger effekt": "Edit effect",
        "Opprett spørsmål som noder og koble svar til neste spørsmål.": "Create questions as nodes and connect answers to the next question.",
        "Dra inn eller klikk for å opprette.": "Drag in or click to create.",
        "Guide flow": "Guide flow",
        "guide.flow.json_dialog_title": "Guide flow — JSON & AI instructions",
        "guide.flow.json_tab": "JSON",
        "guide.flow.ai_guide_tab": "AI instructions",
        "guide.flow.json_hint":
          "Edges are rebuilt automatically from option `next_node_id` and effect `next_node_id`. Paste valid JSON or edit below, then apply.",
        "guide.flow.copy_json": "Copy JSON",
        "guide.flow.apply_json": "Apply to canvas",
        "guide.flow.reload_from_canvas": "Reload from canvas",
        "guide.flow.reload_from_canvas_success": "Editor synced from current canvas.",
        "guide.flow.copy_json_success": "JSON copied to clipboard.",
        "guide.flow.clipboard_failed": "Could not access clipboard.",
        "guide.flow.json_invalid": "Invalid JSON or flow: {{message}}",
        "guide.flow.json_applied": "Guide flow updated.",
        "guide.flow.copy_ai_guide": "Copy AI authoring guide",
        "guide.flow.ai_guide_copied": "AI authoring guide copied.",
        "guide.flow.ai_empty": "AI returned empty flow JSON.",
        "guide.flow.ai_applied": "Guide flow updated from AI.",
        "guide.flow.open_json": "JSON",
        "guide.flow.open_json_tooltip": "View, copy, paste, or edit the guide flow as JSON",
        "guide.flow.generate_with_ai": "Generate with AI",
        "guide.flow.ai_guide_intro":
          "Paste these instructions into external AI tools or use Promang's built-in generator. Technical keys match `settings.flow` in the API.",

        "Velg neste spørsmål for valgt svar.": "Select the next question for the selected answer.",
        "Koble svar til neste spørsmål ved å bruke Koble-knappen på et svar.": "Connect an answer to the next question by using the Connect button on an answer.",
        "Nytt spørsmål": "New question",
        "Koble": "Connect",
        "Koble om": "Reconnect",
        "Slett kobling": "Delete connection",
        "Sett som start": "Set as start",
        "Rediger spørsmål": "Edit question",
        "Svarvalg": "Answer options",
        "Velg en node for å redigere.": "Select a node to edit.",
        "Tid": "Time",
        "Guidet rapport": "Guided report",
        "Ingen rapportguide er tilgjengelig": "No report guide is available",
        "Rapportguide lagret": "Report guide saved",
        "Guiden kan fylle rapporttekst og lagrer svar for administrasjon.": "The guide can fill report text and saves answers for administration.",
        "Lagre rapporttypen før du konfigurerer guide.": "Save the report type before configuring a guide.",
        "Konfigurer spørsmål som kan fylle rapporttekst og lagre svar for administrasjon.": "Configure questions that can fill report text and save answers for administration.",
        "Ta med svar i rapporttekst": "Include answer in report text",
        "Rapporttekst ved valg": "Report text for option",
        "Intern tekst ved valg": "Internal text for option",
        "Case oppfølging tittel": "Case follow-up title",
        "Case oppfølging tekst": "Case follow-up text",
        "Krever tiltak": "Requires action",
        "Reklamasjon": "Complaint",
        "Ingen sjekkliste": "No checklist",
        "Opprett sjekkliste": "Create checklist",
        "Opprett oppfølger": "Create follow-up",
        "Oppfølger beskrivelse": "Follow-up description",
        "Oppfølger intern beskrivelse": "Follow-up internal description",
        "Ingen sjekkliste på oppfølger": "No checklist on follow-up",
        "Opprett avtale på oppfølger": "Create appointment on follow-up",
        "Bruk samme avtaledato og tid som nåværende rapport": "Use the same appointment date and time as the current report",
        "Guidet case-opprettelse": "Guided case creation",
        "Etterspørre info": "Request info",
        "Etterspurt info": "Requested info",
        "Guidet opprettelse": "Guided creation",
        "Spørsmål": "Question",
        "Steg": "Step",
        "Oppsummering": "Summary",
        "guide.case_view_summary": "Review summary",
        "guide.case_summary_review_intro": "Check your answers before applying the guide.",
        "guide.case_chain_effect_title": "Start another case guide",
        "guide.case_chain_effect_help":
          "After this guide is applied, the selected guide opens automatically on the same case (current guide finishes first).",
        "guide.case_chain_pick_guide": "Next guide",
        "guide.case_chain_none": "— none —",
        "guide.case_chain_started": "Opening the next guide…",
        "guide.case_chain_summary_hint":
          "After you apply this guide, another guide will start automatically on the same case.",
        "Ingen guide-spørsmål er konfigurert.": "No guide questions are configured.",
        "Guiden foreslår": "The guide suggests",
        "etiketter": "labels",
        "Bruk guide": "Apply guide",
        "Åpne guide": "Open guide",
        "Tilbake": "Back",
        "Besvart": "Answered",
        "Automatiske etiketter brukt": "Automatic labels applied",
        "Automatiske etiketter lagt til": "Automatic labels added",
        "Antall": "Count",
        "Denne case typen krever guide før opprettelse": "This case type requires the guide before creation",
        "Fyll ut guide": "Complete guide",
        "Fyll ut guiden før saken opprettes": "Complete the guide before creating the case",
        "besvarte etterspurt info": "answered requested info",
        "fullførte guide": "completed guide",
        "Konfigurer spørsmål, valg og automatiske etiketter for denne case typen.": "Configure questions, choices and automatic labels for this case type.",
        "Lagre case type før du konfigurerer guide.": "Save the case type before configuring a guide.",
        "Guide title": "Guide title",
        "Guide description": "Guide description",
        "Aktiv": "Active",
        "Legg til spørsmål": "Add question",
        "Lagre guide": "Save guide",
        "Spørsmålstekst": "Question text",
        "Påkrevd": "Required",
        "Valg": "Option",
        "Valg 1": "Option 1",
        "Valg label": "Option label",
        "Verdi": "Value",
        "Fjern valg": "Remove option",
        "Automatiske etiketter": "Automatic labels",
        "Legg til valg": "Add option",
        "Select case type": "Select case type",
        "Case Type": "Case type",
        "No results": "No results",
        "Select case type first": "Select case type first",
        "No guide configured for this case type": "No guide configured for this case type",
        "Ny case": "New case",
        "Velg case type først. Guiden hjelper deg å stille riktige spørsmål og foreslår etiketter automatisk.": "Select the case type first. The guide helps ask the right questions and suggests labels automatically.",
        "Title and case type are required": "Title and case type are required",
        "Case type is required": "Case type is required",
        "Velg case type først. Tittel genereres automatisk med AI etter opprettelse.": "Select the case type first. The title is generated automatically with AI after creation.",
        "Guide åpnes etter opprettelse": "Guide opens after creation",
        "Etter opprettelse": "After creation",
        "Velg case type først. Hvis typen har en guide kan du besvare den før saken opprettes.": "Select the case type first. If the type has a guide, you can answer it before the case is created.",
        "Valgfri guide for denne case typen": "Optional guide for this case type",
        "Type": "Type",
        "Detaljer": "Details",
        "Velg type": "Select type",
        "Saksdetaljer": "Case details",
        "Guide besvart": "Guide answered",
        "Klar til opprettelse": "Ready to create",
        "Se guide igjen": "Open guide again",
        "Start guide": "Start guide",
        "Hva slags case oppretter du?": "What kind of case are you creating?",
        "Case typen styrer hvilke spørsmål og automatiske forslag som vises.": "The case type controls which questions and automatic suggestions are shown.",
        "Guide": "Guide",
        "Ikke brukt": "Not used",
        "Ja": "Yes",
        "Nei": "No",
        "templates.title": "Templates",
        "templates.new": "New template",
        "templates.edit": "Edit template",
        "templates.empty": "No templates found.",
        "templates.search_placeholder": "Search templates...",
        "templates.editor_placeholder": "Write the template content...",
        "templates.editor_hint": "Create reusable rich text content and connect it to a category.",
        "templates.form.title": "Template details",
        "templates.form.subtitle": "Give the template a clear title, category and rich text content.",
        "templates.insert.append": "Paste together with existing text",
        "templates.insert.replace": "Replace the whole text",
        "templates.insert.use": "Use template",
        "templates.hero.kicker": "Content library",
        "templates.hero.subtitle": "Organize reusable text templates in categories and insert them from rich text editors.",
        "templates.filters.heading": "Search and filters",
        "templates.filters.description": "Search templates or filter by category.",
        "templates.categories.title": "Categories",
        "templates.categories.all": "All templates",
        "templates.categories.new": "New category",
        "templates.categories.edit": "Edit category",
        "templates.categories.name": "Name",
        "templates.categories.parent": "Parent category",
        "templates.categories.no_parent": "No parent category",
        "templates.categories.description": "Description",
        "templates.categories.uncategorized": "Uncategorized",
        "templates.section.kicker": "Templates",
        "templates.section.title": "All templates",
        "templates.section.subtitle": "Choose a category to see only templates connected to it.",
        "templates.section.category_title": "Category templates",
        "templates.section.category_subtitle": "Templates connected to the selected category.",
        "company.settings.tabs.company": "Company",
        "company.settings.tabs.employment_agreement": "Employment agreement",
        "company.employment_agreement.title": "Standard agreement text",
        "company.employment_agreement.description": "This text is included as shared agreement text in the employment contract PDF for employees.",
        "company.employment_agreement.placeholder": "Write standard employment agreement text...",
        "payslips.kicker": "Tripletex payroll",
        "payslips.title": "Payroll",
        "payslips.mine_title": "My payslips",
        "payslips.admin_title": "Payslips",
        "payslips.stats_title": "Statistics",
        "payslips.description": "View payslips made available from Tripletex without signing in to Tripletex.",
        "payslips.admin_description": "Manage and filter employee payslips. Requires the Payroll Admin role (company administrators only see their own payslips unless assigned Payroll Admin).",
        "payslips.stats_description": "Overview of payslips included in the totals below (your own slips unless you have Payroll Admin).",
        "payslips.admin_forbidden": "You need the Payroll Admin role to manage all payslips for the company. Ask an administrator to assign Payroll Admin for this company.",
        "payslips.role_view_override_warning":
          "Role view simulation is active — it only changes menus/UI. The API still uses your real roles. Turn off role view (DevOps menu) to match permissions, or ignore this if you are testing intentionally.",
        "payslips.loading": "Loading payslips...",
        "payslips.empty": "No payslips are available yet.",
        "payslips.error": "Could not fetch payslips.",
        "payslips.period": "Period",
        "payslips.employee": "Employee",
        "payslips.voucher_date": "Voucher date",
        "payslips.available_date": "Available",
        "payslips.gross_amount": "Gross",
        "payslips.amount": "Net",
        "payslips.actions": "Actions",
        "payslips.open": "Open",
        "payslips.opening": "Opening...",
        "payslips.sync_now": "Sync now",
        "payslips.syncing": "Syncing...",
        "payslips.employee_filter": "Employee",
        "payslips.stats_count": "Payslips",
        "payslips.stats_gross": "Gross total",
        "payslips.stats_net": "Net total",
        "payslips.stats_average_net": "Average net",
        "listbox.none": "Not selected",
        "user_info.address": "Address",
        "user_info.address_hint": "Saved on the user profile and used as address basis in the employment flow.",
        "user_employment.option_not_selected": "Not selected",
        "user_employment.section_basic": "Employment basis",
        "user_employment.section_basic_hint": "Core data for the employment relationship and employment contract.",
        "user_employment.employee_number": "Employee number",
        "user_employment.employment_starts": "Employment starts",
        "user_employment.social_security": "National identity number",
        "user_employment.working_posistion": "Position",
        "user_employment.workplace": "Workplace",
        "user_employment.agreement_type": "Agreement type",
        "user_employment.agreement_type_permanent": "Permanent",
        "user_employment.agreement_type_temporary": "Temporary",
        "user_employment.agreement_type_hourly": "On-call/hourly",
        "user_employment.agreement_type_seasonal": "Seasonal",
        "user_employment.agreement_type_other": "Other",
        "user_employment.section_worktime": "Working time",
        "user_employment.section_worktime_hint": "Time spans that can be used in the employment contract.",
        "user_employment.worktime_regular_from": "Regular from",
        "user_employment.worktime_regular_too": "Regular to",
        "user_employment.worktime_weekend_from": "Weekend from",
        "user_employment.worktime_weekend_too": "Weekend to",
        "user_employment.worktime_regular_range": "Regular working time",
        "user_employment.worktime_weekend_range": "Weekend work",
        "user_employment.section_wages": "Wages and additions",
        "user_employment.section_wages_hint": "Agreed wage terms. The salary table below remains available for history and time calculations.",
        "user_employment.wages": "Wages",
        "user_employment.wages_unit": "Wages per",
        "user_employment.wage_unit_hour": "Hour",
        "user_employment.wage_unit_month": "Month",
        "user_employment.wage_unit_year": "Year",
        "user_employment.wage_unit_fixed": "Fixed agreed",
        "user_employment.overtime_pay": "Overtime pay",
        "user_employment.dismissal": "Notice period",
        "user_employment.wage_other_addition": "Other additions",
        "user_employment.wage_weekend_and_night_addition": "Weekend/night addition",
        "user_employment.collective_agreement": "Collective agreement",
        "user_employment.section_contract_text": "Contract text",
        "user_employment.section_contract_text_hint": "Text fields used as basis for the employment contract and internal documentation.",
        "user_employment.employment_instructions": "Position instructions",
        "user_employment.employment_allowance": "Allowance",
        "user_employment.notes": "Notes",
        "user_employment.other": "Other",
        "user_employment.section_signature": "Signature and payment",
        "user_employment.section_signature_hint": "Signature and payment basis for the employment contract.",
        "user_employment.signed_place": "Signing place",
        "user_employment.signed_at": "Signing date",
        "user_employment.account_number": "Account number",
        "user_employment.hourly_costs_title": "Hourly rates and costs",
        "user_employment.section_contract_actions": "Employment contract",
        "user_employment.section_contract_actions_hint": "Printing and signing will use the contract basis once PDF/signing is available.",
        "user_employment.contract_actions_notice_title": "Ready for next phase",
        "user_employment.contract_actions_notice": "The data basis can now be filled in. Employment contract printing and Posten signing are connected in a separate implementation.",
        "user_employment.print_contract": "Print employment contract",
        "user_employment.print_contract_unavailable": "The PDF route for employment contracts is not connected yet.",
        "user_employment.send_to_signing": "Send for signing",
        "user_employment.signing_unavailable": "Posten signing is implemented by a separate agent.",
        "user_employment.contract_title": "Employment contract",
        "user_employment.contract_description": "Employment contract for digital signing",
        "user_employment.preview_contract_draft": "Preview employment contract draft",
        "user_employment.download_contract_draft_pdf": "Download draft PDF",
        "user_employment.draft_pdf_download_failed": "Could not download draft PDF.",
        "user_employment.contract_draft_label": "Draft",
        "user_employment.contract_draft_for": "For {{name}}",
        "user_employment.draft_notice_title": "Review before signing",
        "user_employment.draft_notice": "This is a preview based on saved and filled-in form fields. Save changes before sending for signing.",
        "user_employment.employee_name": "Employee",
        "signing.title": "Digital signing",
        "signing.description": "Send the document to Posten Signering and follow signer status.",
        "signing.new_request": "New signing request",
        "signing.empty": "No signing requests have been created yet.",
        "signing.sender_reference": "Reference",
        "signing.signer_name": "Signer name",
        "signing.national_identity_number": "National identity number / D-number",
        "signing.email": "Email",
        "signing.mobile": "Mobile",
        "signing.identity_warning": "Use national identity number/D-number when available. Email/SMS-only signing is valid, but Promang must verify that the right person signed.",
        "signing.send": "Send to signing",
        "signing.created": "Signing request created",
        "signing.refreshed": "Signing status refreshed",
        "signing.refresh_status": "Refresh status",
        "signing.download_signed": "Download signed PDF",
        "signing.errors.load_failed": "Could not load signing requests.",
        "signing.errors.create_failed": "Could not create signing request.",
        "signing.errors.poll_failed": "Could not refresh signing status.",
        "signing.errors.download_failed": "Could not download signed document.",
        "signing.status.draft": "Draft",
        "signing.status.queued": "Queued",
        "signing.status.sent": "Sent",
        "signing.status.in_progress": "In progress",
        "signing.status.completed": "Completed",
        "signing.status.failed": "Failed",
        "signing.status.rejected": "Rejected",
        "signing.status.expired": "Expired",
        "signing.status.cancelled": "Cancelled",
        "signing.status.waiting": "Waiting",
        "signing.status.available": "Available",
        "signing.status.signed": "Signed",
        "webpage.editor.open_live": "View live",
        "webpage.editor.open_live_title": "Open this page on the webshop (new tab)",
        "webpage.editor.open_live_title_unpublished":
          "Open the webshop URL. Publish the page so customers can see the content.",
        "webpage.editor.import_blocks": "JSON / AI",
        "webpage.editor.import_tooltip": "Paste JSON blocks or copy the AI prompt",
        "webpage.editor.import_dialog_title": "Import blocks or AI guide",
        "webpage.editor.import_tab_paste": "Paste JSON",
        "webpage.editor.import_tab_guide": "AI instructions (copy)",
        "webpage.editor.import_hint":
          "Paste JSON as { \"blocks\": [ ... ] }, a raw array, or exported shape with content.blocks. Wrapping in ```json ... ``` is OK.",
        "webpage.editor.import_replace": "Replace all blocks",
        "webpage.editor.import_append": "Append at bottom",
        "webpage.editor.import_sample": "Insert sample",
        "webpage.editor.import_apply": "Build blocks",
        "webpage.editor.import_success": "Imported {{count}} block(s). Remember to save the page.",
        "webpage.editor.import_error_empty": "Nothing to parse.",
        "webpage.editor.import_error_invalid_json": "Invalid JSON.",
        "webpage.editor.import_error_no_blocks_array": "Expected a blocks array, raw array, or content.blocks.",
        "webpage.editor.import_error_no_valid_blocks": "No valid blocks (type must be text, image, header, section, button, or columns).",
        "webpage.editor.import_error_unknown": "Import failed.",
        "webpage.editor.ai_guide_intro":
          "Copy the text below into your AI system prompt. The model should answer with plain JSON only (no markdown fences).",
        "webpage.editor.copy_ai_guide": "Copy AI instructions",
        "webpage.editor.ai_guide_copied": "Instructions copied to clipboard",
        "webpage.editor.ai_guide_copy_failed": "Could not copy (browser permissions)",
        "webpage.editor.generate_with_ai": "Generate with ChatGPT",
        "webpage.editor.ai_apply_success": "AI added {{count}} block(s) to the editor. Remember to save the page.",
        "webpage.editor.ai_parse_error": "AI did not return valid page JSON. Try again or paste JSON from the “Paste JSON” tab.",
        "Dashboard": "Dashboard",
        "Overview of your workspace": "Overview of your workspace",
        "Collapse": "Collapse",
        "Expand": "Expand",
        "Resource Hub": "Resource Hub",
        "resource_hub.faq.linked_records_title": "Related records",
        "resource_hub.faq.linked_records_help":
          "Link to other company records (HMS/KS document, vehicle, product, report, customer, project). Choose a type, then search and pick the record — you do not need to know its numeric ID. For HMS/KS documents, enter at least two characters in the search box to find matches.",
        "resource_hub.faq.linked_records_add": "Add link",
        "resource_hub.faq.linked_records_type": "Resource type",
        "resource_hub.faq.linked_records_id": "ID",
        "resource_hub.faq.linked_records_pick": "Search and select…",
        "resource_hub.faq.linked_records_existing": "Label (saved)",
        "resource_hub.faq.link_type.hse_document": "HMS / KS document",
        "resource_hub.faq.link_type.vehicle": "Vehicle",
        "resource_hub.faq.link_type.product": "Product",
        "resource_hub.faq.link_type.report": "Report",
        "resource_hub.faq.link_type.customer": "Customer",
        "resource_hub.faq.link_type.project": "Project",
        "resource_hub.faq.linked_records_placeholder_type": "Choose type",
        "product.add": "Add a product",
        "product.update": "Update product",
        "product.model_year": "Model year",
        "product.replaced_by_product": "Replaced by product",
        "product.replaced_by.banner_title": "This product has been replaced",
        "product.replaced_by.banner_description":
          "Use the replacement product for up-to-date details, pricing and stock.",
        "product.replaced_by.open_replacement": "Open replacement product",
        "product.selector.open_product": "Open product",
        "product.selector.replaced_label": "Replaced",
        "product.selector.search_placeholder": "Search products…",
        "product.selector.empty_flat_list":
          "Search or scroll the list. Use the funnel to narrow active, expired, or warehouse filters.",
        "customer.system.product_search_placeholder":
          "Search systems (products with spare parts)…",
        "product.selector.filter_system_products":
          "System (spare-part products)",
        "product.selector.toggle_filters": "Show filters",
        "title.required": "Tittel er krevd",
        "storage.edit": "Edit storage",
        "storage.create": "Create a storage",
        "service.report_types": "Service Report Types",
        "service.report_types.edit": "Edit Report Type",
        "service.report_types.create": "Create Report Type",
        "service.agreement_types": "Service Agreement Types",
        "service.variable_types": "Service Variable Types",
        "service.agreements.list.title": "Service agreements",
        "service.agreements.list.hero_kicker": "Service",
        "service.agreements.list.subtitle":
          "Search, filter by view, and manage recurring service agreements.",
        "service.agreements.list.meta.total": "Agreements",
        "service.agreements.list.meta.new": "New",
        "service.agreements.list.new": "New agreement",
        "service.agreements.list.filters_heading": "Filters",
        "service.agreements.list.filters_description":
          "Refine the list with search and view presets.",
        "service.agreements.list.search_placeholder": "Search agreements…",
        "service.agreements.list.sort_label": "Sort",
        "service.agreements.list.per_page": "Per page",
        "service.agreements.list.table_kicker": "List",
        "service.agreements.list.table_title": "Agreements",
        "service.agreements.list.table_description":
          "Select rows for bulk actions from the toolbar above.",
        "service.agreements.filter.view": "View",
        "service.agreements.view.service_soon": "Service soon (5 days)",
        "service.agreements.view.active": "Active",
        "service.agreements.sort.next_service_asc":
          "Next service — soonest first",
        "service.agreements.sort.next_service_desc":
          "Next service — latest first",
        "service.agreements.sort.created_desc": "Created — newest first",
        "service.agreements.sort.created_asc": "Created — oldest first",
        "service.agreements.table.col_title": "Title",
        "service.agreements.table.col_type": "Type",
        "service.agreements.table.col_project": "Project",
        "service.agreements.table.col_customer": "Customer",
        "service.agreements.table.col_delivery": "Delivery address",
        "service.agreements.table.col_next": "Next service",
        "service.agreements.table.col_interval": "Interval",
        "service.agreements.table.col_status": "Status",
        "service.agreements.table.col_days": "Days until service",
        "service.agreements.table.missing_address": "No delivery address",
        "service.agreements.table.col_next_job": "Next job",
        "service.agreements.next_job.section_title": "Next service job",
        "service.agreements.next_job.next_on": "The next job is scheduled for",
        "service.agreements.next_job.days_until":
          "There are {{count}} days until the next job.",
        "service.agreements.next_job.in_progress": "A job is in progress",
        "service.agreements.actions.missing_type":
          "Agreement type is missing; this agreement cannot be processed.",
        "service.agreements.actions.create_report": "Create new report",
        "service.agreements.actions.create_order": "Create order",
        "service.agreements.actions.go_to_report": "Open report",
        "service.agreements.actions.hint_create_report":
          "A new report is created. When the job is completed, the next service date is set from the completion date.",
        "service.agreements.actions.hint_create_order":
          "A new order is created; the next service date is set automatically.",
        "service.agreements.actions.prompt_report_title": "Create new report",
        "service.agreements.actions.prompt_report_body":
          "Are you sure you want to create a new report for this service agreement?",
        "service.agreements.actions.prompt_order_title": "Create new order",
        "service.agreements.actions.prompt_order_body":
          "Are you sure you want to create a new order for this service agreement?",
        "service.agreements.actions.err_no_agreement":
          "Cannot create without a service agreement.",
        "service.agreements.actions.err_active_report_report":
          "Cannot create a report while a report is already active.",
        "service.agreements.actions.err_active_report_order":
          "Cannot create an order while a report is already active.",
        "service.agreements.actions.err_no_customer_report":
          "Cannot create a report without a customer.",
        "service.agreements.actions.err_no_customer_order":
          "Cannot create an order without a customer.",
        "service.report.order_dialog.title_create": "Create order from report",
        "service.report.order_dialog.title_additional": "Create additional order",
        "service.report.product_line_dialog.title": "Product line",
        "service.report.product_line_dialog.delete_line": "Delete line",
        "service.report.product_line_dialog.delete_tooltip": "Delete line",
        "service.report.product_line_dialog.delete_confirm_title":
          "Delete this line permanently?",
        "service.report.product_line_dialog.delete_confirm_hint":
          "This cannot be undone.",
        "service.report.product_line_dialog.delete_cancel": "Cancel",
        "service.report.product_line_dialog.delete_confirm": "Delete",
        "service.report.product_line_dialog.delete_working": "Deleting…",
        "service.report.product_line_dialog.back_tooltip": "Back to product line",
        "service.report.order_dialog.dialog_eyebrow": "Order",
        "service.report.order_dialog.section_invoice": "Customer & invoice",
        "service.report.order_dialog.section_km": "Mileage",
        "service.report.order_dialog.section_price_lines": "Agreed price lines",
        "service.report.order_dialog.section_order_group": "Order grouping",
        "service.report.order_dialog.price_lines_intro":
          "The following lines are added to the order automatically:",
        "service.report.order_dialog.price_lines_included_hours": "Included hours:",
        "service.report.order_dialog.price_lines_footer_note":
          "These lines include {{hours}} h billed via the price lines, not as separate hour lines.",
        "service.report.order_dialog.generate_invoice": "Generate with ChatGPT",
        "service.report.order_dialog.generating_invoice": "Generating…",
        "service.report.order_dialog.orders_heading": "Orders on this report",
        "service.report.order_dialog.open_order": "Open order {{number}}",
        "service.report.order_dialog.create": "Create order",
        "service.report.order_dialog.create_another": "Create another order",
        "service.report.order_dialog.follow_up_notice_title": "Additional order",
        "service.report.order_dialog.follow_up_notice_body":
          "Agreed price lines were included on the first order from this report and are not added again automatically. You can bill new hours, mileage, and order lines that are not already invoiced.",
        "service.report.order_dialog.hours_rounding_label": "Billable hours rounding",
        "service.report.order_dialog.hours_rounding_actual":
          "Actual registered time (no rounding)",
        "service.report.order_dialog.hours_rounding_ceil_half":
          "Round up to next half hour (0.5 h)",
        "service.report.order_dialog.hours_rounding_nearest_half": "Round to nearest half hour",
        "service.report.order_dialog.hours_rounding_ceil_hour": "Round up to whole hours",
        "service.report.order_dialog.hours_rounding_nearest_hour": "Round to nearest whole hour",
        "service.report.order_dialog.hours_rounding_hint":
          "Default is actual time. Use rounding only when your billing rules require it (round-up half hour matches the old checkbox).",
        "service.report.order_dialog.hour_lines_label": "Hour lines on the order",
        "service.report.order_dialog.hour_lines_each":
          "One line per time entry (recommended for detail)",
        "service.report.order_dialog.hour_lines_grouped":
          "Merge by activity (one line per activity)",
        "service.report.order_dialog.hour_lines_hint":
          "Multiple entries on the same activity become one line when merged. Flat activity fees (budget_fee) stay one line per activity.",
        "service.report.order_dialog.section_order_lines": "Order lines (consumption)",
        "service.report.order_dialog.section_order_lines_subtitle":
          "{{selected}} of {{total}} lines with usage",
        "service.report.order_dialog.section_hours_subtitle":
          "{{selected}} of {{total}} h",
        "service.report.order_dialog.section_hours_subtitle_manual":
          "Manual hours or pick entries below",
        "service.report.order_dialog.toggle_order_lines_aria": "Bill order lines",
        "service.report.order_dialog.toggle_hours_aria": "Bill hours",
        "service.report.order_dialog.invoice_order_lines_switch":
          "Bill order lines ({{selected}} of {{total}} with usage selected)",
        "service.report.order_dialog.pick_order_lines":
          "Select order lines to bill (products with usage only):",
        "service.report.order_dialog.no_consumption_lines":
          "No order lines with usage registered",
        "service.report.order_dialog.add_tilleggsarbeider_group_label":
          "Separate order group “Tilleggsarbeider” (additional work)",
        "service.report.order_dialog.add_tilleggsarbeider_group_hint":
          "Turn off to place hours and related lines in the main group (same as invoice title/text). Useful for orders that are only product lines without an extra group.",
        "service.report.order_dialog.section_hours": "Hours (additional work)",
        "service.report.order_dialog.invoice_hours_switch":
          "Bill hours ({{selected}} of {{total}} h selected)",
        "service.report.order_dialog.invoice_hours_switch_manual":
          "Bill hours (manual or from list)",
        "service.report.order_dialog.hours_manual_notice_title": "No billable hour entries",
        "service.report.order_dialog.hours_manual_notice_body":
          "All time may sit in agreed price lines, or no hours are registered. Keep billing enabled and enter manual hours below to add the default hour product to the order.",
        "service.report.order_dialog.pick_billable_hours":
          "Select hours to bill (additional work only):",
        "service.report.order_dialog.hours_settings_heading": "Hour settings",
        "service.report.order_dialog.manual_hours_label":
          "Manual hours (overrides selected hours when set)",
        "service.report.order_dialog.manual_hours_placeholder":
          "Required for manual-only billing — otherwise optional",
        "service.report.order_dialog.hours_discount_label": "Discount (%)",
        "service.report.order_dialog.hours_preview_heading": "Preview",
        "service.report.order_dialog.hours_preview_quantity": "Hours: {{hours}}",
        "service.report.order_dialog.hours_preview_discount": "Discount: {{pct}}%",
        "order.number": "Order number",
        "order.total": "Order sum total",
        "order.info": "Order Information",
        "status": "Status",
        "customer": "Customer",
        "customer.name": "Customer Name",
        "customer.number": "Customer Number",
        "customer.email": "Customer Email",
        "customer.mobile": "Customer Mobile",
        "customer.required": "Customer is required",
        "customer.address": "Customer address",
        "reference": "Reference",
        "customer.contact": "Contact Person",
        "customer.type": "Customer Type",
        "customer.name.required": "Customer name is required",
        "Contact information": "Contact Information",
        "company.outbound_mail.title": "Outbound email (Microsoft)",
        "company.outbound_mail.description": "Choose which shared company mailbox Promang should send from (Microsoft 365). If none is selected or Microsoft is unavailable, mail is sent via Promang’s default email.",
        "company.outbound_mail.mailbox_label": "Send system mail from shared mailbox",
        "company.outbound_mail.promang_default": "Promang default (not Microsoft)",
        "company.outbound_mail.case_email_hint": "Case update emails to employees are sent from the user’s own Microsoft account when linked under user settings — not from this shared mailbox.",
        "company.userRoles.helpLabel.scope": "Includes:",
        "company.userRoles.helpLabel.admin": "Admins should consider:",
        "company.userRoles.sections.actions": "Actions",
        "company.userRoles.sections.submodules": "Sub-modules",
        "company.userRoles.accessIntro":
          "Role descriptions explain what access is granted and what to watch for when assigning permissions.",
        "company.users.page_title": "Users",
        "company.users.subtitle_selected": "{{count}} selected",
        "company.users.hero.kicker": "Company",
        "company.users.hero.title": "Users & access",
        "company.users.hero.subtitle":
          "Manage people, roles, invitations, and filters in one place — aligned with your dashboard overview.",
        "company.users.stats.total": "Total",
        "company.users.stats.on_page": "On this page",
        "company.users.stats.selected": "Selected",
        "company.users.section.kicker": "Directory",
        "company.users.section.title": "User list",
        "company.users.section.subtitle":
          "Search, refine with filters, and open a profile to edit details.",
        "company.users.section.meta_line": "{{total}} users · page {{page}}",
        "company.users.search_placeholder": "Search users…",
        "company.users.filters_heading": "Filters",
        "company.users.filters_description":
          "Search and narrow the list with the options below.",
        "company.users.filter_title": "Filter users",
        "company.users.filter.active": "Active users",
        "company.users.filter.employee": "Employees",
        "company.users.filter.show_in_dropdown": "Show in dropdown",
        "company.users.new_user": "New user",
        "company.users.calendar": "Calendar",
        "company.users.loading": "Loading users…",
        "company.users.table.status_inactive": "Inactive",
        "company.users.table.status_pending": "Pending",
        "company.users.table.status_active": "Active",
        "company.users.table.empty_title": "No users found",
        "company.users.table.empty_hint":
          "Try adjusting search or filters to see more results.",
        "company.users.table.row_kicker": "User",
        "company.users.table.unnamed": "Unnamed user",
        "company.users.table.calendar": "Calendar",
        "company.users.profile.read_only_title": "User information is read-only",
        "company.users.profile.read_only_multi_company":
          "This user is linked to several companies. Their profile (name, photo, contact details, etc.) can only be edited from their primary company to avoid conflicting changes. Switch to that company in the workspace, or set the correct primary company on the user.",
        "company.users.table.edit": "Edit",
        "company.users.table.settings": "Profile",
        "company.users.table.view": "Open",
        "company.users.table.selected_of_total":
          "{{selected}} of {{total}} selected",
        "company.users.table.user_count": "{{count}} users",
        "company.users.table.n_selected": "{{count}} selected",
        "company.users.invitation.expired":
          "This user has an expired invitation link.",
        "company.users.invitation.resend_button": "Send invitation again",
        "company.users.invitation.resending": "Sending invitation...",
        "company.users.invitation.resend_success":
          "Invitation resent successfully.",
        "company.users.invitation.resend_error":
          "Could not resend invitation.",
        "driving": "Driving (fleet)",
        "driving_trips": "Trips & checked-in vehicle",
        "driving_drivers": "Drivers",
        "driving_vehicles": "Vehicles (driving module)",
        "vehicles": "Vehicles",
        "Postal Address": "Postal Address",
        "Physical Address": "Physical Address",
        "Edit": "Edit",
        "Back": "Back",
        "Customer Number": "Customer Number",
        "Name": "Name",
        "Email": "Email",
        "pmField.email.invalid": "Enter a valid email address.",
        "pmField.email.sameAsName": "Email and name must not be the same. Use the name field for the name and the email field for the email.",
        "pmField.email.nameLooksLikeEmail": "This looks like an email address. Use the email field for email.",
        "Mobile": "Mobile",
        "Org. Nummer": "Org. Number",
        "Short Description": "Short Description",
        "Address": "Address",
        "Address 2": "Address 2",
        "Postal": "Postal",
        "Place": "Place",
        "Active": "Active",
        "Yes": "Yes",
        "No": "No",
        "Copied to clipboard": "Copied to clipboard",
        "Failed to copy": "Failed to copy",
        "Copy to clipboard": "Copy to clipboard",
        "our_contact": "Our Contact",
        "order.lines": "Order Lines",
        "report.create": "Create report",
        "report.update": "Update report",
        "report.type": "Report type",
        "report.date": "Report date",
        "report.description": "Report Description",
        "report.agreement.update": "Update Report Agreement",
        "report.agreement.new": "New Report Agreement",
        "report.agreement.modal_intro":
          "Fill in when the work is planned and whether the customer should receive a message.",
        "report.agreement.title": "Appointment agreement",
        "report.agreement.subtitle": "Schedule, executor, and customer notification",
        "report.agreement.setup_title": "No appointment saved yet",
        "report.agreement.setup_body": "Add date, time, who performs the work, and optionally send SMS or email to the customer.",
        "report.agreement.setup_cta": "Set up agreement",
        "report.agreement.section.schedule": "Schedule",
        "report.agreement.section.schedule_help":
          "Who performs the work, appointment date and time window.",
        "report.agreement.section.notify": "Customer notification",
        "report.agreement.section.notify_help":
          "Choose whether to send the agreement by SMS or email and who receives it.",
        "report.agreement.send_to_customer": "Send agreement to customer",
        "report.agreement.send_to_customer_hint_on": "SMS and/or email can be used when enabled below.",
        "report.agreement.send_to_customer_hint_off": "The appointment is saved in Promang only; the customer is not notified.",
        "report.agreement.executing_you": "You (logged-in user)",
        "report.agreement.select_executing": "Choose employee",
        "report.agreement.change_executing": "Change…",
        "report.agreement.confirm_hint_required":
          "The agreement is sent to the customer, who must confirm via SMS or email.",
        "report.agreement.confirm_hint_optional":
          "Appointment details are sent to the customer; no confirmation is required and the agreement is confirmed automatically.",
        "report.agreement.validation.date_required": "Date is required",
        "report.agreement.validation.executing_required": "Executing employee is required",
        "report.agreement.validation.phone_for_sms": "Phone number is required when SMS is enabled",
        "report.agreement.validation.email_for_email": "Valid email is required when email is enabled",
        "report.agreement.status.confirmed": "Agreement confirmed",
        "report.agreement.status.not_confirmed": "Agreement not confirmed",
        "report.agreement.status.sms_sent": "SMS sent",
        "report.agreement.status.sms_not_sent": "SMS not sent",
        "report.agreement.status.sms_confirmed": "Confirmed via SMS",
        "report.agreement.status.email_sent": "Email sent",
        "report.agreement.status.email_not_sent": "Email not sent",
        "report.agreement.status.none": "No agreement",
        "report.view.mobileNav.ariaLabel": "Quick links to report sections",
        "report.view.mobileNav.items": "Item consumption",
        "report.view.mobileNav.variables": "Variables",
        "report.view.mobileNav.checklist": "Checklist",
        "report.view.mobileNav.report": "Report",
        "report.view.mobileNav.timeRegistration": "Time tracking",
        "report.view.summary.customer": "Customer",
        "report.view.sectionReport.title": "Report",
        "report.view.sectionReport.description": "Write report content",
        "report.view.sectionReport.unit": "report",
        "report.view.sectionReport.statusFinished": "Done",
        "report.view.sectionReport.statusNotRequired": "Not required",
        "report.view.sectionReport.statusMissing": "Missing",
        "report.view.sectionGuide.title": "Guides",
        "report.view.sectionGuide.description": "Structured guides and completed runs for this report",
        "report.view.sectionGuide.unitRuns": "runs",
        "report.view.sectionGuide.statusNone": "Not started",
        "report.view.sectionGuide.statusHasRuns": "{{count}} completed",
        "report.view.guideHistory.title": "Guide history",
        "report.view.guideHistory.empty": "No guides have been completed on this report yet.",
        "report.view.guideHistory.startGuide": "Start guide",
        "report.view.guideHistory.close": "Close",
        "report.view.guideHistory.completedAt": "Completed",
        "report.view.guideHistory.by": "By",
        "report.view.guideHistory.unknownUser": "Unknown user",
        "report.view.guideHistory.answers": "Answers",
        "report.view.guideHistory.tagsApplied": "Tags applied ({{count}})",
        "report.view.mobileNav.guide": "Guide",
        "report.view.priceCalculated.title": "A price has been calculated for this job",
        "report.view.priceCalculated.subtitle": "The latest saved estimate shows what the customer should pay for the full job (fixed price + extras).",
        "report.view.priceCalculated.open": "Open calculator",
        "report.view.priceCalculated.exVat": "Ex. VAT",
        "report.view.priceCalculated.incVat": "Inc. VAT",
        "report.additional_work_calculator.sectionTitle": "Calculate additional work",
        "report.additional_work_calculator.sectionSubtitle": "Estimate extras beyond fixed price — simple view for the customer total",
        "report.additional_work_calculator.sectionBody": "Open the calculator to adjust hours, materials and a new visit. The headline shows what the customer pays with and without VAT.",
        "report.additional_work_calculator.open": "Open calculator",
        "report.additional_work_calculator.dialogTitle": "Estimate — what should the customer pay?",
        "report.additional_work_calculator.loading": "Loading price estimate…",
        "report.additional_work_calculator.heroLabel": "What the customer pays (full job)",
        "report.additional_work_calculator.exVat": "Excluding VAT",
        "report.additional_work_calculator.incVat": "Including VAT",
        "report.additional_work_calculator.exVatShort": "ex.",
        "report.additional_work_calculator.incVatShort": "inc.",
        "report.additional_work_calculator.extraHours": "Extra hours",
        "report.additional_work_calculator.hoursLabel": "Hours",
        "report.additional_work_calculator.newVisit": "New visit / travel",
        "report.additional_work_calculator.newVisitHelp": "Distance and rates follow the same basis as the price estimate (delivery address, etc.). You can use system km, custom km or a flat minimum charge.",
        "report.additional_work_calculator.includeVisit": "Include cost for a new visit",
        "report.additional_work_calculator.estimateKm": "Distance from estimate: {{km}} km (approx.)",
        "report.additional_work_calculator.estimateKmPrice": "Customer km rate: {{price}} /km ex. VAT",
        "report.additional_work_calculator.estimateMin": "Minimum travel charge: {{min}} — below that, flat rate {{fixed}} applies",
        "report.additional_work_calculator.underMinHint": "With system distance below the minimum, the flat rate is used in the calculation.",
        "report.additional_work_calculator.modeSystem": "Use system km",
        "report.additional_work_calculator.modeCustom": "Custom km",
        "report.additional_work_calculator.modeMinimum": "Minimum / flat rate only",
        "report.additional_work_calculator.customKm": "Kilometres",
        "report.additional_work_calculator.productsTitle": "Materials (non fixed-price lines)",
        "report.additional_work_calculator.noProducts": "No non–fixed-price lines are registered on this report.",
        "report.additional_work_calculator.lineHint": "Changes here affect only the calculator — not report lines.",
        "report.additional_work_calculator.qty": "Qty",
        "report.additional_work_calculator.unitPrice": "Unit price (ex.)",
        "report.additional_work_calculator.exclude": "Exclude from calculation",
        "report.additional_work_calculator.includeAgain": "Include again",
        "report.additional_work_calculator.detailsToggle": "More for your company (cost, margin, fixed price)",
        "report.additional_work_calculator.hourlyCustomer": "Customer hourly rate (ex.)",
        "report.additional_work_calculator.hourlyCustomerHelp": "Hourly rate charged to the customer. Default comes from the company hour product.",
        "report.additional_work_calculator.hourlyCost": "Cost hourly rate (ex.)",
        "report.additional_work_calculator.hourlyCostHelp": "Internal cost rate per hour.",
        "report.additional_work_calculator.fallbackHourly": "Default rate used — actual customer rate not found.",
        "report.additional_work_calculator.fallbackCost": "Default rate used — actual cost rate not found.",
        "report.additional_work_calculator.rowLaborCust": "Labour (customer)",
        "report.additional_work_calculator.rowLaborCost": "Labour (cost)",
        "report.additional_work_calculator.rowMaterialCust": "Materials (customer)",
        "report.additional_work_calculator.rowMaterialCost": "Materials (cost)",
        "report.additional_work_calculator.rowVisitCust": "Visit (customer)",
        "report.additional_work_calculator.rowVisitCost": "Visit (cost)",
        "report.additional_work_calculator.rowFixed": "Fixed-price lines (customer, ex.)",
        "report.additional_work_calculator.rowTotalCost": "Total company cost (ex.)",
        "report.additional_work_calculator.rowMargin": "Margin (ex.)",
        "report.additional_work_calculator.historyToggle": "Saved estimates ({{count}})",
        "report.additional_work_calculator.restore": "Restore",
        "report.additional_work_calculator.close": "Close",
        "report.additional_work_calculator.save": "Save estimate",
        "report.additional_work_calculator.saveAsNew": "Save as new estimate",
        "report.additional_work_calculator.saveOverwrite": "Overwrite latest",
        "report.additional_work_calculator.saveOverwriteHint":
          "Replaces the most recently saved estimate. Older history is kept.",
        "report.additional_work_calculator.newCalculation": "New estimate",
        "report.additional_work_calculator.newCalculationHint":
          "Resets the form from the report and price estimate (last save is not applied).",
        "report.additional_work_calculator.saving": "Saving…",
        "report.additional_work_calculator.toastSaved": "Estimate saved",
        "report.additional_work_calculator.toastSavedNew": "New estimate saved",
        "report.additional_work_calculator.toastSavedOverwrite": "Latest estimate updated",
        "report.additional_work_calculator.toastSaveError": "Could not save estimate",
        "report.additional_work_calculator.toastRestored": "Values from saved estimate loaded",
        "report.additional_work_calculator.addFromCatalog": "Add product",
        "report.additional_work_calculator.addManualLine": "Blank line",
        "report.additional_work_calculator.addProductsTitle": "Choose products for the estimate",
        "report.additional_work_calculator.addSelectedProducts": "Add to estimate",
        "report.additional_work_calculator.toastProductsAdded": "{{count}} product(s) added to the estimate",
        "report.additional_work_calculator.lineTitle": "Description / item",
        "report.additional_work_calculator.lineHintCustom": "Estimate only — does not create a report line.",
        "report.additional_work_calculator.unitCost": "Unit cost (ex. VAT)",
        "report.additional_work_calculator.removeLine": "Remove line",
        "report.additional_work_calculator.loadFromReport": "Load estimate from report",
        "report.additional_work_calculator.loadFromReportHint":
          "The list only shows reports with a saved price estimate. Pick a report — the latest saved estimate is applied. Lines from the source report are not linked to this report.",
        "report.additional_work_calculator.reportSelectorLabel": "Report with price estimate",
        "report.additional_work_calculator.selectorCalcSummary": "Latest saved: {{ex}} ex. VAT / {{inc}} inc. VAT",
        "report.additional_work_calculator.loadFromReportDialogTitle": "Load estimate from another report",
        "report.additional_work_calculator.loadFromReportBody":
          "Enter the report ID (same as in the URL or report card). Lines from that report are not linked here — they are only included in this estimate.",
        "report.additional_work_calculator.reportIdLabel": "Report ID",
        "report.additional_work_calculator.loadFromReportApply": "Load",
        "report.additional_work_calculator.loadFromReportCancel": "Cancel",
        "report.additional_work_calculator.loadFromReportLoading": "Loading…",
        "report.additional_work_calculator.loadFromReportIdRequired": "Enter a report ID",
        "report.additional_work_calculator.loadFromReportIdInvalid": "Invalid report ID",
        "report.additional_work_calculator.loadFromReportSame": "Choose a different report than this one",
        "report.additional_work_calculator.toastLoadedFromReport": "Estimate loaded from report {{number}}",
        "report.additional_work_calculator.toastNoCalculatorOnReport": "That report has no saved estimate",
        "report.additional_work_calculator.toastLoadReportError": "Could not load report or estimate",
        "report.additional_work_calculator.addToConsumption": "Add to consumption",
        "report.additional_work_calculator.addToConsumptionWorking": "Adding…",
        "report.additional_work_calculator.addToConsumptionHint":
          "Creates or updates a line on the report (same as consumption). Calculator prices are written to the line when they differ from defaults.",
        "report.additional_work_calculator.toastAddedToConsumption": "Added to consumption",
        "report.additional_work_calculator.toastAddToConsumptionNeedQty": "Enter a quantity greater than zero",
        "report.additional_work_calculator.toastAddToConsumptionNeedTitle": "Enter a description for a manual line",
        "report.additional_work_calculator.toastAddToConsumptionUnlinked":
          "The item was added, but the calculator could not link to the line automatically — refresh or adjust from consumption.",
        "report.additional_work_calculator.toastAddToConsumptionPriceSyncError":
          "Line created, but calculator prices could not be synced",
        "report.additional_work_calculator.toastAddToConsumptionError": "Could not add to consumption",
        "report.additional_work_calculator.discountLabel": "Discount — hours & travel",
        "report.additional_work_calculator.discountHint":
          "Amount ex. VAT deducted from extra hours and new visit/travel only (not materials or fixed-price lines). Cannot exceed the sum of those charges.",
        "report.additional_work_calculator.discountFieldLabel": "Hours/travel discount (ex. VAT)",
        "report.additional_work_calculator.lineDiscountLabel": "Line discount (ex.)",
        "report.additional_work_calculator.lineDiscountHint":
          "Discount ex. VAT on this material line. Cannot exceed the line amount (qty × unit price).",
        "report.additional_work_calculator.rowSubtotal": "Subtotal before discounts (ex.)",
        "report.additional_work_calculator.rowDiscount": "Discount (ex.)",
        "report.additional_work_calculator.rowDiscountMaterials": "Materials discount (ex.)",
        "report.additional_work_calculator.rowDiscountHoursVisit": "Hours/travel discount (ex.)",
        "report.additional_work_calculator.rowMaterialCustGross": "Materials before discount (customer, ex.)",
        "report.additional_work_calculator.detailsToggleCustomer": "Price details (customer, ex.)",
        "report.additional_work_calculator.rowTotalCustomerExVat": "Customer total (ex.)",
        "report.additional_work_calculator.excludeShort": "Exclude",
        "report.additional_work_calculator.includeShort": "Include",
        "report.additional_work_calculator.addToConsumptionShort": "Consumption",
        "report.additional_work_calculator.addPriceLines": "Add price line",
        "report.additional_work_calculator.addPriceLinesHint":
          "Creates one agreed price line titled agreed work incl. visit/travel: sum of extra hours and visit (excl. VAT, before hours/visit discount). Links the first project activity with an activity item when available. Edit under Price lines.",
        "report.additional_work_calculator.priceLineWorkIncludingVisitTitle":
          "Agreed work incl. visit/travel (calculator)",
        "report.additional_work_calculator.toastPriceLinesNothing":
          "Enter extra hours and/or enable a new visit with a charge greater than zero.",
        "report.additional_work_calculator.toastPriceLinesAdded": "Added {{count}} price line(s)",
        "report.additional_work_calculator.toastPriceLinesError": "Could not create price line",
        "report.sectionCard.viewOnlyHint": "View only (click to view)",
        "report.sectionCard.progress": "Progress",
        "report.sectionDialog.reportTitle": "Report content",
        "report.sectionDialog.reportDescription": "Write report content",
        "report.sectionDialog.reportContentLabel": "Report content",
        "report.sectionDialog.internalReportLabel": "Internal report",
        "report.sectionDialog.placeholderReport": "Write report content here…",
        "report.sectionDialog.placeholderInternal": "Write internal report here…",
        "report.sectionDialog.formatting": "Formatting…",
        "report.sectionDialog.formatWithAi": "Format with ChatGPT",
        "report.sectionDialog.autoSaveHint": "Changes are saved automatically.",
        "report.sectionDialog.saving": "Saving…",
        "report.sectionDialog.saved": "Saved",
        "report.sectionDialog.autoSaveError": "Could not save report text",
        "report.sectionDialog.close": "Close",
        "report.agreement.section.followup": "Follow-up messages",
        "report.agreement.section.followup_help":
          "Send a reminder, resend the agreement (SMS), or send an updated agreement after it is confirmed.",
        "report.agreement.section.manual_confirm": "Manually confirm agreement",
        "report.agreement.section.manual_confirm_help":
          "Use when the customer has already confirmed outside Promang. You will be asked to confirm before it is saved.",
        "report.agreement.section.cancel_agreement": "Cancel agreement",
        "report.agreement.section.cancel_agreement_help":
          "Choose a cancellation type or reason. “Assignment cancelled” ends the agreement with no stated cause and no message about rescheduling. SMS to the customer can be toggled below before you confirm.",
        "report.agreement.cancel_sms_hint":
          "If enabled, an SMS may be sent when the cancellation is submitted (depending on your setup).",
        "report.agreement.prompt.reminder_title": "Send confirmation reminder?",
        "report.agreement.prompt.reminder_body":
          "Make sure you have not already sent a reminder for this agreement.",
        "report.agreement.prompt.resend_title": "Resend agreement?",
        "report.agreement.prompt.resend_body":
          "Make sure you have not already sent a new message to the customer.",
        "report.agreement.prompt.updated_appointment_title":
          "Send updated agreement?",
        "report.agreement.prompt.updated_appointment_body":
          "The same date and time are sent as before; description and other details may have been updated.",
        "report.agreement.prompt.confirm_manual_title":
          "Register manual confirmation?",
        "report.agreement.prompt.confirm_manual_body":
          "This will mark the agreement as confirmed ({{method}}). Continue?",
        "report.agreement.prompt.cancel_agreement_title":
          "Cancel this agreement?",
        "report.agreement.prompt.cancel_agreement_body":
          "Reason: {{reason}}. This cancels the appointment agreement in Promang. Continue?",
        "report.agreement.edit": "Edit agreement",
        "report.agreement.time_range": "Time window",
        "report.variables.update": "Update Variables",
        "report.price_lines.title": "Price Lines",
        "report.price_lines.description": "Manage price lines and agreed prices",
        "report.price_lines.add": "Add Price Line",
        "report.price_lines.empty": "No price lines added",
        "report.price_lines.line": "Price Line",
        "report.price_lines.title_field": "Title",
        "report.price_lines.activity_item": "Activity",
        "report.price_lines.no_activity": "No activity",
        "report.price_lines.description_field": "Description",
        "report.price_lines.is_agreed_price": "Agreed Price Line",
        "report.price_lines.agreed_price": "Agreed Price",
        "report.price_lines.agreed_price_excl_vat": "Agreed Price (excl. VAT)",
        "report.price_lines.agreed_price_incl_vat": "Agreed Price (incl. VAT)",
        "report.price_lines.vat_type": "VAT Type",
        "report.price_lines.no_vat_type": "No VAT Type",
        "report.price_lines.select_vat_type": "Select VAT Type",
        "report.price_lines.select_vat_type_description": "Select a VAT type for this price line",
        "report.price_lines.search_vat_types": "Search VAT types...",
        "report.price_lines.no_vat_types_found": "No VAT types found",
        "report.price_lines.no_vat_types_available": "No VAT types available",
        "report.price_lines.select_activity": "Select Activity",
        "report.price_lines.project_activity": "Project activity",
        "report.price_lines.select_project_activity": "Select project activity",
        "report.price_lines.select_project_first": "Select a project first",
        "report.price_lines.remove_activity": "Remove Activity",
        "report.price_lines.agreed_hours": "Agreed Hours",
        "project_activity.label": "Project activity",
        "project_activity.select": "Select project activity",
        "project_activity.dialog_title": "Select project activity",
        "project_activity.search_placeholder": "Search project activities…",
        "project_activity.empty": "No project activities found",
        "project_activity.select_project_first": "Select a project first",
        "project_activity.load_error": "Could not load project activities",
        "project_activity.clear_selection": "Clear selection",
        "project_activity.none": "No project activity",
        "project_activity.missing": "No project line",
        "hours.period_table.project_and_line": "Project / project line",
        "Loading": "Loading",
        "hours.registration_warning.title": "Warning: Hours Exceed Estimated",
        "hours.registration_warning.message": "You are about to register {newHours} hours on activity \"{activityTitle}\". This will bring the total registered hours to {totalAfterRegistration} hours, which exceeds the estimated {estimatedHours} hours. Currently registered: {registeredHours} hours.",
        "hours.registration_warning.question": "Are you sure you want to register these hours on this activity?",
        "hours.registration_warning.confirm": "Yes, I'm sure",
        "hours.registration_warning.cancel": "No, correct",
        "hours.registration_warning.this_activity": "this activity",
        "hours.form_tab_details": "Details",
        "hours.approved_edit_notice_title": "Approved hour",
        "hours.approved_edit_notice_body":
          "This hour is approved. You can still edit it as a company administrator; approval status is kept. Payroll or Tripletex may need a manual check after changes.",
        "hours.bulk_reassign.project_field": "Project",
        "hours.bulk_reassign.title": "Move hours to another project / activity",
        "hours.bulk_reassign.intro": "You are editing {{count}} hour(s). Pick the target project, then the project activity line.",
        "hours.bulk_reassign.project_required": "Project is required",
        "hours.bulk_reassign.activity_required": "Project activity is required",
        "hours.bulk_reassign.submit": "Apply to selected hours",
        "hours.bulk_reassign.saving": "Saving…",
        "hours.bulk_reassign.success": "Updated {{count}} hour(s).",
        "hours.bulk_reassign.partial": "Updated {{updated}}; {{failed}} failed — see details in the list.",
        "hours.bulk_reassign.error": "Could not move hours",
        "hours.bulk_reassign.open": "Move selected…",
        "hours.approval.filter_project": "Project",
        "hours.approval.all_projects": "All projects",
        "hours.approval.clear_project_filter": "Clear project",
        "hours.approval.selection_summary.title": "Selection summary",
        "hours.approval.selection_summary.subtitle":
          "\"Registered\" and period totals come from the loaded list for the selected date range and filters (same rows as the table).",
        "hours.approval.selection_summary.total_selected": "Selected: {{hours}} h · {{entries}} entries",
        "hours.approval.selection_summary.period_totals": "In period (loaded): {{hours}} h · {{entries}} entries",
        "hours.approval.selection_summary.by_date": "By date",
        "hours.approval.selection_summary.day_row": "{{date}}: {{selected}} h selected of {{registered}} h registered",
        "hours.approval.selection_summary.other_days": "Other days with registrations: {{days}} days · {{hours}} h",
        "hours.approval.selection_summary.clear": "Clear selection",
        "hours.approval.selection_summary.unknown_user": "Unknown user",
        "hours.approval.bulk_unapprove.action": "Revoke approval for selected",
        "hours.approval.bulk_unapprove.no_approved": "None of the selected hours are approved — nothing to revoke.",
        "hours.approval.bulk_unapprove.success": "Approval revoked for {{count}} hour(s).",
        "hours.approval.bulk_unapprove.error": "Could not revoke approval for all selected hours",
        "hours.approval.bulk_unapprove.process_note": "Bulk approval revoked",
        "project.time_registration.bulk_reassign": "Move selected hours…",
        "project.time_registration.select_hour": "Select hour for bulk move",
        "hours.sheet.add_hour": "Add hour",
        "hours.sheet.edit_hour": "Edit hour",
        "hours.sheet.new_hour": "New hour",
        "hours.sheet.stats_title": "Summary",
        "hours.sheet.stats_selected_period": "Selected period (list)",
        "hours.sheet.stats_calendar_month": "Calendar month",
        "hours.sheet.stats_weeks_heading": "Weeks",
        "hours.sheet.stats_this_week": "This week",
        "hours.sheet.stats_prev_week": "Previous week",
        "hours.sheet.stats_normal_suffix": "normal (schedule)",
        "hours.sheet.stats_no_schedule": "No work schedule is linked to this employment — normal hours and percentages are not shown.",
        "hours.sheet.stats_loading_extra": "Loading month and week totals…",
        "report.price_lines.updated": "Price line updated successfully",
        "report.price_lines.created": "Price line created successfully",
        "report.price_lines.deleted": "Price line deleted successfully",
        "report.price_lines.save_error": "Failed to save price line",
        "report.price_lines.delete_error": "Failed to delete price line",
        "report.price_lines.edit": "Edit Price Line",
        "report.copy.price_lines_option": "Price lines",
        "report.copy.variables_option": "Variables",
        "report.sequel.copy_variables_switch": "Copy from main report",
        "report.sequel.copy_variables_hint_on":
          "Variables will be copied from the main report, including groups, type groups, values, and measurements.",
        "report.sequel.copy_variables_hint_off": "No variables will be copied.",
        "report.sequel.copy_variables_none_available":
          "No variable rows or groups on the main report — nothing to copy.",
        "report.sequel.copy_price_lines_switch": "Copy from main report",
        "report.sequel.copy_price_lines_hint_on":
          "Price lines will be copied from the main report ({{count}} lines).",
        "report.sequel.copy_price_lines_hint_off": "No price lines will be copied.",
        "report.sequel.copy_price_lines_none_available": "No price lines on the main report.",
        "report.price_lines.updating": "Updating...",
        "report.price_lines.adding": "Adding...",
        "report.price_lines.delete_confirm": "Are you sure you want to delete this price line?",
        "report.price_lines.delete": "Delete Price Line",
        "report.price_lines.error_loading": "Error Loading Price Lines",
        "report.price_lines.add_first": "Add First Price Line",
        "report.price_lines.title_required": "Title is required",
        "report.price_lines.validation.agreed_price_or_hours":
            "Enter an agreed price (excl. or incl. VAT) or agreed hours, or turn off «Agreed price line».",
        "report.price_lines.server_errors_title": "Could not save — check the messages below",
        "report.price_lines.field_errors_hint": "Fields with problems are highlighted.",
        "report.details.description": "Basic report information",
        "report.items.description": "Manage items and consumption",
        "report.activities.description": "Manage activities and hours",
        "report.checklist.description": "Complete checklist items",
        "report.checklist.loading": "Loading checklist…",
        "report.checklist.load_error": "Could not load checklist",
        "report.checklist.load_error_title": "Checklist could not be loaded",
        "report.checklist.load_error_hint":
          "Go to another step and back, or close and reopen the dialog. If the problem continues, try again later.",
        "quality.checklist.view.completionTitle": "Checklist completion",
        "quality.checklist.view.completionDescription":
          "When all lines are approved or marked as a deviation, you can finalize the checklist. Unsaved changes are saved when you continue.",
        "quality.checklist.view.completionButton": "Finalize checklist",
        "quality.checklist.view.completionSaving": "Saving…",
        "quality.checklist.view.completionDoneTitle": "Checklist finalized",
        "quality.checklist.view.completionDoneDescription":
          "This checklist is marked as finished.",
        "quality.checklist.type.titleLabel": "Title",
        "quality.checklist.type.activeLabel": "Active",
        "quality.checklist.type.introLabel": "Introduction for this checklist type",
        "quality.checklist.type.defaultActions": "Available responses",
        "quality.checklist.type.defaultActionsHint":
          "Choose which outcome buttons should appear on checklist lines. Points can narrow this list further.",
        "quality.checklist.type.pointsHeading": "Checklist points",
        "quality.checklist.type.pointsSubheading":
          "Add titles, customer-facing guidance, and which response buttons apply to each point.",
        "quality.checklist.type.documentsRequired": "Documents required",
        "quality.checklist.type.pointLabel": "Point {{n}}",
        "quality.checklist.type.pointTitle": "Point title",
        "quality.checklist.type.guidanceLabel": "Customer guidance",
        "quality.checklist.type.guidanceHint":
          "Shown to the person filling the checklist so they understand what to verify. Freetext answers are captured separately per line.",
        "quality.checklist.type.pointActions": "Responses for this point",
        "quality.checklist.type.pointActionsHint":
          "Turn off responses that should not appear for only this point. Defaults follow the checklist type.",
        "quality.checklist.type.addRow": "Add point",
        "quality.checklist.type.deleteRowConfirm": "Delete this point?",
        "quality.checklist.type.customFieldsTitle": "Custom fields",
        "quality.checklist.type.customFieldsHint":
            "Add input fields the technician must fill in when executing this point (e.g. measured current, recovery rate).",
        "quality.checklist.type.customFieldLabel": "Label",
        "quality.checklist.type.customFieldType": "Type",
        "quality.checklist.type.customFieldUnit": "Unit",
        "quality.checklist.type.customFieldPlaceholder": "Placeholder",
        "quality.checklist.type.customFieldRequired": "Required",
        "quality.checklist.type.customFieldAdd": "Add field",
        "quality.checklist.type.customFieldTypes.text": "Text",
        "quality.checklist.type.customFieldTypes.number": "Number",
        "quality.checklist.type.customFieldTypes.textarea": "Long text",
        "quality.checklist.actions.performed": "Performed",
        "quality.checklist.actions.approved": "Approved",
        "quality.checklist.actions.na": "Not applicable",
        "quality.checklist.actions.deviation": "Deviation",
        "quality.checklist.item.title": "Title",
        "quality.checklist.item.guidanceTitle": "Guidance",
        "quality.checklist.item.completionNote": "Notes / what was observed",
        "quality.checklist.item.deviationNoteRequired": "Add a short explanation for the deviation.",
        "quality.checklist.item.responseLabel": "Outcome",
        "quality.checklist.item.customFieldsTitle": "Measurements / data",
        "quality.checklist.item.customFieldRequired": "This field is required",
        "quality.checklist.item.customFieldsRequiredBeforeOutcome":
            "Fill in required fields before selecting an outcome.",
        "report.type.required": "Report type is required",
  
        // Report admin menu
        "report.admin.title": "Admin",
        "report.admin.status": "Report status",
        "report.admin.status_desc": "Under process, processed, invoiced",
        "report.admin.reset": "Reset",
        "report.admin.reset_desc": "Reset report modules",
        "report.admin.view_main_report": "View main report",
        "report.admin.view_sequel": "Go to follow-up",
        "report.admin.view_case": "View case",
        "report.admin.create_case": "Create case",
        "report.admin.create_case_desc": "Create or link case for report follow-up",
        "report.admin.case_dialog_title": "Report follow-up",
        "report.admin.create_sequel": "Create follow-up",
        "report.admin.create_sequel_desc": "Create new report as follow-up",
        "report.admin.create_order": "Create order",
        "report.admin.create_order_desc": "Create an order from this report (hours, mileage, lines)",
        "report.admin.open_mentions": "Open case where report is mentioned",
        "report.admin.open_mentions_desc": "View cases and notes that mention this report",
        "report.admin.mentions_dialog_title": "Report mentioned in",
        "report.admin.mentioned_at": "Mentioned",
        "report.admin.no_mentions": "Report is not mentioned elsewhere",

        "report.dev.title": "Dev",
        "report.dev.variables_v2": "Variables V2",
        "report.dev.variables_v2_desc": "Edit report variables (grouped editor)",

        "report.variables.legacy.headingOnly": "Variables",
        "report.variables.legacy.headingTagged": "Variables (legacy)",
        "report.variables.legacy.saving": "Saving…",
        "report.variables.legacy.save": "Save variables",
        "report.variables.orphaned.title": "Incomplete main variables",
        "report.variables.orphaned.body":
          "These are flagged as main variables but lack a type group. Link them to a type group or delete them.",
        "report.variables.ungrouped.heading": "Variables without a group",
        "report.variables.groups.heading": "Groups",
        "report.variables.newSystem.title": "Variables",
        "report.variables.createTypeGroup": "Create type group",
        "report.variables.createGroup": "Create group",
        "report.variables.sketch.tablist": "Variables (sketch)",
        "report.variables.sketch.groupTablist": "Groups and overview",
        "report.variables.sketch.navGroupLabel": "Group",
        "report.variables.sketch.navVariableTypeLabel": "Variable type",
        "report.variables.sketch.typeTablist": "Variable types",
        "report.variables.sketch.noTypesInGroup": "No variable types here yet.",
        "report.variables.sketch.ungroupedTab": "Ungrouped",
        "report.variables.sketch.ungroupedTabSub": "{{count}} variable types",
        "report.variables.sketch.pickVariableType": "Select a variable type in the tab row above.",
        "report.variables.sketch.addGroup": "Add group",
        "report.variables.sketch.groupNoTypes": "No type groups",
        "report.variables.sketch.unitsNotSet": "Measurement unit not set",
        "report.variables.sketch.untitledGroup": "Untitled",
        "report.variables.sketch.measureLabel": "Meas.",
        "report.variables.sketch.projectedShort": "Proj.",
        "report.variables.sketch.variableTypeFallback": "Variable type",
        "report.variables.sketch.tabOrphaned": "Incomplete",
        "report.variables.sketch.tabOrphanedSub": "{{count}} main variables",
        "report.variables.sketch.tabLegacySub": "Legacy format",
        "report.variables.sketchTab.legacy": "Legacy",
        "report.variables.sketch.emptyAll":
          "No groups or ungrouped variable types yet. Use the buttons above to create.",
        "report.variables.sketch.groupTabEmpty":
          "No type groups in this tab yet. Add a main variable.",
        "report.variables.sketch.editGroup": "Edit group",
        "report.variables.sketch.addMainVariable": "Main variable",
        "report.variables.sketch.addAnotherMainVariable": "Add another main variable to this group",
        "report.variables.sketch.typeGroupUngrouped": "Type group (ungrouped)",
        "report.variables.sketch.deleteGroupAria": "Delete group",
        "report.variables.sketch.structureMenuTrigger": "Group & structure",
        "report.variables.sketch.structureMenuAria": "Group and structure — more actions",
        "report.variables.sketch.deleteGroupMenu": "Delete group",
        "report.variables.sketch.addVariable": "Add variable",
        "report.variables.sketch.addBulkVariables": "Bulk add variables",
        "report.variables.sketch.editTypeGroupAria": "Edit variable type",
        "report.variables.sketch.deleteTypeGroupAria": "Delete variable type",
        "report.variables.sketch.typeGroupMoreAria": "More actions for this variable type",
        "report.variables.sketch.editTypeGroupMenu": "Edit variable type",
        "report.variables.sketch.deleteTypeGroupMenu": "Delete variable type",
        "report.variables.sketch.measurements": "Measurements",
        "report.variables.sketch.editVariable": "Edit",
        "report.variables.sketch.editVariableAria": "Edit variable",
        "report.variables.sketch.deleteVariable": "Delete",
        "report.variables.sketch.deleteVariableAria": "Delete variable",
        "report.variables.sketch.variableRowMenuAria": "Variable actions",
        "report.variables.sketch.noSubvariablesYet": "No variables yet",
        "report.variables.sketch.actionSheetClose": "Close",
        "report.variables.sketch.openVariableActionsAria": "Show actions for variable",
        "report.variables.sketch.variableActionsTitle": "Variable",
        "report.variables.sketch.variableActionsHint": "Choose an action below.",
        "report.variables.sketch.rowProjected": "Projected:",
        "report.variables.sketch.rowPreMeasurement": "Pre-measurement:",
        "report.variables.sketch.rowMeasured": "Measured:",
        "report.variables.sketch.globalTotalsHeading": "Total per variable type (all groups)",
        "report.variables.sketch.globalStatTotalLabel": "Total",
        "report.variables.sketch.globalSumProjected": "Proj. (total)",
        "report.variables.sketch.globalSumPre": "Pre (total)",
        "report.variables.sketch.globalSumMeasured": "Measured (total)",
        "report.variables.sketch.tabSumProjected": "Σ Proj.",
        "report.variables.sketch.tabSumPre": "Σ Pre",
        "report.variables.sketch.tabSumMeasured": "Σ Meas.",
        "report.variables.sketch.cardTotalPrefix": "TOTAL",
        "report.variables.sketch.totalsProjRow": "Proj. total",
        "report.variables.sketch.totalsPreRow": "Pre total",
        "report.variables.sketch.totalsMeasRow": "Measured total",
        "report.variables.sketch.newGroup": "New group",
        "report.variables.sketch.typeGroupShort": "Type group",
        "report.variables.sketch.tableColVariable": "Variable",
        "report.variables.sketch.tableColProj": "Proj.",
        "report.variables.sketch.tableColPre": "Pre",
        "report.variables.sketch.tableColMeas": "Meas.",
        "report.variables.sketch.tableColLsSuffix": "(l/s)",
        "report.variables.sketch.bulkAddShort": "Bulk-add",
        "report.variables.sketch.fabNoType": "Create a type group before adding variables.",
        "report.variables.sketch.statusMeasuredOnly": "Measured",
        "report.variables.sketch.statusGood": "Good",
        "report.variables.sketch.statusCheck": "Check",
        "report.variables.sketchEditor.statusMeasured": "Measured",
        "report.variables.sketchEditor.statusGood": "Good match",
        "report.variables.sketchEditor.statusGoodSub": "Measured value is within an acceptable range",
        "report.variables.sketchEditor.statusCheck": "Check deviation",
        "report.variables.sketchEditor.statusCheckSub": "Measured differs more than 15% from projected",
        "report.variables.sketchEditor.refRequired": "Reference is required",
        "report.variables.sketchEditor.saveError": "Could not save",
        "report.variables.sketchEditor.measureError": "Could not save measurement",
        "report.variables.sketchEditor.saved": "Saved",
        "report.variables.sketchEditor.noGroup": "Ungrouped",
        "report.variables.sketchEditor.measuredActual": "Measured (actual)",
        "report.variables.sketchEditor.cancel": "Cancel",
        "report.variables.sketchEditor.saving": "Saving…",
        "report.variables.sketchEditor.saveChanges": "Save changes",
        "report.variables.sketchEditor.deleteSubvariable": "Delete sub-variable",
        "report.variables.sketchEditor.deleteSubvariableHint":
          "This only removes this sub-variable. The main variable and type group stay.",
        "report.variables.sketchEditor.deleteSubvariableConfirm":
          "Delete sub-variable «{{reference}}»? Measurements and values are permanently removed.",
        "report.variables.sketchEditor.subvariableDeleted": "Sub-variable deleted",
        "report.variables.sketchEditor.subvariableDeleteError": "Could not delete variable",
        "report.variables.sketchEditor.deleteSubvariableCancel": "Cancel",
        "report.variables.sketchEditor.deleteSubvariableWorking": "Deleting…",
        "report.variables.sketchEditor.deleteSubvariableConfirmAction": "Delete permanently",
        "report.variables.sketchEditor.measuredHint":
          "Updates the latest measurement on save. Use “Add measurement” below to register additional readings.",
        "report.variables.sketchEditor.addMeasurementHeading": "Add new measurement",
        "report.variables.sketchEditor.addMeasurementValue": "Measurement value",
        "report.variables.sketchEditor.addMeasurementButton": "Add",
        "report.variables.sketchEditor.addingMeasurement": "Adding…",
        "report.variables.sketchEditor.measurementAdded": "Measurement added",
        "report.variables.sketchEditor.measurementInvalid": "Enter a valid measurement value",
        "report.variables.sketchEditor.historyHeading": "Measurement history ({{count}})",
        "report.variables.sketchEditor.historyLoading": "Loading measurements…",
        "report.variables.sketchEditor.historyEmpty": "No measurements recorded",
        "report.variables.sketchEditor.historyLoadError": "Could not load measurements",
        "report.variables.sketchEditor.historyColValue": "Value",
        "report.variables.sketchEditor.historyColDate": "Date/time",
        "report.variables.sketchEditor.tabMeasurements": "Measurements",
        "report.variables.sketchEditor.tabDetails": "Values",
        "report.variables.sketchEditor.tabsAria": "Variable editor sections",
        "report.variables.sketchEditor.measurementsIntro": "Add a reading or browse history.",
        "report.variables.sketchEditor.detailsIntro": "Reference and fields saved together.",
        "report.variables.sketchEditor.goToDetails": "Edit reference and other values →",
        "report.variables.sketchEditor.close": "Close",
        "report.variables.sketchEditor.addMeasurementPlaceholder": "Value",
        "report.variables.sketchEditor.measuredHintDetails":
          "Updates the latest reading if you save a new value here. Add new measurement points on the Measurements tab.",
        "report.variables.measurementDialog.title": "Measurements",
        "report.variables.measurementDialog.variableFallback": "Variable",
        "report.variables.measurementDialog.contextHeading": "Basis",
        "report.variables.measurementDialog.reference": "Reference",
        "report.variables.measurementDialog.measurementUnit": "Measurement unit",
        "report.variables.measurementDialog.projectedUnit": "Projected unit",
        "report.variables.measurementDialog.projectedLabel": "Projected",
        "report.variables.measurementDialog.preMeasurementLabel": "Pre-measurement",
        "report.variables.measurementDialog.latestHeading": "Latest measurement",

        "project": "Project",
        "project_plan": "Project plan",
        "projects_plan": "Project plan",
        "projects_accounting": "Project accounting",
        "project.details": "Project Details",
        "project.edit": "Edit Project",
        "project.item_list": "Item List",
        "project.item_list.create": "Create item list",
        "project.item_list.edit": "Edit item list",
        "project.item_list.delete": "Delete item list",
        "project.item_list.type": "Item list type",
        "project.item_list.type.consumption": "Consumption",
        "project.item_list.type.return": "Return",
        "project.item_list.warehouse": "Warehouse",
        "project.item_list.select_warehouse": "Select warehouse",
        "project.item_list.save": "Save item list",
        "project.item_list.deliver": "Deliver item list",

        "project.billing_plan": "Billing plan",
        "project.billing_plan.overview": "Delivered / executed overview",
        "project.billing_plan.create_invoice": "Create A‑account invoice line",
        "project.billing_plan.final_invoice": "Final invoice",
        "project.billing_plan.progress": "Progress",
        "project.billing_plan.completed": "Executed",
        "project.billing_plan.remaining": "Retention",
        "project.billing_plan.contract_sum": "Contract sum",
        "project.billing_plan.completed_amount": "Executed amount",
        "project.billing_plan.billed_amount": "Invoiced amount",
        "project.billing_plan.remaining_amount": "Retention held",
        "project.billing_plan.completed_sum": "Executed amount",
        "project.billing_plan.billable_sum": "Billable amount",
        "project.billing_plan.items.title": "Billing plan",
        "project.billing_plan.items.empty": "No billing plan rows yet",
        "project.billing_plan.type": "Type",
        "project.billing_plan.planned_date": "Planned date",
        "project.billing_plan.amount": "Amount",
        "project.billing_plan.status.title": "Status",
        "project.billing_plan.status.planned": "Planned",
        "project.billing_plan.status.billed": "Invoiced",
        "project.billing_plan.status.cancelled": "Cancelled",
        "project.billing_plan.actions": "Actions",
        "project.billing_plan.edit": "Edit",
        "project.billing_plan.delete": "Delete",
        "project.billing_plan.edit_item": "Edit billing row",
        "project.billing_plan.no_description": "No description",
        "project.billing_plan.deleting": "Deleting billing row…",
        "project.billing_plan.updating": "Updating billing row…",
        "project.billing_plan.creating": "Creating billing row…",
        "project.billing_plan.delete_confirmation": "Delete this billing plan row?",
        "project.billing_plan.invoice_selected": "Invoice selected",
        "project.billing_plan.invoicing": "Invoicing…",
        "project.billing_plan.a_account": "A‑account",
        "project.billing_plan.invoice_number": "Invoice no.",
        "project.billing_plan.settings": "Settings",
        "project.billing_plan.remaining_settings_title": "Retention settings",
        "project.billing_plan.amount_to_invoice": "Amount to invoice",
        "project.billing_plan.amount_to_invoice_hint": "Suggestion: executed for this billing row or period minus retention when enabled on the project. Same as executed when retention is off. Earlier invoices do not affect the amount. Updated automatically.",
        "project.billing_plan.retention_helper_disabled": "Retention is 0 when project retention settings are disabled.",
        "project.billing_plan.retention_helper_enabled": "Retention is {{pct}}% of {{base}}.",
        "project.billing_plan.retention_base_contract": "contract sum",
        "project.billing_plan.retention_base_completed": "executed amount",
        "project.billing_plan.completed_helper": "Executed for this period or billing row (draft). Contract-line total shown for reference only: {{suggested}}.",
        "project.billing_plan.footer_suggested_line": "Suggested amount to invoice: {{amount}}. With retention enabled: {{pct}}% of {{base}}. Earlier invoices do not reduce the suggestion.",
        "project.billing_plan.summary_title": "Amount summary",
        "project.billing_plan.summary_contract_lines_completed": "Contract lines total (reference only)",
        "project.billing_plan.summary_billed_to_date": "Invoiced via plan to date",
        "project.billing_plan.summary_retention_for_period": "Retention (preview for entered executed amount)",
        "project.billing_plan.invoice_edit_hint": "Change amounts in the billing plan before invoicing.",
        "project.billing_plan.invoice_type_label": "Invoicing type",
        "project.billing_plan.invoice_auto": "Automatic (create invoice and order for sync)",
        "project.billing_plan.invoice_manual": "Manual / external invoicing",
        "project.billing_plan.external_invoice_checkbox": "External invoice (issued outside Promang)",
        "project.billing_plan.link_invoice": "Link existing invoice (optional)",
        "project.billing_plan.link_invoice_none": "No link",
        "project.billing_plan.invoice_a_account_title": "Invoice A‑account",
        "project.billing_plan.invoice_confirm": "Invoice",
        "project.billing_plan.invoice_loading": "Invoicing…",
        "project.billing_plan.invoice_created": "Invoice created",
        "project.billing_plan.invoice_created_tripletex_ok": "Invoice created and order confirmed in Tripletex.",
        "project.billing_plan.tripletex_queued_hint": "Tripletex session unavailable — the order was queued for sync (check integration and background jobs if something is missing).",
        "project.billing_plan.invoice_failed": "Could not create invoice",

        "project.summary": "Project summary",
        "project.summary.overview": "Accounting overview",
        "project.summary.labor_costs": "Labour cost",
        "project.summary.material_costs": "Materials / consumption",
        "project.summary.invoiced_amount": "Invoiced amount",
        "project.summary.supplier_invoices": "Supplier invoices",
        "project.summary.total_costs": "Total costs",
        "project.summary.profit": "Operating result",
        "project.summary.margin": "Margin",
        "project.summary.provisional_result": "Provisional result",
        "project.summary.module_breakdown": "Module breakdown",
        "project.summary.module_breakdown_description": "Modules affecting this project summary",
        "project.summary.module_type.report": "Report",
        "project.summary.module_type.work_order": "Work order",
        "project.summary.module_type.item_list": "Item list",
        "project.summary.invoiced": "Invoiced",
        "project.summary.has_order": "Has order",
        "project.summary.costs": "Costs",
        "project.summary.income": "Income",
        "project.summary.hours": "Hours",
        "project.summary.hours_short": "h",
        "project.summary.material": "Materials",
        "project.summary.agreed_price": "Agreed price",
        "project.summary.price_lines": "price lines",
        "project.summary.expected_module_income": "Expected income from modules",
        "project.summary.expected_module_costs": "Expected module costs",
        "project.summary.invoiced_ex_vat_basis": "invoiced (ex. VAT)",
        "project.summary.margin_on_invoiced_hint": "Based on invoiced ex. VAT",
        "project.summary.of": "of",
        "project.summary.invoicing_rate": "Invoicing rate",
        "project.summary.cost_rate": "Cost ratio",
        "project.summary.invoicing_rate_no_contract": "Not defined without contract sum",
        "project.summary.cost_rate_on_invoiced_hint": "vs invoiced ex. VAT",
        "project.summary.contract_sum": "Contract sum",
        "project.summary.remaining": "Remaining",
        "project.summary.cost_breakdown": "Cost breakdown",
        "project.summary.no_costs": "No costs recorded yet",
        "project.summary.last_updated": "Last updated",
        "project.summary.export_pdf": "Export PDF",
        "project.summary.error.title": "Could not load summary",
        "project.summary.no_data.title": "No data",
        "project.summary.no_data.description": "Summary will appear when data exists",

        "project.invoices": "Invoices",
        "project.invoices.overview": "Invoice overview",
        "project.invoices.create": "Create invoice",
        "project.invoices.status": "Status",
        "project.invoices.status.paid": "Paid",
        "project.invoices.status.pending": "Outstanding",
        "project.invoices.status.overdue": "Overdue",
        "project.invoices.amount": "Amount",
        "project.invoices.due_date": "Due date",
        "project.invoices.totals.invoiced_ex_vat": "Total invoiced (ex. VAT)",
        "project.invoices.pagination.showing": "Showing {{from}}–{{to}} of {{total}}",
        "project.invoices.pagination.load_more": "Load more invoices",
        "project.invoices.pagination.loading_more": "Loading…",
        "project.invoices.pagination.loaded_of_total": "{{loaded}} of {{total}} invoices shown",
        "project.invoices.pagination.all_loaded": "All {{total}} invoices loaded",
        "project.invoices.create_disabled_hint": "Creating invoices from here is not available yet",
        "project.invoices.pagination.prev": "Previous",
        "project.invoices.pagination.next": "Next",
        "project.invoices.error.title": "Could not load",
        "project.invoices.no_invoices.title": "No invoices",
        "project.invoices.no_invoices.description": "No invoices for this project yet",

        "project.item_list.approve": "Approve item list",
        "project.item_list.reject": "Reject item list",
        "project.item_list.submit_for_approval": "Submit for approval",
        "project.item_list.status": "Status",
        "project.item_list.status.label": "Status",
        "project.item_list.status.draft": "Draft",
        "project.item_list.status.pending_approval": "Pending approval",
        "project.item_list.status.delivered": "Delivered",
        "project.item_list.status.approved": "Approved",
        "project.item_list.status.rejected": "Rejected",
        "project.item_list.status.invoiced_manually": "Invoiced (manual)",
        "project.item_list.mark_invoiced_manually": "Mark as manually invoiced",
        "project.item_list.print": "Print",
        "project.item_list.total_purchase": "Total purchase",
        "project.item_list.merge.select": "Select",
        "project.item_list.merge.select_list": "Select list {{title}}",
        "project.item_list.merge.select_all_eligible": "Select all",
        "project.item_list.merge.deselect_all": "Clear selection",
        "project.item_list.merge.create_order": "Create order from lists",
        "project.item_list.merge.dialog_title": "Create order from item lists",
        "project.item_list.merge.dialog_hint": "{{count}} list(s) selected. Choose how lines are built and optional price adjustments.",
        "project.item_list.merge.mode_label": "Line structure",
        "project.item_list.merge.mode.grouped_by_list": "One group per list (list name = group), all product lines",
        "project.item_list.merge.mode.one_line_per_list": "One aggregated line per list (weighted unit prices)",
        "project.item_list.merge.mode.flat_by_product": "Single list: one line per product (quantities summed)",
        "project.item_list.merge.purchase_markup": "Purchase + %",
        "project.item_list.merge.sales_discount": "Sales discount %",
        "project.item_list.merge.sales_surcharge": "Sales surcharge %",
        "project.item_list.merge.mark_invoiced_after": "Mark selected lists as manually invoiced after creating the order",
        "project.item_list.merge.submit": "Create order",
        "project.item_list.merge.submitting": "Creating order…",
        "project.item_list.merge.error_generic": "Could not create order. Check permissions and that lists contain items.",
        "project.item_list.add_product": "Add product",
        "project.item_list.products": "Items",
        "project.item_list.product": "Product",
        "project.item_list.quantity": "Quantity",
        "project.item_list.price": "Price",
        "project.item_list.total": "Total",
        "project.item_list.actions": "Actions",
        "project.item_list.remove": "Remove",
        "project.item_list.no_items": "No items",
        "project.item_list.no_items_description": "This item list has no items yet.",
        "project.item_list.scan_qr": "Scan QR code",
        "project.item_list.manual_search": "Manual search",
        "project.item_list.scan_or_enter": "Scan QR code or enter product number",
        "project.item_list.selected_product": "Selected product",
        "project.item_list.add": "Add",
        "project.item_list.back": "Back",
        "project.item_list.cancel": "Cancel",
        "project.item_list.created_by": "Created by",
        "project.website_settings": "Website Settings",
        "project.show_on_website": "Show project on website",
        "project.show_on_website_description": "Enable to show the project publicly on the website",
        "project.public_title": "Visible Title",
        "project.public_title_placeholder": "Title shown on the website",
        "project.public_description": "Visible Description",
        "project.public_description_placeholder": "Description shown on the website",
        "project.public_contract_sum": "Public Contract Sum",
        "project.public_contract_sum_placeholder": "E.g. 2 500 000 NOK",
        "project.public_contract_sum_description": "Contract sum shown publicly on the website",
        "project.public_main_image": "Public Main Image",
        "project.public_main_image_description": "Image shown on the website",
        "project.select_image": "Select Image",
        "project.change_image": "Change Image",
        "project.search_images": "Search for images...",
        "project.searching": "Searching...",
        "project.search": "Search",
        "project.no_images_found": "No images found",
        "project.website_content_lines": "Content (statistics/info)",
        "project.content_line_title": "Title",
        "project.content_line_value": "Value",
        "project.line_type_info": "Info",
        "project.line_type_statistics": "Statistics",
        "project.add_line": "Add",
        "project.update_line": "Update",
        "project.cancel": "Cancel",
        "project.no_content_lines": "No content lines added",
        "project.saving": "Saving...",
        "project.save_settings": "Save Settings",
        "project.item_list.approved_by": "Approved by",
        "project.item_list.approval_comment": "Approval comment",
        "project.item_list.total_items": "Total items",
        "project.item_list.total_quantity": "Total quantity",
        "project.item_list.total_value": "Total value",
        "project.item_list.summary_title": "Item lists — summary",
        "project.item_list.summary_total_quantity": "Total quantity (net)",
        "project.item_list.summary_total_purchase": "Total purchase",
        "project.item_list.summary_total_sales": "Total sales",
        "project.item_list.view_items_summary": "View items summary",
        "project.item_list.items_summary_page_title": "Project item lists — summary",
        "project.item_list.items_summary_subtitle": "Quantities and prices across all lists on this project",
        "project.item_list.items_summary_intro":
          "Lines are combined by product item number (products without a number are grouped per product). Return lists reduce net quantity and amounts.",
        "project.item_list.items_summary_table_item_number": "Item no.",
        "project.time_registration.loading": "Loading time entries…",
        "project.time_registration.list_title": "Time registration — {{title}}",
        "project.time_registration.filter": "Filter",
        "project.time_registration.date_from": "From date",
        "project.time_registration.date_to": "To date",
        "project.time_registration.empty": "No time entries found for this project",
        "project.time_registration.registrations": "entries",
        "project.time_registration.no_activity": "No activity",
        "project.time_registration.approved_section": "Approved hours",
        "project.time_registration.approved_section_hint":
          "These hours are approved and included in totals and hourly costs above.",
        "project.time_registration.excluded_section":
          "Not approved or pending approval",
        "project.time_registration.excluded_section_hint":
          "Hours that are not approved are excluded from totals and hourly costs.",
        "project.time_registration.no_approved_in_range":
          "No approved hours in the selected period.",
        "project.time_registration.total_approved_hours": "Approved (in totals)",
        "project.time_registration.total_excluded_hours": "Excluded from totals",
        "project.time_registration.summary_approved_label": "Total approved hours (summed)",
        "project.time_registration.summary_excluded_note":
          "{{hours}} hours are not approved and are not included.",
        "project.time_registration.badge_approved": "Approved",
        "project.time_registration.badge_rejected": "Not approved",
        "project.time_registration.badge_pending": "Pending approval",
        "project.time_registration.approve": "Approve",
        "project.time_registration.reject": "Reject",
        "project.time_registration.open_hour": "Edit hour",
        "project.time_registration.process_dialog": "Process hour",
        "order.date": "Order Date",
        "use_customer_address": "Use Customer Address",
        "report": "Report",
        "send-sms.customer": "Send SMS to Customer",
        "cancel.reason": "Reason for canceling",
        "cancel.reason.required": "Reason for canceling is required",
        "cancel.reason.employee_sickness": "Employee is sick",
        "cancel.reason.customer_sickness": "Customer is sick",
        "cancel.reason.not_confirmed": "Ikke bekreftet av kunde",
        "cancel.reason.not_suited": "Date/ time is not suited for customer",
        "cancel.reason.assignment_cancelled": "Assignment cancelled",
        "cancel.reason.not_chosen": "Not chosen",
        "not_chosen": "Not chosen",
        "product.brands": "Brands",
        "product.brands.create": "Create a New Brand",
        "product.brand": "Product Brand",
        "image.change": "Change Image",
        "delete": "delete",
        "confirmation.sure": "Are you sure you want to",
        "library": "Library",
        "order_date": "Order Date",
        "order_number": "Order Number",
        "RESPONSIBLE": "Responsible",
        "EXECUTOR": "Executor",
        "OBSERVER": "Observer",
        "note": "Note",
        "work_order": "Work Order",
        "contact": "Contact",
        "service_agreement": "Service Agreement",
        "order": "Order",
        "product": "Product",
        "folder": "Folder",
        "number.to": "To",
        "number.from": "From",
  
        // Control Panel / Sentralbord translations
        "control.panel": "Control Panel",
        "control.panel.overview":
          "Dashboard for system integrations and monitoring",
        "overview": "Overview",
        "queues": "Queues",
        "calls": "Call Log",
        "persons": "Persons",
        "settings": "Settings",
        "Bruker som håndterer egenmelding": "User who handles absences",
        "Velg administrator": "Select administrator",
        "Velg en administrator som skal håndtere egenmeldinger": "Select an administrator who will handle absences",
        "control.panel.overview.title": "Control Panel Overview",
        "control.panel.overview.description":
          "Dashboard for all integrations and systems",
        "current.phone.status": "Current Phone Status",
        "phone.status": "Phone Status",
        "phone.details.status": "Phone Status Details",
        "connected.to.phonero": "Connected to Phonero",
        "not.connected.to.phonero": "Not connected to Phonero system",
        "change.status": "Change Status",
        "not.connected.to.phone.system": "Not connected to phone system",
        "phonero.status": "Phonero Status",
        "active": "Active",
        "not.configured": "Not configured",
        "view.details": "View details",
        "system.status": "System Status",
        "all.systems.operational": "All systems operational",
        "last.updated": "Last updated",
        "quick.actions": "Quick Actions",
        "configure": "Configure",
        "phonero.queues": "Phonero Queues",
        "monitor.manage.queues": "Monitor and manage call queues",
        "call.log": "Call Log",
        "view.call.history": "View call history and details",
        "phonero.persons": "Phonero Persons",
        "manage.persons.phone": "Manage persons and their phone settings",
        "control.panel.settings": "Control Panel Settings",
        "configure.control.panel": "Configure control panel and integrations",
        "integrations": "Integrations",
        "manage.all.integrations": "Manage all system integrations",
        "phone.integration": "Phone integration",
  
        // Pagination
        "pagination.previous": "Previous",
        "pagination.next": "Next",
        "pagination.showing": "Showing {{current}} of {{total}}",
        "pagination.loadMore": "Load more",
        "histories.title": "History",
        "histories.subtitle": "Activity and changes",
        "histories.last_updated": "Last updated",
        "histories.last_edited": "Last edited",
        "histories.by_prefix": "by",
        "histories.no_data": "No data yet",
        "histories.filter_action": "Filter by action",
        "histories.filter_all": "All",
        "histories.empty_filter": "No events for this filter.",
        "histories.load_more": "Load more",
        "histories.loading_more": "Loading…",
        "histories.close": "Close",
        "histories.system_user": "System",
        "histories.unknown_user": "Unknown",
        "histories.sync_changes_heading": "Sync metadata",
        "histories.action.tripletex_sync_attempt": "attempted Tripletex sync on",
        "histories.action.tripletex_sync": "completed Tripletex sync for",
        "histories.action.tripletex_sync_skipped": "skipped Tripletex sync for",
        "histories.deviation_scope.deviation": "Deviation timeline",
        "histories.deviation_scope.project": "Linked to project timeline",
        "histories.deviation_scope.customer": "Linked to customer timeline",
        "deviation.work_order.link_dialog_title": "Link work order",
        "deviation.work_order.section_title": "Linked work order",
        "deviation.work_order.link_submit": "Save",
        "deviation.work_order.link_open": "Link work order",
        "deviation.work_order.open_linked": "Open work order",
        "deviation.work_order.unlink": "Remove link",
        "deviation.work_order.change": "Change",
        "deviation.work_order.mode_existing": "Choose existing",
        "deviation.work_order.mode_create": "Create new",
        "deviation.work_order.existing_intro":
          "Only work orders without another deviation linked are listed. The work order already linked to this deviation stays available.",
        "deviation.work_order.create_intro":
          "Create a new work order — it will be linked to this deviation when you save.",
        "deviation.work_order.create_button": "Create work order",
        "deviation.work_order.linked_after_create":
          "Work order created and linked to the deviation",
        "deviation.work_order.link_failed_after_create":
          "The work order was created, but it could not be linked to the deviation. Open the deviation and link the work order manually.",
        "deviation.work_order.suggested_wo_title_full":
          "Deviation {{number}} · {{title}}",
        "deviation.work_order.suggested_wo_title_number_only":
          "Deviation {{number}}",
        "deviation.work_order.toast_saved": "Work order link updated",
        "deviation.form.work_order_heading": "Work order from deviation",
        "deviation.form.work_order_mode_none": "Not linked",
        "deviation.form.work_order_mode_existing": "Choose existing",
        "deviation.form.work_order_mode_create": "Create new",
        "deviation.form.work_order_create_timing_intro": "How should the assignment start?",
        "deviation.form.work_order_perform_now": "Work is happening now",
        "deviation.form.work_order_plan_later": "Work will be planned",
        "deviation.form.work_order_perform_now_help":
          "A work order is created from this deviation's title and description, linked to the deviation, and a calendar event is created for the selected assignee starting now with a 2-hour duration.",
        "deviation.form.work_order_plan_later_help":
          "The deviation is saved. You continue to create a work order; it links to the deviation when you save the new order.",
        "deviation.form.executor_label": "Assignee executing the job",
        "deviation.form.executor_pick": "Choose assignee",
        "deviation.form.executor_hint": "The calendar event will be tied to this person.",
        "deviation.form.executor_dialog_help":
          "The person who should appear as the assignee when the job happens now.",
        "deviation.form.need_project_customer_for_work_order":
          "Select project and customer (on the deviation) before creating or deferring the work order from here.",
        "deviation.form.work_order_create_failed": "Could not create the work order.",
        "deviation.form.event_creation_failed":
          "The work order was created, but the event could not be created automatically — add one on the work order.",
        "deviation.form.work_order_and_event_saved":
          "Work order and event were created and linked to the deviation.",
        "deviation.form.saved": "Saved",
        "deviation.form.save_failed": "Something went wrong while saving.",
        "deviation.form.default_wo_title": "Deviation work order",
        "deviations.list.notified_none": "No notifications sent",
        "deviations.list.notified_compact_suffix": " (+{{count}})",

        // Cases list - new view
        "Use list view": "Use list view",
        "Use new view": "Use new view",
        "Switch to classic list view": "Switch to classic list view",
        "Switch to compact editable table view": "Switch to compact editable table view",
        "Status updated": "Status updated",
        "Could not update status": "Could not update status",
        "Due date updated": "Due date updated",
        "Could not update due date": "Could not update due date",
        "Priority updated": "Priority updated",
        "Could not update priority": "Could not update priority",
        "Last update": "Last update",
        "No updates yet": "No updates yet",
        "Add update": "Add update",
        "Write an update...": "Write an update...",
        "Gå til bruker": "Go to user",
        "Bruker": "User",
        "Ansatt": "Employee",
        "Update added": "Update added",
        "Could not add update": "Could not add update",
        "Title (optional)": "Title (optional)",
        "Add title": "Add title",
        "Link": "Link",
        "Add link": "Add link",
        "Link text (optional)": "Link text (optional)",
        "URL": "URL",
        "Send": "Send",
        "Open case": "Open case",
        "View full": "View full",
        "No title": "No title",
        "Case type": "Case type",
        "Labels": "Labels",
        "No labels defined": "No labels defined",
        "Remove": "Remove",
        "Statistics": "Statistics",
        "Cases by label": "Cases by label",
        "No labels with cases yet": "No labels with cases yet",
        "Label administration": "Label administration",
        "All modules": "All modules",
        "Cases": "Cases",
        "Projects": "Projects",
        "Customers": "Customers",
        "Tasks": "Tasks",
        "Add label": "Add label",
        "Scope module": "Scope module",
        "Sort order": "Sort order",
        "Name is required": "Name is required",
        "Are you sure you want to delete this label?": "Are you sure you want to delete this label?",
        "No employees found": "No employees found",
        "Prioritering": "Priority",
        "Priority": "Priority",
  
        // Phonero presence statuses
        "presence.available": "Available",
        "presence.busy": "Busy",
        "presence.away": "Away",
        "presence.unknown": "Unknown",
        "presence.connected": "Connected to Phonero",
        "presence.not.available": "Presence status not available",
        "presence.failed.to.load": "Failed to load presence data",
        "presence.updated.successfully": "Presence updated successfully",
        "presence.failed.to.update": "Failed to update presence",
        "presence.cannot.update":
          "Cannot update presence - user not found in Phonero",
  
        // Phonero presence descriptions
        "Free": "Free",
        "Meeting": "Meeting",
        "Lunch": "Lunch",
        "Vacation": "Vacation",
        "Busy": "Busy",
        "Way": "Way",
        "Gone for the day": "Gone for the day",
  
        // Live Calls translations
        "Live Calls (Not synched yet)": "Live Calls (Not synched yet)",
        "Latest calls from Phonero API (not yet synced to database)":
          "Latest calls from Phonero API (not yet synced to database)",
        "Refreshing...": "Refreshing...",
        "Refresh": "Refresh",
        "Loading live calls...": "Loading live calls...",
        "No unsynced live calls found": "No unsynced live calls found",
  
        // Manual Call translations
        "Add Manual Call": "Add Manual Call",
        "From Number (Customer)": "From Number (Customer)",
        "Date & Time": "Date & Time",
        "Duration (seconds)": "Duration (seconds)",
        "Note": "Note",
        "Cancel": "Cancel",
        "Create Call": "Create Call",
        "Creating...": "Creating...",
        "Manual call created successfully": "Manual call created successfully",
        "Manual call added successfully": "Manual call added successfully",
        "Manual": "Manual",
        "Select Date": "Select Date",
        "Choose date": "Choose date",
        "Report": "Report",
        "Case": "Case",
        "Order": "Order",
        "Work Order": "Work Order",
        "Work Orders": "Work Orders",
        "Work Order List": "Work Order List",
        "New Work Order": "New Work Order",
        "Search work orders...": "Search work orders...",
        "Filter Work Orders by Status": "Filter Work Orders by Status",
        "Invoiced": "Invoiced",
        "Ready to be invoiced": "Ready for invoicing",
        "Finished": "Finished",
        "Order Date": "Order Date",
        "Due Date": "Due Date",
        "Event Period": "Event Period",
        "Responsible": "Responsible",
        "Executor": "Executor",
        "Work Order #": "Work Order #",
        "work_orders.pagination_summary":
          "Page {{page}} of {{totalPages}} ({{total}} total)",
        "work_orders.delete_confirm":
          "This permanently deletes the work order. Hours linked to it will be unlinked. This cannot be undone.",
        "work_orders.delete_success": "Work order deleted",
        "work_orders.delete_failed": "Could not delete the work order",
        "work_orders.back_to_view": "Back to view",
        "work_orders.calendar_filter": "Work orders",
        "work_orders.project_activity.section_title": "Project activity",
        "work_orders.project_activity.help":
          "Link a project activity that is not already tied to another record, or create a new one on this project. Saving the work order connects the activity to this order.",
        "work_orders.project_activity.new_title_label": "New activity title",
        "work_orders.project_activity.copy_from_title": "Copy from title",
        "work_orders.project_activity.new_title_placeholder":
          "e.g. Installation phase 2",
        "work_orders.project_activity.create_button": "Create and select",
        "work_orders.project_activity.creating": "Creating…",
        "work_orders.project_activity.created_toast": "Project activity created",
        "work_orders.project_activity.create_error":
          "Could not create project activity",
        "work_orders.project_activity.linked_label": "Project activity",
        "work_orders.billing_ready.action": "Ready for invoicing",
        "work_orders.billing_ready.eyebrow": "Invoicing draft",
        "work_orders.billing_ready.title": "Prepare billing information",
        "work_orders.billing_ready.title_edit": "Update billing draft",
        "work_orders.billing_ready.intro":
          "Save invoice text and what to bill (hours and consumption lines). You can mark the work order ready for invoicing only, or create a sales order immediately to continue invoicing on the order.",
        "work_orders.billing_ready.section_invoice": "Invoice draft",
        "work_orders.billing_ready.section_hours": "Billable hours",
        "work_orders.billing_ready.section_hours_subtitle":
          "Selected {{selected}} h of {{total}} h (billable)",
        "work_orders.billing_ready.section_items": "Material lines (consumption)",
        "work_orders.billing_ready.section_items_subtitle":
          "{{selected}} of {{total}} lines selected",
        "work_orders.billing_ready.section_group": "Order grouping (later)",
        "work_orders.billing_ready.add_tilleggsarbeider_hint":
          "When orders are generated from this work order later, hours and materials can be placed in a separate group on the sales order.",
        "work_orders.billing_ready.toggle_hours_aria": "Include hours on invoice draft",
        "work_orders.billing_ready.toggle_items_aria": "Include material lines on invoice draft",
        "work_orders.billing_ready.no_billable_hours": "No billable hours linked to this work order.",
        "work_orders.billing_ready.no_usage_items": "No consumption lines with used quantity.",
        "work_orders.billing_ready.submit": "Save and mark ready for invoicing",
        "work_orders.billing_ready.success": "Marked ready for invoicing and reminder sent where applicable",
        "work_orders.billing_ready.failed": "Could not save billing draft",
        "work_orders.billing_ready.submit_create_order": "Create sales order",
        "work_orders.billing_ready.success_order": "Sales order created",
        "work_orders.billing_ready.failed_order": "Could not create sales order",
        "work_orders.billing_ready.open_order": "Open sales order",
        "work_orders.billing_ready.sales_income_in_project_notice_title":
          "Invoicing via sales order disabled",
        "work_orders.billing_ready.sales_income_in_project_notice":
          "This work order is marked as having sales income included in the project. Use project billing instead; marking ready for invoicing and creating a sales order from this work order are not available.",
        "work_orders.bulk_create.toolbar": "{{count}} selected",
        "work_orders.bulk_create.open": "Create sales orders…",
        "work_orders.bulk_create.clear": "Clear selection",
        "work_orders.bulk_create.title": "Create sales orders from work orders",
        "work_orders.bulk_create.summary": "You are about to create one or more sales orders from {{count}} work order(s).",
        "work_orders.bulk_create.hint":
          "Default billing rules apply: all billable hours and consumption lines on each work order are included. For full control (rounding, manual hours, line picks), use the billing dialog on each work order.",
        "work_orders.bulk_create.strategy_label": "How should orders be grouped?",
        "work_orders.bulk_create.strategy_per_wo": "One sales order per work order",
        "work_orders.bulk_create.strategy_customer": "Combine per customer (one order per customer)",
        "work_orders.bulk_create.strategy_project": "Combine per project (one order per project)",
        "work_orders.bulk_create.submit": "Create orders",
        "work_orders.bulk_create.success": "Created {{count}} sales order(s)",
        "work_orders.bulk_create.failed": "Could not create sales orders",
        "work_orders.bulk_create.select_row": "Select work order for bulk invoicing",
        "work_orders.bulk_create.select_page": "Select all work orders on this page that can be invoiced",
        "work_orders.checklist.enable_switch": "Use checklist on this work order",
        "work_orders.checklist.section_title": "Checklist",
        "work_orders.checklist.save_to_enable_title": "Save the work order",
        "work_orders.checklist.save_to_enable_body":
          "Save your changes to activate the checklist section and create or edit checklist lines.",
        "work_orders.checklist.missing_title": "No checklist yet",
        "work_orders.checklist.missing_body":
          "Create a checklist by choosing a template or starting empty.",
        "work_orders.checklist.choose": "Choose checklist",
        "work_orders.checklist.delete": "Delete checklist",
        "work_orders.checklist.delete_confirm_title": "Delete checklist?",
        "work_orders.checklist.delete_confirm_body":
          "This cannot be undone. The checklist and its answers will be removed.",
        "work_orders.checklist.loading": "Loading checklist…",
        "work_orders.checklist.load_error": "Could not load checklist.",
        "work_orders.checklist.load_error_title": "Checklist could not be loaded",
        "work_orders.checklist.load_error_hint":
          "Try again or open the work order from the project overview.",
        "work_orders.checklist.created": "Checklist created",
        "work_orders.checklist.create_error": "Could not create checklist",
        "work_orders.checklist.deleted": "Checklist removed",
        "work_orders.checklist.delete_error": "Could not delete checklist",
        "work_orders.checklist.save_error": "Could not save checklist",
        "work_orders.checklist.read_only_hint":
          "You can view the work order checklist in read mode on the checklist page.",
        "work_orders.checklist.page_subtitle": "Checklist",
        "work_orders.checklist.page_heading": "Work order checklist",
        "work_orders.checklist.back_to_work_order": "Back to work order",
        "work_orders.checklist.disabled_title": "Checklist is not enabled",
        "work_orders.checklist.disabled_body":
          "Enable «Use checklist» on the work order edit page to use this section.",
        "work_orders.checklist.read_only_banner":
          "View only: you do not have permission to edit this checklist.",
        "work_orders.checklist.create_from_edit":
          "Create a checklist from the work order edit page.",
        "work_orders.checklist.load_work_order_error": "Could not load work order",
        "work_orders.checklist.card_title": "Checklist",
        "work_orders.checklist.card_desc_with_checklist":
          "View and complete checklist items on the checklist page.",
        "work_orders.checklist.card_desc_no_checklist":
          "Create a checklist from the work order edit page (choose a template or start empty).",
        "work_orders.checklist.unit": "items",
        "work_orders.checklist.mobile_nav": "Checklist",
        "work_orders.list_meta_total": "Total: {{count}}",
        "work_orders.table_no_title": "No title",
        "work_order.view.mobileNav.ariaLabel":
          "Quick links for work order time and item consumption",
        "work_order.admin.title": "Admin",
        "work_order.admin.edit": "Edit work order",
        "work_order.admin.edit_desc": "Open the full edit form",
        "work_order.admin.approve": "Approve work order",
        "work_order.admin.approve_desc": "Approve or reject (coordinator)",
        "work_order.admin.open_project": "Open project",
        "work_order.admin.open_customer": "Open customer",
        "work_order.admin.item_consumption": "Item consumption",
        "work_order.admin.item_consumption_desc": "Register materials and quantity used",
        "work_order.admin.billing_desc": "Prepare invoicing or create a sales order",
        "work_order.admin.finish": "Finish work order",
        "work_order.admin.finish_desc": "Complete checklist and mark as finished",
        "work_order.admin.mentions": "@mentions",
        "work_order.admin.mentions_desc": "Notes and resources that reference this work order",
        "work_order.admin.mentions_dialog_title": "Mentions of this work order",
        "work_order.admin.no_mentions": "No mentions found.",
        "work_order.admin.set_status": "Set status (admin)",
        "work_order.admin.set_status_desc":
          "Correct status for legacy cases, for example already invoiced outside Promang.",
        "work_order.admin_set_status.title": "Set work order status",
        "work_order.admin_set_status.intro":
          "Use when the order was invoiced or completed outside the normal flow. This does not create a sales order.",
        "work_order.admin_set_status.status_label": "Status",
        "work_order.admin_set_status.mark_completed": "Mark as completed",
        "work_order.admin_set_status.submit": "Save",
        "work_order.admin_set_status.success": "Status updated.",
        "work_order.admin_set_status.error": "Could not update status.",
        "work_order.completion.title": "Completion",
        "work_order.completion.status_not_applicable":
          "Finishing is not available for this status.",
        "work_order.completion.heading_done": "Work order completed",
        "work_order.completion.heading_pending": "Finish work order",
        "work_order.completion.sub_done":
          "The work order has been marked as finished.",
        "work_order.completion.sub_blocked":
          "Some requirements must be met before you can finish.",
        "work_order.completion.sub_ready":
          "All required checks are satisfied; you can finish when ready.",
        "work_order.completion.label_status": "Status",
        "work_order.completion.label_progress": "Readiness",
        "work_order.completion.value_done": "Completed",
        "work_order.completion.no_checks": "—",
        "work_order.completion.cta_view": "View completion details",
        "work_order.completion.cta_finish": "Finish work order",
        "work_order.event.dialog_create": "Create event",
        "work_order.event.dialog_edit": "Edit event",
        "work_order.event.toast_created": "Event created",
        "work_order.event.toast_updated": "Event updated",
        "work_order.event.toast_deleted": "Event deleted",
        "work_order.event.delete_failed": "Could not delete event",
        "work_order.event.delete_event": "Delete",
        "work_order.event.saving": "Saving…",
        "work_order.event.submit_create": "Create",
        "work_order.event.submit_update": "Update",
        "work_order.event.field_title": "Title",
        "work_order.event.field_title_placeholder": "Event title",
        "work_order.event.field_description": "Description",
        "work_order.event.field_description_placeholder": "Describe the event…",
        "work_order.event.field_start": "Start",
        "work_order.event.field_end": "End",
        "work_order.event.field_location": "Location",
        "work_order.event.field_location_placeholder": "Where will the event take place?",
        "work_order.event.location_prefilled":
          "Delivery address from the work order is pre-filled (you can edit it).",
        "work_order.event.all_day": "All day",
        "work_order.event.attendees_title": "Event attendees",
        "work_order.event.attendees_hint":
          "Everyone on the work order is suggested. Uncheck anyone who should not attend. You can add more below.",
        "work_order.event.add_attendee": "Add attendee",
        "work_order.event.add_confirm": "Add",
        "work_order.event.select_user": "Select user",
        "work_order.event.loading_users": "Loading users…",
        "work_order.event.no_attendees_from_wo":
          "No participants on the work order. Use “Add attendee” to invite someone.",
        "work_order.event.from_work_order": "From work order",
        "work_order.event.remove_attendee": "Remove",
        "work_order.event.role_participant": "Participant",
        "work_order.event.error_need_event_owner":
          "The work order must have someone who can own the calendar event (responsible executor, work order responsible, or creator) before you can create an event.",
        "work_order.event.notice_no_event_owner_title": "No event owner on work order",
        "work_order.event.notice_no_event_owner_description":
          "Add a responsible executor or work order responsible, or ensure the order has a creator, so the event can be tied to a user. You can still edit an existing event.",
        "work_order.participants.title": "Participants",
        "work_order.participants.description":
          "Who is on the work order (roles and status).",
        "work_order.participants.draft_hint":
          "Save the work order first to manage participants like on a project (dedicated dialogs).",
        "work_order.participants.add": "Add participant",
        "work_order.participants.add_first": "Add first participant",
        "work_order.participants.none": "No participants yet.",
        "work_order.participants.user": "User",
        "work_order.participants.role": "Role",
        "work_order.participants.status": "Status",
        "work_order.participants.edit": "Edit",
        "work_order.participants.delete": "Delete",
        "work_order.participants.delete_confirm":
          "Remove this participant from the work order?",
        "work_order.participants.delete_error": "Could not remove participant",
        "work_order.participants.error_loading":
          "Could not load participants",
        "work_order.participants.save_error": "Could not save participant",
        "work_order.participants.created": "Participant added",
        "work_order.participants.updated": "Participant updated",
        "work_order.participants.updating": "Updating…",
        "work_order.participants.adding": "Adding…",
        "report.participants.title": "Additional assignees",
        "report.participants.subtitle":
          "Extra field staff and observers (calendar shows everyone). The responsible technician is set on the agreement.",
        "report.participants.add": "Add assignee",
        "report.participants.add_first": "Add first assignee",
        "report.participants.none": "No additional assignees.",
        "report.participants.user": "User",
        "report.participants.role": "Role",
        "report.participants.status": "Status",
        "report.participants.choose_role": "Select role",
        "report.participants.choose_status": "Select status",
        "report.participants.edit": "Edit",
        "report.participants.delete": "Remove",
        "report.participants.delete_confirm":
          "Remove this person from the report assignees?",
        "report.participants.delete_error": "Could not remove assignee",
        "report.participants.save_error": "Could not save assignee",
        "report.participants.created": "Assignee added",
        "report.participants.updated": "Assignee updated",
        "report.participants.updating": "Updating…",
        "report.participants.adding": "Adding…",
        "report.participants.error_is_executing_employee":
          "This person is already set as the responsible technician on the agreement. Remove them from the agreement first, or pick another colleague.",
        "Use card view": "Use card view",
        "Switch to card overview layout": "Switch to card overview layout",
        "Switch to compact table layout": "Switch to compact table layout",
        "Service Agreement": "Service Agreement",
        "Project": "Project",
        "Absence": "Absence",
        "Week": "Week",
        "Day": "Day",
        "Filters": "Filters",
        "Project Filter": "Project Filter",
        "Activity Filter": "Activity Filter",
        "All Projects": "All Projects",
        "All Activities": "All Activities",
        "Clear Filters": "Clear Filters",
        "No hours recorded for this day": "No hours recorded for this day",
        "entries": "entries",
        "Loading hours...": "Loading hours...",
        "already_registered_hours_for_event": "Already registered hours for this event",
        "dashboard_report.status.planned": "Planned",

        "company_guide.badge": "Company guide",
        "company_guide.hours.title": "Time tracking, absence and work schedule",
        "company_guide.hours.subtitle":
          "Checklist for admins with the Hours module (shown on the hours user guide).",
        "company_guide.hours.progress_label": "Status",
        "company_guide.hours.progress_loading": "Loading…",
        "company_guide.hours.progress_error": "Could not load status. Try refreshing the page.",
        "company_guide.hours.progress_summary_ok": "{{done}} of {{total}} recommended steps are complete.",
        "company_guide.hours.progress_summary_warnings":
          "{{done}} of {{total}} recommended steps are complete. {{warnings}} item(s) still need attention.",
        "company_guide.hours.footer_hint":
          "Legacy Activity/ActivityItem is mainly for Tripletex sync, not primary time entry in Promang.",
        "company_guide.hours.footer_link_settings": "Open Hours → Settings",
        "company_guide.hours.link.scroll_to_explanation": "Read the explanation below",
        "company_guide.hours.link.settings_section": "Open in settings",
        "company_guide.hours.link.work_schedule": "Open schedule",
        "company_guide.hours.task.registration_model.title": "Time entry and project lines",
        "company_guide.hours.task.registration_model.info":
          "Project hours need project_activity on the project. Activity/ActivityItem is legacy in the UI and used for Tripletex sync.",
        "company_guide.hours.task.absence_types.title": "Absence types",
        "company_guide.hours.task.absence_types.ok": "{{count}} absence type(s) defined.",
        "company_guide.hours.task.absence_types.warn":
          "Create absence types that match how you work (vacation, sick leave, time off in lieu, …).",
        "company_guide.hours.task.absence_types.unknown": "Could not verify absence types automatically.",
        "company_guide.hours.task.handlers.title": "Hours and absence ownership",
        "company_guide.hours.task.handlers.ok": "Hours and absence handlers are set.",
        "company_guide.hours.task.handlers.warn":
          "Assign who processes timesheets and self-reported absence so employees know who follows up.",
        "company_guide.hours.task.work_schedule.title": "Work schedule and FTE",
        "company_guide.hours.task.work_schedule.info":
          "Ensure each employee has a work schedule that matches their position; it affects planned hours and absence.",
        "company_guide.hours.task.work_schedule.ok": "Work schedules exist and employees are assigned.",
        "company_guide.hours.task.work_schedule.warn_none": "Create at least one company work schedule.",
        "company_guide.hours.task.work_schedule.warn_unassigned":
          "{{count}} active employee(s) have no work schedule assigned.",
        "company_guide.hours.link.work_schedule_admin": "Manage work schedules",

        "company_guide.company.badge": "Company guide",
        "company_guide.company.heading": "Core company profile",
        "company_guide.company.subtitle":
          "Logo, contact details, addresses and terms links build trust in customer-facing flows.",
        "company_guide.company.progress_label": "Status",
        "company_guide.company.progress_loading": "Loading…",
        "company_guide.company.progress_error": "Could not load company data. Try refreshing.",
        "company_guide.company.progress_ok": "{{done}} of {{total}} recommended items are complete.",
        "company_guide.company.progress_warnings":
          "{{done}} of {{total}} recommended items are complete. {{warnings}} still need attention.",
        "company_guide.company.footer_hint":
          "Update everything under Company → Settings. This checklist refreshes after you save.",
        "company_guide.company.link.settings": "Open company settings",
        "company_guide.company.task.name.title": "Company name",
        "company_guide.company.task.name.warn": "Company name should be filled in.",
        "company_guide.company.task.name.ok": "Company name looks set.",
        "company_guide.company.task.logo.title": "Logo",
        "company_guide.company.task.logo.warn": "Add a logo for documents, offers and customer views.",
        "company_guide.company.task.logo.ok": "Logo is set.",
        "company_guide.company.task.contact.title": "Contact information",
        "company_guide.company.task.contact.warn": "Provide at least one of email, phone or mobile.",
        "company_guide.company.task.contact.ok": "At least one contact channel is set.",
        "company_guide.company.task.address.title": "Address",
        "company_guide.company.task.address.warn": "Add a business or postal address.",
        "company_guide.company.task.address.ok": "An address is registered.",
        "company_guide.company.task.sales_conditions_url.title": "Sales terms (URL)",
        "company_guide.company.task.sales_conditions_url.warn":
          "A link to sales/terms is missing — important for offers and webshop.",
        "company_guide.company.task.sales_conditions_url.ok": "Sales/terms link is set.",
        "company_guide.company.task.vat.title": "VAT / org. number",
        "company_guide.company.task.vat.warn": "Organization / VAT number should be filled in.",
        "company_guide.company.task.vat.ok": "Organization / VAT number is set.",

        "dashboard.company_guide.alert_company_title": "Company profile needs attention",
        "dashboard.company_guide.alert_company_subtitle":
          "{{count}} item(s) in the company guide should be fixed.",
        "dashboard.company_guide.alert_hours_title": "Hours setup needs attention",
        "dashboard.company_guide.alert_hours_subtitle":
          "{{count}} item(s) in the hours guide should be fixed.",
        "dashboard.company_guide.alert_cta": "Open guide and checklist",

        "user_guide.hub.card.company.title": "Company and settings",
        "user_guide.hub.card.company.description":
          "Logo, contact, addresses, sales terms and other basics that should be in place.",

        "user_guide.company.back_to_hub": "Back to user guide",
        "user_guide.company.badge": "Company",
        "user_guide.company.title": "Company settings and profile",
        "user_guide.company.intro":
          "Correct company information matters for customers, offers and integrations. As an admin, work through the checklist below and fill any gaps.",
        "user_guide.company.section.why.title": "Why this matters",
        "user_guide.company.section.why.p1":
          "Logo and contact details are expected wherever you meet customers and suppliers.",
        "user_guide.company.section.why.p2":
          "Address and sales terms are often required in agreements, webshop and document exports.",
        "user_guide.company.section.where.title": "Where to change this",
        "user_guide.company.section.where.p1":
          "Go to Company → Settings. Use the checklist links to jump to the right section.",

        "user_employment.work_schedule_label": "Work schedule (hours)",
        "user_employment.work_schedule_hint":
          "Used for time tracking, planned time and absence. Create schedules under Hours → Work schedules.",
        "user_employment.work_schedule_none": "None selected",

        "work_schedules_admin.title": "Work schedules",
        "work_schedules_admin.intro":
          "Create and maintain schedules (hours per weekday). New employees get the latest schedule by default unless you assign another.",
        "work_schedules_admin.summary_title": "Summary",
        "work_schedules_admin.summary_plans": "{{count}} work schedule(s) in the company.",
        "work_schedules_admin.summary_unassigned_ok": "All active employees have a work schedule.",
        "work_schedules_admin.summary_unassigned_warn":
          "{{count}} active employee(s) have no work schedule — assign under the user/employee profile.",
        "work_schedules_admin.assign_hint": "Assign on employee:",
        "work_schedules_admin.assign_link": "Users / employees",
        "work_schedules_admin.new": "New work schedule",
        "work_schedules_admin.edit": "Edit",
        "work_schedules_admin.delete": "Delete",
        "work_schedules_admin.save": "Save",
        "work_schedules_admin.saving": "Saving…",
        "work_schedules_admin.cancel": "Cancel",
        "work_schedules_admin.field_name": "Name (optional)",
        "work_schedules_admin.field_name_placeholder": "e.g. Office 7.5h",
        "work_schedules_admin.empty": "No work schedules yet — create one to get started.",
        "work_schedules_admin.unnamed": "Untitled",
        "work_schedules_admin.confirm_delete": "Delete “{{name}}”? Cannot delete if in use.",
        "work_schedules_admin.created": "Work schedule created",
        "work_schedules_admin.saved": "Work schedule saved",
        "work_schedules_admin.deleted": "Work schedule deleted",
        "work_schedules_admin.load_error": "Could not load work schedules",
        "work_schedules_admin.save_error": "Could not save",
        "work_schedules_admin.delete_error": "Could not delete",
        "work_schedules_admin.back_guide": "Back to user guide (hours)",
        "work_schedules_admin.day.monday": "Monday",
        "work_schedules_admin.day.tuesday": "Tuesday",
        "work_schedules_admin.day.wednesday": "Wednesday",
        "work_schedules_admin.day.thursday": "Thursday",
        "work_schedules_admin.day.friday": "Friday",
        "work_schedules_admin.day.saturday": "Saturday",
        "work_schedules_admin.day.sunday": "Sunday",

        "work_schedule_view.page_title": "Schedule",
        "work_schedule_view.fallback_title": "Work schedule",
        "work_schedule_view.subtitle": "Hours per weekday adjusted for position percentage",
        "work_schedule_view.empty": "No work schedule is linked to your employment yet.",
        "work_schedule_view.empty_hint":
          "Ask an administrator to create a schedule and assign it on your user/employee profile.",
        "work_schedule_view.link_users": "Go to users",
        "work_schedule_view.day_off": "Off",
        "work_schedule_view.hours_value": "{{hours}} hours",
        "work_schedule_view.day.monday": "Monday",
        "work_schedule_view.day.tuesday": "Tuesday",
        "work_schedule_view.day.wednesday": "Wednesday",
        "work_schedule_view.day.thursday": "Thursday",
        "work_schedule_view.day.friday": "Friday",
        "work_schedule_view.day.saturday": "Saturday",
        "work_schedule_view.day.sunday": "Sunday",

        "hours.resource_plan.title": "Resource plan and availability",
        "hours.resource_plan.subtitle": "See who is scheduled, available, absent or clocked in on the actual days.",
        "hours.resource_plan.date_from": "From date",
        "hours.resource_plan.date_to": "To date",
        "hours.resource_plan.access_title": "Employee access",
        "hours.resource_plan.access_body": "Users with Hours access can see operational colleague status without admin rights.",
        "hours.resource_plan.load_error": "Could not load resource plan",
        "hours.resource_plan.stats.employees": "Employees",
        "hours.resource_plan.stats.available_days": "Available day rows",
        "hours.resource_plan.stats.clocked_in": "Clocked in",
        "hours.resource_plan.stats.scheduled_hours": "Scheduled hours",
        "hours.resource_plan.days_title": "Days in period",
        "hours.resource_plan.days_subtitle": "Select a day for a detailed employee overview.",
        "hours.resource_plan.day_stats": "{{available}} of {{employees}} available",
        "hours.resource_plan.no_day": "No day selected",
        "hours.resource_plan.employee_overview": "Employees, planned time and status for the selected day.",
        "hours.resource_plan.empty": "No employees found for the selected period.",
        "hours.resource_plan.unknown_employee": "Unknown employee",
        "hours.resource_plan.table.employee": "Employee",
        "hours.resource_plan.table.status": "Status",
        "hours.resource_plan.table.department": "Department",
        "hours.resource_plan.table.scheduled": "Work schedule",
        "hours.resource_plan.table.shift": "Shift",
        "hours.resource_plan.table.note": "Note",
        "hours.resource_plan.status.clocked_in": "At work now",
        "hours.resource_plan.status.available": "Available",
        "hours.resource_plan.status.planned": "Planned",
        "hours.resource_plan.status.absent": "Absent",
        "hours.resource_plan.status.unavailable": "Unavailable",
        "hours.resource_plan.status.off": "Off",

        "hour_settings.page.subtitle":
          "Absence, approval flow, payroll locking and other time settings (project hours use project_activity on the project).",
        "hour_settings.guide.title": "Getting started with hours",
        "hour_settings.guide.intro":
          "These are the same steps as on the dashboard. Time tracking is built on projects and project_activity; the general activity lists here are optional admin maintenance, not an onboarding requirement.",
        "hour_settings.guide.step.project_activity":
          "Project hours: ensure project_activity (and project) exists where people log time — this is what current Promang requires for project registration.",
        "hour_settings.guide.step.absence_types": "Absence types: create and maintain the types you use.",
        "hour_settings.guide.step.handlers":
          "Set administrators for hours and for self-reported absence.",
        "hour_settings.guide.step.payroll_lock":
          "Consider payroll period locking and payout day once routines are in place.",
        "hour_settings.guide.step.time_documents":
          "Optional — attach files to standalone hours without a linked service report or work order.",
        "hour_settings.guide.step.work_schedule":
          "Create schedules under Hours → Work schedules and assign them to employees (user profiles).",
        "hour_settings.guide.back_dashboard": "Back to home",
        "hour_settings.guide.open_user_guide": "User guide: hours and absence",
        "hour_settings.time_documents.section_title": "Time entry attachments",
        "hour_settings.time_documents.section_description":
          "Allow attaching photos/files to standalone hours when the hour is not linked to a service report or work order.",
        "hour_settings.time_documents.enabled": "Allow documentation uploads on hours",

        "hour.time_documents.title": "Documentation",
        "hour.time_documents.subtitle": "Pictures and files tied to this time entry.",
        "hour.time_documents.help_save_first": "Save the hour before you can attach files.",
        "hour.time_documents.pending_hint":
          "Add files below. They upload automatically right after you save (you do not need a separate upload step).",
        "hour.time_documents.pending_add": "Add files",
        "hour.time_documents.pending_count": "{{count}} file(s) queued for upload",
        "hour.time_documents.pending_remove": "Remove",
        "hour.time_documents.pending_file_type_denied": "That file type is not allowed.",
        "hour.time_documents.pending_upload_done": "Attachments uploaded",
        "hour.time_documents.pending_upload_failed":
          "The hour was saved, but uploads failed or were skipped. Close and reopen the hour to try again.",
        "hour.time_documents.blocked_linked":
          "Documentation is disabled when this hour is linked to a service report or work order.",
        "hour.time_documents.blocked_lock": "This period is locked; attachments cannot be changed.",
        "user_guide.hub.title": "How to use Promang",
        "user_guide.hub.subtitle":
          "Step-by-step guides for admins and staff. Content is maintained inside the app — technical developer docs are separate.",
        "user_guide.hub.card.hours.title": "Hours, absence and work schedule",
        "user_guide.hub.card.hours.description":
          "Getting started: absence types, owners, payroll lock, reminders and work schedules.",
        "user_guide.hub.footer_note": "Need more answers? Try the Resource hub FAQ.",

        "dashboard.company_guide.hours_teaser_title": "Hours and absence",
        "dashboard.company_guide.hours_teaser_subtitle":
          "Setup status and the full guide are on the user guide — not on the home page.",
        "dashboard.company_guide.hours_teaser_cta": "Open status and guide",

        "user_guide.hours.back_to_hub": "Back to user guide",
        "user_guide.hours.checklist.badge": "Getting started",
        "user_guide.hours.checklist.heading": "Setup status (Hours module)",
        "user_guide.hours.checklist.subtitle":
          "Visible to admins only. Each row links to settings or to more detail further down this page.",
        "user_guide.hours.badge": "Hours and absence",
        "user_guide.hours.title": "Hours, absence and work schedule",
        "user_guide.hours.purpose":
          "This guide helps new companies and admins set up absence, ownership and work schedules. The checklist on the home page (admins only) links here for detail.",

        "user_guide.hours.section.registration.title": "Time entry in Promang",
        "user_guide.hours.section.registration.p1":
          "Project hours should be linked to a project and a project activity line. That is what drives time entry in the product.",
        "user_guide.hours.section.registration.p2":
          "Legacy Activity and ActivityItem are used in the background for accounting systems (for example Tripletex sync). They are not what you normally pick when logging hours in the UI.",
        "user_guide.hours.section.registration.p3":
          "“General activity” lists under Hours → Settings can be used for admin maintenance, but they are not a separate onboarding requirement on the dashboard checklist.",

        "user_guide.hours.section.visibility.title": "Who sees what?",
        "user_guide.hours.section.visibility.li1":
          "On the home page, only a short link is shown to admins when Hours is on. Full status and the checklist live here on the user guide.",
        "user_guide.hours.section.visibility.li2":
          "Everyone who can open Hours → Settings sees the short help panel at the top of that page.",

        "user_guide.hours.section.steps.title": "Recommended order",
        "user_guide.hours.section.steps.s1.title": "1. Absence types",
        "user_guide.hours.section.steps.s1.where": "Go to Hours → Settings → Absence types.",
        "user_guide.hours.section.steps.s1.b1":
          "Create types that fit your company: vacation, sick leave, self-reported absence, time off in lieu, leave, and so on.",
        "user_guide.hours.section.steps.s1.b2":
          "Absence is registered against these types. Who approves self-reported absence depends on roles and who you set as absence handler.",

        "user_guide.hours.section.steps.s2.title": "2. Hours and absence ownership",
        "user_guide.hours.section.steps.s2.where": "Go to Hours → Settings → Hours and absence handling.",
        "user_guide.hours.section.steps.s2.b1":
          "Hours: choose who should approve timesheets and follow up discrepancies.",
        "user_guide.hours.section.steps.s2.b2":
          "Self-reported absence: choose who processes self-reported absence (often HR or the line manager).",
        "user_guide.hours.section.steps.s2.b3": "Set both early so employees know who follows up.",

        "user_guide.hours.section.steps.s3.title": "3. Payroll period lock (optional)",
        "user_guide.hours.section.steps.s3.where": "Go to Hours → Settings → Payroll period lock.",
        "user_guide.hours.section.steps.s3.b1":
          "When routines are in place you can lock the month at period end and set payout day to match payroll.",
        "user_guide.hours.section.steps.s3.b2":
          "Locked periods limit backdated changes; exceptions are handled by users with unlock rights where enabled.",

        "user_guide.hours.section.steps.s4.title": "4. Hour reminders (optional)",
        "user_guide.hours.section.steps.s4.where": "Go to Hours → Settings → Hour reminders.",
        "user_guide.hours.section.steps.s4.b1": "Turn on daily reminders and set times if you want nudges to log hours.",
        "user_guide.hours.section.steps.s4.b2":
          "Outgoing email must be configured in operations (scheduled jobs) — check with your admin or vendor whether this is active.",

        "user_guide.hours.section.steps.s5.title": "5. Work schedule and FTE",
        "user_guide.hours.section.steps.s5.where": "Use Schedule and user profiles under Users.",
        "user_guide.hours.section.steps.s5.b1":
          "Each employee should have a work schedule that matches their position — it affects expected time and planning.",
        "user_guide.hours.section.steps.s5.b2": "Calendar views and absence follow-up assume this is in place.",

        "user_guide.hours.section.related.title": "Useful shortcuts",
        "user_guide.hours.section.related.link_hours": "Hour list",
        "user_guide.hours.section.related.link_approval": "Hours approval",
        "user_guide.hours.section.related.link_absence": "Absence overview",
        "user_guide.hours.section.related.link_monthly": "Monthly hours overview",
        "user_guide.hours.section.related.link_settings": "Hours settings",

        "user_guide.hours.section.more_help.title": "More help",
        "user_guide.hours.section.more_help.p1":
          "If something is not covered here, the Resource hub FAQ or support can help further.",
        "user_guide.hours.section.more_help.faq_link": "Open FAQ in the Resource hub",

        "Time Registration": "Time Registration",
        "Registered hours": "Registered hours",
        "Close": "Close",
        "Saving": "Saving",
        "Save": "Save",
        "Error saving changes": "Error saving changes",
        "Changes saved successfully": "Changes saved successfully",
        "You have unsaved changes": "You have unsaved changes",
        "Could not save": "Could not save",
        "Hours Overview": "Hours Overview",
        "Track and manage work hours": "Track and manage work hours",
        "Select Employee": "Select Employee",
  
        // Work Statistics translations
        "Work Statistics": "Work Statistics",
        "Overview of your work hours and performance":
          "Overview of your work hours and performance",
        "Something went wrong while loading work stats":
          "Something went wrong while loading work stats",
        "Could not load work statistics": "Could not load work statistics",
        "No data available": "No data available",
        "No work statistics found for this user.":
          "No work statistics found for this user.",
        "Expected This Week": "Expected This Week",
        "Worked This Week": "Worked This Week",
        "Worked This Month": "Worked This Month",
        "Earned Time Off": "Earned Time Off",
        "Weekly Progress": "Weekly Progress",
        "Hours worked this week": "Hours worked this week",
        "Remaining": "Remaining",
        "Overtime": "Overtime",
        "Weekly Goal": "Weekly Goal",
        "Completed": "Completed",
        "In Progress": "In Progress",
        "Status": "Status",
        "Under Target": "Under Target",
        "On Track": "On Track",
        "Efficiency": "Efficiency",
  
        // Vehicle translations
        "Vehicle handbook": "Vehicle handbook",
        "Check in to a vehicle to open its handbook from this menu.":
          "Check in to a vehicle to open its handbook from this menu.",
        "Vehicle handbook could not be opened. Try again or contact an administrator.":
          "Vehicle handbook could not be opened. Try again or contact an administrator.",
        "Go to trips": "Go to trips",
        "Vehicle handbook entry subtitle":
          "Check in, then open the handbook for your current vehicle.",
        "Vehicle handbook check in": "Check in to vehicle",
        "Vehicle handbook check in hint":
          "Choose a vehicle to check in; you are then taken to its handbook.",
        "Vehicle handbook not a driver":
          "You are not registered as a driver in this company. Ask an administrator if you need driving access.",
        "Vehicle handbook no vehicles permission":
          "You need permission to use the vehicle list to check in from here. You may still check in from Trips or the dashboard if available.",
        "Vehicle Information": "Vehicle Information",
        "Number Plate": "Number Plate",
        "VIN (Chassis Number)": "VIN (Chassis Number)",
        "Make": "Make",
        "Model": "Model",
        "Model Year": "Model Year",
        "Body Style": "Body Style",
        "Nickname": "Nickname",
        "Current Odometer (km)": "Current Odometer (km)",
        "Description": "Description",
        "Statens Vegvesen Information": "Statens Vegvesen Information",
        "Norwegian Vehicle Authority Information":
          "Norwegian Vehicle Authority Information",
        "Registration Date": "Registration Date",
        "First Registration": "First Registration",
        "Vehicle Type": "Vehicle Type",
        "Fuel Type": "Fuel Type",
        "Engine Size (cc)": "Engine Size (cc)",
        "Power (kW)": "Power (kW)",
        "Inspection Information": "Inspection Information",
        "EU-kontroll / Periodic Vehicle Inspection":
          "EU-kontroll / Periodic Vehicle Inspection",
        "Last Inspection Date": "Last Inspection Date",
        "Next Inspection Date": "Next Inspection Date",
        "Inspection Result": "Inspection Result",
        "Inspection Station": "Inspection Station",
        "Insurance Information": "Insurance Information",
        "Vehicle Insurance Details": "Vehicle Insurance Details",
        "Insurance Company": "Insurance Company",
        "Policy Number": "Policy Number",
        "Insurance Start Date": "Insurance Start Date",
        "Insurance End Date": "Insurance End Date",
        "Insurance Type": "Insurance Type",
        "Annual Premium (NOK)": "Annual Premium (NOK)",
        "Service Information": "Service Information",
        "Maintenance and Service Details": "Maintenance and Service Details",
        "Last Service Date": "Last Service Date",
        "Next Service Date": "Next Service Date",
        "Service Interval (km)": "Service Interval (km)",
        "Service Provider": "Service Provider",
        "Warranty End Date": "Warranty End Date",
        "Warranty Type": "Warranty Type",
        "Damage Reports": "Damage Reports",
        "Vehicle Damage History": "Vehicle Damage History",
        "Damage reports will be implemented in the future":
          "Damage reports will be implemented in the future",
        "Internal Controls": "Internal Controls",
        "Company Internal Vehicle Controls": "Company Internal Vehicle Controls",
        "Last Internal Check": "Last Internal Check",
        "Next Internal Check": "Next Internal Check",
        "Safety Equipment Status": "Safety Equipment Status",
        "Vehicle Status": "Vehicle Status",
        "Trips": "Trips",
        "Service": "Service",
        "Documents": "Documents",
        "Vehicle": "Vehicle",
        "Vehicle Documents": "Vehicle Documents",
        "Manage vehicle documents and files":
          "Manage vehicle documents and files",
        "Vehicle Trips": "Vehicle Trips",
        "trips found": "trips found",
        "No trips found for this vehicle": "No trips found for this vehicle",
        "Vehicle safety and maintenance checklists":
          "Vehicle safety and maintenance checklists",
        "Create Checklist": "Create Checklist",
        "Last Internal Control": "Last Internal Control",
        "Checklist Number": "Checklist Number",
        "Items Approved": "Items Approved",
        "Checklist Items": "Checklist Items",
        "Approved": "Approved",
        "Not Approved": "Not Approved",
        "No checklists found": "No checklists found",
        "Get started by creating a new checklist":
          "Get started by creating a new checklist",
        "Select Checklist Type": "Select Checklist Type",
        "Choose the type of checklist you want to create for this vehicle":
          "Choose the type of checklist you want to create for this vehicle",
        "Create a new checklist for this project":
          "Create a new checklist for this project",
        "Choose the type of checklist you want to create for this project":
          "Choose the type of checklist you want to create for this project",
        "Project checklist title": "Project checklist #{{number}}{{suffix}}",
        "Customer checklist title": "Customer checklist #{{number}}{{suffix}}",
        "Folder checklist title": "Folder checklist #{{number}}{{suffix}}",
        "Generic new checklist title": "Checklist #{{number}} ({{date}})",
        "Report checklist default title": "Report {{number}} - {{address}}",
        "Choose the type of checklist you want to create for this report":
          "Choose the type of checklist you want to create for this report",
        "Choose the type of checklist you want to create for this folder":
          "Choose the type of checklist you want to create for this folder",
        "Choose the type of checklist you want to create for this customer":
          "Choose the type of checklist you want to create for this customer",
        "Choose the type of checklist you want to create":
          "Choose the type of checklist you want to create",
        "Checklist title placeholder": "Enter a title for the checklist",
        "Checklist title edit hint":
          "Suggested automatically — change the title if you want before choosing a type.",
        "Title": "Title",
        "Enter checklist title": "Enter checklist title",
        "No checklist types available": "No checklist types available",
        "items": "items",
        "Basic Information": "Basic Information",
        "Enter checklist basic details": "Enter checklist basic details",
        "Define checklist items and requirements":
          "Define checklist items and requirements",
        "Upload required documents": "Upload required documents",
        "Review & Create": "Review & Create",
        "Review and create the checklist": "Review and create the checklist",
        "Title is required": "Title is required",
        "Description is required": "Description is required",
        "Date is required": "Date is required",
        "Item title is required": "Item title is required",
        "At least one item is required": "At least one item is required",
        "Please fix the errors before continuing":
          "Please fix the errors before continuing",
        "Create New Checklist": "Create New Checklist",
        "Checklist Summary": "Checklist Summary",
        "Items Count": "Items Count",
        "Not specified": "Not specified",
        "Mark as finished": "Mark as finished",
        "Mark as approved": "Mark as approved",
        "Previous": "Previous",
        "Show all": "Show all",
        "Show in new tab": "Show in new tab",
  
        // Journal translations
        "journal": "Journal",
        "journal.title": "Journal Title",
        "journal.description": "Journal Description",
        "journal.date": "Journal Date",
        "journal.next_follow_up": "Next Follow-up Date",
        "journal.status": "Journal Status",
        "journal.create": "Create Journal Entry",
        "journal.update": "Update Journal Entry",
        "journal.delete": "Delete Journal Entry",
        "journal.entries": "Journal Entries",
        "journal.no_entries": "No journal entries found",
        "journal.add_entry": "Add Journal Entry",
        "journal.edit_entry": "Edit Journal Entry",
        "journal.entry_created": "Journal entry created successfully",
        "journal.entry_updated": "Journal entry updated successfully",
        "journal.entry_deleted": "Journal entry deleted successfully",
        "journal.follow_up_reminder": "Follow-up Reminder",
        "journal.service_documentation": "Service Documentation",
        "journal.calibration_record": "Calibration Record",
        "journal.repair_record": "Repair Record",
        "journal.maintenance_record": "Maintenance Record",
  
        // Tool translations
        "tool": "Tool",
        "tools": "Tools",
        "tool.title": "Tool Title",
        "tool.number": "Tool Number",
        "tool.description": "Tool Description",
        "tool.status": "Tool Status",
        "tool.category": "Tool Category",
        "tool.brand": "Tool Brand",
        "tool.model": "Tool Model",
        "tool.serial_number": "Serial Number",
        "tool.purchase_date": "Purchase Date",
        "tool.purchase_price": "Purchase Price",
        "tool.supplier.label": "Purchased from (supplier)",
        "tool.supplier.placeholder": "Select supplier",
        "tool.supplier.select_one": "Select supplier",
        "tool.supplier.select_multiple": "Select suppliers",
        "tool.supplier.search_placeholder": "Search suppliers…",
        "tool.supplier.empty": "No suppliers found. Try another search.",
        "tool.supplier.load_more": "Load more",
        "tool.supplier.clear": "Clear selection",
        "tool.supplier.load_error": "Could not load suppliers",
        "tool.supplier.selected_count": "{{count}} selected",
        "tool.service_interval": "Service Interval (days)",
        "tool.last_service": "Last Service",
        "tool.next_service": "Next Service",
        "tool.service_overdue": "Service Overdue",
        "tool.service_due_soon": "Service Due Soon",
        "tool.create": "Create Tool",
        "tool.update": "Update Tool",
        "tool.delete": "Delete Tool",
        "tool.overview": "Tool Overview",
        "tool.manage_tools": "Manage Tools",
        "tool.no_tools": "No tools found",
        "tool.add_tool": "Add Tool",
        "tool.edit_tool": "Edit Tool",
        "tool.tool_created": "Tool created successfully",
        "tool.tool_updated": "Tool updated successfully",
        "tool.tool_deleted": "Tool deleted successfully",
        "tool.service_overview": "Service Overview",
        "tool.upcoming_services": "Upcoming Services",
        "tool.overdue_services": "Overdue Services",
        "tool.total_tools": "Total Tools",
        "tool.active_tools": "Active Tools",
        "tool.quick_row_label": "—",
        "tool.quick_new": "New",
        "tool.quick_add_placeholder": "Title — press Tab or Enter to save",
        "tool.next_number_hint_title": "Next suggested tool number for new rows",
        "tool.quick_add_tab_hint": "Tab / Enter",
        "tool.active_column": "Active",
        "tool.assign_short": "Assign",
        "tool.duplicate": "Copy",
        "tool.duplicate_created": "Tool copied",
        "tool.number_auto_placeholder": "Next: {{next}} (leave empty to auto-assign)",
  
        // Tool Category translations
        "tool.categories": "Tool Categories",
        "tool.category.name": "Category Name",
        "tool.category.description": "Category Description",
        "tool.category.create": "Create Tool Category",
        "tool.category.update": "Update Tool Category",
        "tool.category.delete": "Delete Tool Category",
        "tool.category.no_categories": "No tool categories found",
        "tool.category.add_category": "Add Tool Category",
        "tool.category.edit_category": "Edit Tool Category",
        "tool.category.created": "Tool category created successfully",
        "tool.category.updated": "Tool category updated successfully",
        "tool.category.deleted": "Tool category deleted successfully",
        "tool.category.manage_title": "Tool categories",
        "tool.category.all_categories": "All categories",
        "tool.category.new_category": "New",
        "tool.category.delete_confirm": "Delete this category?",
        "tool.category.delete_confirm_with_tools":
          "This category is linked to {{count}} tool(s). Delete anyway?",
        "tool.category.delete_failed": "Could not delete the category",
        "tool.category.tools_count": "{{count}} tools",
  
        // Tool Brand translations
        "tool.brands": "Tool Brands",
        "tool.brand.name": "Brand Name",
        "tool.brand.description": "Brand Description",
        "tool.brand.create": "Create Tool Brand",
        "tool.brand.update": "Update Tool Brand",
        "tool.brand.delete": "Delete Tool Brand",
        "tool.brand.no_brands": "No tool brands found",
        "tool.brand.add_brand": "Add Tool Brand",
        "tool.brand.edit_brand": "Edit Tool Brand",
        "tool.brand.created": "Tool brand created successfully",
        "tool.brand.updated": "Tool brand updated successfully",
        "tool.brand.deleted": "Tool brand deleted successfully",
        "tool.brand.manage_title": "Tool brands",
        "tool.brand.all_brands": "All brands",
        "tool.brand.new_brand": "New",
        "tool.brand.delete_confirm": "Delete this brand?",
        "tool.brand.delete_confirm_with_tools":
          "This brand is linked to {{count}} tool(s). Delete anyway?",
        "tool.brand.delete_failed": "Could not delete the brand",
        "tool.brand.tools_count": "{{count}} tools",
        "tool.open": "Open",
        "tool.back_to_overview": "Back to tools",
        "tool.assigned_user_column": "Assigned to",
        "tool.assignment_heading": "Assignment",
        "tool.assignment_hint":
          "Assign this tool to an employee, or return it to stock (unassign).",
        "tool.assigned_to": "Assigned to",
        "tool.not_assigned": "Not assigned",
        "tool.assign_user": "Assign to user",
        "tool.reassign_user": "Change assignee",
        "tool.return_from_user": "Return (unassign)",
        "tool.assign_saved": "Assignment updated",
        "tool.return_saved": "Tool returned (unassigned)",
        "tool.notes_heading": "Tool notes",
        "tool.notes_hint":
          "Internal notes about this tool (not shown on journal/service list).",
        "tool.notes_placeholder": "Write notes…",
        "tool.save_notes": "Save notes",
        "tool.notes_saved": "Notes saved",
        "tool.completed_service_intervals": "Completed service intervals",
        "tool.completed_service_intervals_hint":
          "Journal entries marked completed with “service” in the title (same rule as next service calculation).",
        "tool.no_completed_service_intervals":
          "No completed service intervals recorded yet.",
        "tool.journal_other_hint":
          "Other journal entries (active, planned follow-ups, non-service, etc.).",
        "tool.journal_empty_hint": "Add a journal entry for service or notes.",
        "tool.journal_no_other_entries": "No other journal entries.",
        "tool.print_label": "Print sign / label",
        "tool.usage_history_heading": "Assignment history",
        "tool.usage_history_hint":
          "Who had the tool, for how many days (calendar days, inclusive), and whether the period ended with a return or a handover to another user.",
        "tool.usage_history_empty": "No history yet. History is recorded when you assign, reassign, or return the tool.",
        "tool.usage_user": "User",
        "tool.usage_from": "From",
        "tool.usage_to": "To",
        "tool.usage_days": "Days",
        "tool.usage_outcome": "How it ended",
        "tool.usage_status": "Status",
        "tool.usage_status_active": "Active loan",
        "tool.usage_status_ended": "Ended",
        "tool.usage_reason.return": "Returned (unassigned)",
        "tool.usage_reason.reassign": "Handed to another user",
        "tool.employee_tools_title": "Tools",
        "tool.employee_tools_intro_title": "Your assigned tools",
        "tool.employee_tools_intro":
          "A simple overview of tools registered to you, including assignment date and key details.",
        "tool.employee_tools_short": "Your assigned tools.",
        "tool.employee_tools_loading": "Loading tools...",
        "tool.employee_tools_load_error": "Could not load tools.",
        "tool.employee_tools_empty_title": "No assigned tools",
        "tool.employee_tools_empty": "No tools are registered to you.",
        "tool.employee_tools_assigned_on": "Taken into use",
        "tool.employee_tools_unknown_date": "Unknown date",
        "tool.employee_tools_no_service": "No planned service",
        "tool.employee_tools_days_held": "{{count}} days in use",
  
        // Tool Status translations
        "tool.status.active": "Active",
        "tool.status.inactive": "Inactive",
        "tool.status.maintenance": "Under Maintenance",
        "tool.status.retired": "Retired",
  
        // Journal Status translations
        "journal.status.active": "Active",
        "journal.status.completed": "Completed",
        "journal.status.archived": "Archived",
  
        // Personalhåndbok translations
        "Personalhåndbok": "Personalhåndbok",
        "personalhåndbok.description":
          "Access to company guidelines, safety procedures, and employee information",
        "Open": "Open",
        "HMS Guidelines": "Rutiner",
        "Safety procedures and guidelines": "Safety procedures and guidelines",
        "Instructions": "Retningslinjer",
        "Company policies and procedures": "Company policies and procedures",
        "Instruction Chapters": "Retningslinjer - Kapitler",
        "Chapter": "Kapittel",
        "Create Chapter": "Opprett kapittel",
        "Update Chapter": "Oppdater kapittel",
        "Chapter Number": "Kapittel nummer",
        "Parent Chapter": "Overordnet kapittel",
        "Sub Chapters": "Underkapitler",
        "No chapter number": "Ingen kapittel nummer",
        "Colleagues": "Colleagues",
        "Team overview and contacts": "Team overview and contacts",
        "Overview": "Overview",
        "Recent HMS Guidelines": "Recent HMS Guidelines",
        "Recent Instructions": "Recent Instructions",
        "Recent KS/HMS Documents": "Recent KS/HMS Documents",
        "KS/HMS Documents": "KS/HMS Documents",
        "employee_handbook.pending_read_ack_title":
          "KS/HMS: documents awaiting your confirmation",
        "employee_handbook.pending_read_ack_body":
          "You have {count} document(s) not yet confirmed as read and understood. Open each document to confirm, or use the full HSE/KS view.",
        "employee_handbook.all_documents_acknowledged":
          "You have confirmed all KS/HMS documents available to you (read and understood).",
        "employee_handbook.read_status_acknowledged": "Read and confirmed",
        "employee_handbook.read_status_pending": "Confirmation missing",
        "employee_handbook.read_status_creator_exempt": "Author (exempt)",
        "employee_handbook.go_to_documents_tab": "Go to KS/HMS documents",
        "employee_handbook.open_full_document": "Open full page (HSE/KS)",
        "dashboard_report.handbook_read_incomplete":
          "{pending} of {total} KS/HMS documents still need read/understood confirmation.",
        "employee_handbook.stat_line_pending":
          "{count} document(s) still need read/understood confirmation.",
        "Kapitler": "Chapters",
        "Dokumenter uten kapittel": "Documents without chapter",
        "Dokumenter som ikke er tilknyttet noe kapittel": "Documents that are not linked to any chapter",
        "Søk etter dokumenter...": "Search for documents...",
        "Fant {count} dokumenter": "Found {count} documents",
        "Ingen dokumenter funnet": "No documents found",
        "Prøv å endre søkeordene dine": "Try changing your search terms",
        "Laster dokument...": "Loading document...",
        "Ingen innhold tilgjengelig": "No content available",
        "Dokumenter uten bransje": "Documents without discipline",
        "Dokumenter uten kategori": "Documents without category",
        "Dokumenter uten bransje og kategori": "Documents without discipline and category",
        "No chapter": "No chapter",
        "Employee Handbook": "Employee Handbook",
  
        // Action creation dialog
        "deviation.create_action": "Create Action",
        "deviation.saving": "Saving...",
  
        // Action creation dialog
        "deviation.action.create.question": "Do you want to create actions?",
        "deviation.action.create.description":
          "You can create concrete actions with deadline, responsible person and description.",
        "deviation.action.create.yes": "Yes, create action",
        "deviation.action.create.no": "No, not now",
        "deviation.action.notes": "Action notes (optional)",
        "deviation.action.notes.placeholder":
          "Add notes about actions if necessary...",
        "deviation.form.type_category_hint":
          "Choose the category that best describes this deviation.",
        "deviation.form.search_types": "Search deviation types…",
        "deviation.form.no_matching_types": "No matching types",
  
        // HSE Events translations
        "HSE-hendelser": "HSE Events",
        "Håndter helse-, sikkerhets- og miljøhendelser":
          "Manage health, safety and environment events",
        "Ny HSE-hendelse": "New HSE Event",
        "Søk i HSE-hendelser...": "Search HSE events...",
        "Filtre": "Filters",
        "Ingen HSE-hendelser funnet": "No HSE events found",
        "Viser": "Showing",
        "av": "of",
        "resultater": "results",
        "Forrige": "Previous",
        "Neste": "Next",
        "Rediger HSE-hendelse": "Edit HSE Event",
        "HSE-statistikk": "HSE Statistics",
        "Er du sikker på at du vil slette denne HSE-hendelsen?":
          "Are you sure you want to delete this HSE event?",
        "HSE-hendelse ble slettet": "HSE event was deleted",
        "Kunne ikke slette HSE-hendelse": "Could not delete HSE event",
        "HSE-hendelse ble opprettet": "HSE event was created",
        "HSE-hendelse ble oppdatert": "HSE event was updated",
        "Kunne ikke opprette HSE-hendelse": "Could not create HSE event",
        "Kunne ikke lagre HSE-hendelse": "Could not save HSE event",
        "Kunne ikke laste HSE-hendelser": "Could not load HSE events",
  
        // HSE Event Form translations
        "Grunnleggende informasjon": "Basic Information",
        "Tittel": "Title",
        "Angi tittel for hendelsen": "Enter title for the event",
        "Dato": "Date",
        "Tidspunkt": "Time",
        "Hendelsestype": "Event Type",
        "Velg hendelsestype": "Select event type",
        "Alvorlighetsgrad": "Severity Level",
        "Velg alvorlighetsgrad": "Select severity level",
        "Beskrivelse": "Description",
        "Beskriv hendelsen detaljert...": "Describe the event in detail...",
        "Sted og avdeling": "Location and Department",
        "Sted": "Location",
        "Avdeling": "Department",
        "Bygg/Område": "Building/Area",
        "Rom/Område": "Room/Area",
        "Detaljert beskrivelse av stedet": "Detailed description of location",
        "Beskriv stedet mer detaljert...":
          "Describe the location in more detail...",
        "Involverte personer": "People Involved",
        "Ansvarlig person": "Responsible Person",
        "Velg ansvarlig person": "Select responsible person",
        "Vitner": "Witnesses",
        "Kategorisering": "Categorization",
        "Kategori": "Category",
        "Velg kategori": "Select category",
        "Umiddelbar årsak": "Immediate Cause",
        "Underliggende årsak": "Underlying Cause",
        "Detaljert kategorisering": "Detailed categorization",
        "Beskriv kategoriseringen mer detaljert...":
          "Describe the categorization in more detail...",
        "Analyse og tiltak": "Analysis and Actions",
        "Årsakanalyse påkrevd": "Root cause analysis required",
        "Strakstiltak påkrevd": "Immediate actions required",
        "Årsakanalyse": "Root Cause Analysis",
        "Beskriv årsakanalysen...": "Describe the root cause analysis...",
        "Strakstiltak": "Immediate Actions",
        "Beskriv strakstiltakene...": "Describe the immediate actions...",
        "Forslag til tiltak": "Suggested Actions",
        "Beskriv forslag til tiltak...": "Describe suggested actions...",
        "Tilknyttede elementer": "Related Elements",
        "Dokumenter": "Documents",
        "Avbryt": "Cancel",
        "Oppdater": "Update",
        "Opprett": "Create",
        "Create": "Create",
        "Update": "Update",
        "Lagrer...": "Saving...",
        "Laster...": "Loading...",
  
        // HSE Event Types
        "Skade": "Injury",
        "Nærhendelse": "Near Miss",
        "Materiellskade": "Property Damage",
        "Miljøhendelse": "Environmental Event",
        "Annet": "Other",
  
        // HSE Severity Levels
        "Lav": "Low",
        "Medium": "Medium",
        "Høy": "High",
        "Kritisk": "Critical",
  
        // HSE Event Categories
        "Avvik lov": "Law Violation",
        "Avvik forskrift": "Regulation Violation",
        "Brudd på prosedyre": "Procedure Violation",
        "Brudd på opplæring": "Training Violation",
        "Informasjon": "Information",
  
        // HSE Status
        "Kladd": "Draft",
        "Innsendt": "Submitted",
        "Under vurdering": "Under Review",
        "Lukket": "Closed",
  
        // Form validation
        "Tittel er påkrevd": "Title is required",
        "Dato er påkrevd": "Date is required",
        "Hendelsestype er påkrevd": "Event type is required",
        "Sted er påkrevd": "Location is required",
  
        // HSE Filters and Statistics
        "Alle typer": "All types",
        "Alle statuser": "All statuses",
        "Fra dato": "From date",
        "Til dato": "To date",
        "Nullstill": "Reset",
        "Bruk filtre": "Apply filters",
        "Kunne ikke laste statistikk": "Could not load statistics",
        "Totale hendelser": "Total events",
        "Nylige hendelser": "Recent events",
        "Forfalte tiltak": "Overdue actions",
        "Kritiske hendelser": "Critical events",
        "Hendelser etter type": "Events by type",
        "Hendelser etter status": "Events by status",
  
        // HSE Event Form - Additional translations
        "Hendelsesdato": "Event Date",
        "Hendelsestid": "Event Time",
        "Involverte personer beskrivelse":
          "List all persons involved in the event",
        "Vitner beskrivelse": "List any witnesses to the event",
        "Umiddelbar årsak beskrivelse":
          "Describe the immediate cause of the event",
        "Underliggende årsak beskrivelse":
          "Describe the underlying cause of the event",
        "Kategorisering beskrivelse":
          "Describe the categorization in more detail",
        "Årsakanalyse beskrivelse": "Describe the root cause analysis",
        "Strakstiltak beskrivelse": "Describe the immediate actions taken",
        "Forslag til tiltak beskrivelse":
          "Describe suggested actions to prevent recurrence",
        "Tilknyttede elementer beskrivelse":
          "Link related customers, projects, employees, and folders",
        "Dokumenter beskrivelse": "Upload relevant documents and files",
        "Velg avdeling": "Select Department",
        "Velg involverte personer": "Select Involved Persons",
        "Andre involverte personer": "Other Persons Involved",
        "Andre involverte personer beskrivelse":
          "Describe other persons involved in the event",
        "Beskriv andre involverte personer...":
          "Describe other involved persons...",
        "Søk etter personer...": "Search for persons...",
        "Ingen personer funnet": "No persons found",
        "Valgte personer": "Selected Persons",
        "Ingen personer tilgjengelig": "No persons available",
        "Fjern alle": "Remove All",
        "Legg til person": "Add Person",
        "Personer": "Persons",
        "Søk i personer...": "Search persons...",
        "Velg personer": "Select Persons",
        "Ingen personer valgt": "No persons selected",
        "Personer valgt": "Persons selected",
        "Bekreft": "Confirm",
        "personer valgt": "persons selected",
        "Nytt system": "New System",
        
        // Project Participants translations (English)
        "project.participants.title": "Participants",
        "project.participants.description": "Project participants and their roles",
        "project.participants.add": "Add Participant",
        "project.participants.add_first": "Add First Participant",
        "project.participants.edit": "Edit Participant",
        "project.participants.delete": "Delete Participant",
        "project.participants.delete_confirm": "Are you sure you want to remove this participant?",
        "project.participants.none": "No participants added yet.",
        "project.participants.user": "User",
        "project.participants.role": "Role",
        "project.participants.status": "Status",
        "project.participants.admin": "Admin",
        "project.participants.error_loading": "Error Loading Participants",
  
        // Project Activities translations (English)
        "project.activities.tab_title": "Activities",
        "project.activities.tab_hint":
          "Leave the title field (Tab or click outside) to save a new line. The next number is set automatically; Tripletex lines are handled in the background.",
        "project.activities.search_label": "Search",
        "project.activities.search_placeholder": "Search title, number, description…",
        "project.activities.filter_label": "Filter",
        "project.activities.filter_all": "All",
        "project.activities.filter_standard": "Standard only",
        "project.activities.filter_additional": "Additional work only",
        "project.activities.add_quick": "New row",
        "project.activities.draft_title_placeholder": "Title — Tab to save and add next",
        "project.activities.deleted": "Activity removed",
        "project.activities.title": "Activities",
        "project.activities.description":
          "Lines used for hours and price estimates. Manage them in the Activities tab on the project.",
        "project.activities.description_field": "Description",
        "project.activities.activity_line": "Tripletex activity line",
        "project.activities.activity_line_hint":
          "Optional. Links this row to a project activity line for Tripletex.",
        "project.activities.is_additional": "Additional",
        "project.activities.title_required": "Title is required",
        "project.activities.delete_error": "Could not delete activity",
        "project.activities.add": "Add Activity",
        "project.activities.add_first": "Add First Activity",
        "project.activities.edit": "Edit Activity",
        "project.activities.delete": "Delete Activity",
        "project.activities.delete_confirm": "Are you sure you want to remove this activity?",
        "project.activities.none": "No activities added yet.",
        "project.activities.activity": "Activity",
        "project.activities.number": "Number",
        "project.activities.budget_hours": "Budget Hours",
        "project.activities.budget_fee": "Budget Fee",
        "project.activities.invoiceable": "Invoiceable",
        "project.activities.error_loading": "Error Loading Activities",
  
        // Project sync status (English)
        "project.synced": "Synced",
        "project.not_synced": "Not Synced",
        
        // Additional project translations (English)
        "project.participants.updated": "Participant updated successfully",
        "project.participants.created": "Participant added successfully",
        "project.participants.save_error": "Failed to save participant",
        "project.participants.user_required": "User is required",
        "project.participants.role_required": "Role is required",
        "project.participants.admin_access": "Admin Access",
        "project.participants.updating": "Updating...",
        "project.participants.adding": "Adding...",
        
        "project.activities.updated": "Activity updated successfully",
        "project.activities.created": "Activity added successfully",
        "project.activities.save_error": "Failed to save activity",
        "project.activities.activity_required": "Activity is required",
        "project.activities.title_field": "Title",
        "project.activities.start_date": "Start Date",
        "project.activities.end_date": "End Date",
        "project.activities.budget_fee_rate": "Budget Fee Rate",
        "project.activities.inactive": "Inactive",
        "project.activities.updating": "Updating...",
        "project.activities.adding": "Adding...",
        "project.activities.summary_title": "Overview",
        "project.activities.summary_hours": "Hours (logged / budget)",
        "project.activities.summary_activities_done": "Activities completed",
        "project.activities.summary_budget_fee": "Total budget fee",
        "project.activities.summary_budget_fee_hint": "Sum of budget fee on all activities (for reference).",
        "project.activities.hours_unit": "h",
        "project.activities.hours_unit_short": "h",
        "project.activities.of_total_budget_hours": "of budgeted hours (project)",
        "project.activities.completed_label": "completed",
        "project.activities.currency_nok": "NOK",
        "project.activities.mode_view": "View mode",
        "project.activities.mode_edit": "Edit mode",
        "project.activities.status_label": "Status",
        "project.activities.status.open": "Open",
        "project.activities.status.in_progress": "In progress",
        "project.activities.status.completed": "Completed",
        "project.activities.status.on_hold": "On hold",
        "project.activities.edit_dialog_title": "Activity details",
        "project.activities.progress_section": "Progress",
        "project.activities.logged_vs_budget": "{{logged}} h logged · {{budget}} h budget",
        "project.activities.of_budget_hours": "of this activity’s budget hours",
        "project.activities.linked_work_orders": "{{count}} linked work order(s)",
        "project.activities.linked_work_orders_label": "Work orders on this activity",
        "project.activities.no_description": "No description.",
        "project.activities.period": "Period",
        "project.activities.new_work_order": "New work order",
        "project.activities.open_work_orders_tab": "Open work orders tab",
        "project.activities.open_time_tab": "Open time registration",
        "project.activities.logged_short": "Logged",
        "project.activities.status_progress_title": "Status and progress",
        
        // Project Plan translations (English)
        "project.plan.title": "Project Plan",
        "project.plan.subtitle": "Plan and manage project events",
        "project.plan.select_project": "Select Project",
        "project.plan.select_project_first": "Please select a project first",
        "project.plan.project": "Project",
        "project.plan.no_events": "No events in this period",
        "project.plan.total": "Total",
        "project.plan.loading": "Loading events...",
        "project.plan.week": "Week",
        "project.plan.resource_capacity": "Resource capacity",
        "project.plan.resource_capacity_subtitle":
          "Compares the Hours resource plan with planned project events and work orders in the selected period.",
        "project.plan.loading_resource_plan": "Loading resource plan...",
        "project.plan.capacity.events": "Events",
        "project.plan.capacity.available": "Available",
        "project.plan.capacity.assigned": "Assigned",
        "project.plan.capacity.scheduled_hours": "Work schedule hours",
        "project.plan.capacity.free_hours": "Free hours",
        "project.plan.capacity.assigned_of_available": "{{assigned}} of {{available}} resources used",
        "project.plan.capacity.free_hours_value": "{{hours}}h free",
        "project.plan.capacity.events_value": "{{count}} event(s)",
        "No project": "No project",
        "No activity": "No activity",
        
        // Project Plan Preview translations (English)
        "project.plan.preview.title": "Project Plan",
        "project.plan.preview.subtitle": "Upcoming events and schedule",
        "project.plan.preview.go_to_full_plan": "Go to Full Plan",
        "project.plan.preview.loading": "Loading events...",
        "project.plan.preview.error": "Error loading events",
        "project.plan.preview.no_events": "No upcoming events",
        "project.plan.preview.untitled_event": "Untitled Event",
        "project.plan.preview.resource": "resource",
        "project.plan.preview.resources": "resources",
        "project.plan.preview.view_all": "View all {{count}} events",

        "crew.panel.title": "Crew & shifts",
        "crew.panel.subtitle": "Today’s roster, absence and time punches (requires «Crew scheduling» company module)",
        "crew.panel.loading": "Loading crew…",
        "crew.panel.error": "Could not load crew data",
        "crew.panel.no_project": "Select a project to view crew",
        "crew.panel.shifts": "Shifts",
        "crew.panel.absences": "Absence today",
        "crew.panel.open_punches": "Open punches",
        "crew.panel.clock_in": "Clock in",
        "crew.panel.clock_out": "Clock out",
        "crew.panel.checklists": "Checklists",
        "crew.panel.seed_checklists": "Create default checklist types",
        "crew.panel.hours": "Hours",
        "crew.panel.open_full": "Open module",
        "crew.page.kicker": "Planning",
        "crew.page.title": "Crew and shifts",
        "crew.page.subtitle": "Plan shifts, manage availability, time punches, kiosk and leader overview",
        "crew.tabs.shifts": "Shift plan",
        "crew.tabs.mine": "My shifts",
        "crew.tabs.availability": "Availability",
        "crew.tabs.punch": "Time punch",
        "crew.tabs.kiosk": "Kiosk",
        "crew.tabs.leader": "Leader",
        "crew.tabs.leader_alerts": "Compliance and alerts",
        "crew.tabs.payroll": "Payroll basis",
        "crew.stats.shifts": "Shifts",
        "crew.stats.assignments": "Assignments",
        "crew.stats.open_punches": "Open punches",
        "crew.stats.alerts": "Alerts",
        "crew.filters.title": "Planning filters",
        "crew.filters.subtitle": "Choose project, period and active day for the week view.",
        "crew.filters.project": "Project",
        "crew.filters.date": "Date",
        "crew.filters.period": "Period",
        "crew.filters.period_from": "Period from",
        "crew.filters.period_to": "Period to",
        "crew.filters.active_day": "Active day",
        "crew.filters.density": "View",
        "crew.filters.days": "days",
        "crew.filters.this_week": "This week",
        "crew.filters.next_week": "Next week",
        "crew.filters.this_month": "This month",
        "crew.density.cozy": "Cozy",
        "crew.density.compact": "Compact",
        "crew.shift.new": "New shift",
        "crew.shift.edit": "Edit shift",
        "crew.shift.copy": "Copy shift",
        "crew.shift.copy_short": "Copy",
        "crew.shift.new_short": "New shift",
        "crew.shift.step_info": "Info",
        "crew.shift.step_days_time": "Days and time",
        "crew.shift.next_days_time": "Next: days and time",
        "crew.shift.back_info": "Back to info",
        "crew.shift.title": "Title",
        "crew.shift.title_hint": "Short name that makes the shift easy to recognize, e.g. “Saturday evening food truck”.",
        "crew.shift.title_placeholder": "E.g. Saturday evening food truck",
        "crew.shift.role": "Role",
        "crew.shift.role_hint": "What the person will do on the shift, e.g. shift lead, kitchen, register, service or cleanup. Use “shift lead” when the person should also follow start/end checklists.",
        "crew.shift.role_placeholder": "E.g. Shift lead",
        "crew.shift.role_suggestions": "Choose a role suggestion or type manually",
        "crew.shift.roles.shift_lead": "Shift lead",
        "crew.shift.roles.cashier": "Register",
        "crew.shift.roles.kitchen": "Kitchen",
        "crew.shift.roles.service": "Service",
        "crew.shift.roles.runner": "Runner",
        "crew.shift.roles.cleanup": "Cleanup",
        "crew.shift.roles.closing": "Closing",
        "crew.shift.starts_at": "Start",
        "crew.shift.ends_at": "End",
        "crew.shift.project": "Project",
        "crew.shift.project_hint": "Links the shift to the correct project. This is used later for time punches and time registration so hours land on the right project.",
        "crew.shift.location": "Location",
        "crew.shift.location_hint": "Where the shift is performed, e.g. food truck name, address, event or department.",
        "crew.shift.location_placeholder": "E.g. Food truck downtown",
        "crew.shift.break_minutes": "Break (min)",
        "crew.shift.break_minutes_hint": "Planned break deducted from planned hours.",
        "crew.shift.slots": "Slots",
        "crew.shift.slots_hint": "How many people are needed on this shift.",
        "crew.shift.assignment_mode": "Assignment",
        "crew.shift.assignment_mode_hint": "Direct assignment gives the shift to the selected employee. Open shift offer lets employees respond to the offer.",
        "crew.shift.assignment_direct": "Direct assignment",
        "crew.shift.assignment_open": "Open shift offer",
        "crew.shift.response_deadline": "Response deadline",
        "crew.shift.response_deadline_hint": "Optional. Unanswered offers are hidden from employees after the deadline.",
        "crew.shift.leader_checklist_required": "Require leader checklists",
        "crew.shift.leader_checklist_required_hint": "Creates required startup and shutdown checklists for this shift. Useful for shift leads in food trucks, catering units and service teams.",
        "crew.shift.handover_note": "Handover note",
        "crew.shift.handover_note_hint": "Important information the next leader or shift should see.",
        "crew.shift.assigned_employee": "Employee on shift",
        "crew.shift.assigned_employee_hint": "Optional. Select an employee here to add the person directly to all selected days.",
        "crew.shift.month": "Month",
        "crew.shift.month_hint": "Choose the month to plan. Tick the days in the calendar below.",
        "crew.shift.from_time": "From time",
        "crew.shift.from_time_hint": "Start time used for all selected days.",
        "crew.shift.to_time": "To time",
        "crew.shift.to_time_hint": "End time used for all selected days. If the end is before the start, it is treated as an overnight shift ending the next day.",
        "crew.shift.single_day": "One day",
        "crew.shift.period_days": "Multiple days",
        "crew.shift.period_from": "Period from",
        "crew.shift.period_to": "Period to",
        "crew.shift.weekdays": "Select weekdays",
        "crew.shift.create_plan": "Create shift plan",
        "crew.shift.copy_plan": "Copy shift plan",
        "crew.shift.copy_assignments_hint": "{{count}} crew member(s) will be copied from the original shift unless you select another employee.",
        "crew.shift.overview_month": "Month",
        "crew.shift.overview_period": "Period",
        "crew.shift.days_with_shifts": "Days with shifts",
        "crew.shift.missing_days": "Days without plan",
        "crew.shift.planned_hours": "Planned hours",
        "crew.shift.month_overview": "Month overview",
        "crew.shift.month_overview_hint": "Green days have a shift plan. Light days are missing a plan.",
        "crew.shift.day_has_shifts": "{{count}} shift(s)",
        "crew.shift.day_missing": "Missing plan",
        "crew.shift.day_by_day": "Day by day",
        "crew.shift.day_shift_count": "{{count}} shift(s)",
        "crew.shift.selected_day_timeline": "Timeline for selected day",
        "crew.shift.no_shifts_selected_day": "No shifts on the selected day.",
        "crew.shift.add_shift_hint": "Select a day in the week or create a new shift to complete the plan.",
        "crew.shift.no_role": "No role",
        "crew.shift.no_days_selected": "No days selected in period",
        "crew.shift.ends_after_start": "End must be after start",
        "crew.shift.no_crew_added": "No crew added / shift offer sent",
        "crew.shift.publish": "Publish",
        "crew.shift.cancel": "Cancel",
        "crew.shift.cancel_reason": "Cancellation reason",
        "crew.assignment.add": "Add crew",
        "crew.assignment.add_short": "Add crew",
        "crew.assignment.accept": "Accept",
        "crew.assignment.decline": "Decline",
        "crew.availability.starts_at": "From",
        "crew.availability.ends_at": "To",
        "crew.availability.add_day": "Select day",
        "crew.availability.add_day_button": "Add day",
        "crew.availability.add_weekdays": "Add weekdays",
        "crew.availability.month": "Month",
        "crew.availability.remove_day": "Remove day",
        "crew.availability.no_days_selected": "No days selected",
        "crew.availability.selected_days": "Selected days",
        "crew.availability.selected_short": "Selected",
        "crew.availability.saved_short": "Saved",
        "crew.availability.from_time": "From time",
        "crew.availability.to_time": "To time",
        "crew.availability.status": "Status",
        "crew.availability.available": "Available",
        "crew.availability.unavailable": "Unavailable",
        "crew.availability.monthly_overview": "Availability by month",
        "crew.availability.month_stats": "{{days}} days · {{hours}} hours available",
        "crew.availability.loading": "Loading…",
        "crew.availability.no_entries": "No availability saved for the selected period.",
        "crew.punch.clocked_in": "You are clocked in",
        "crew.punch.choose_shift": "Choose a shift to clock in, or clock in without a shift.",
        "crew.punch.clock_in_without_shift": "Clock in without shift",
        "crew.punch.history": "Time punch history",
        "crew.punch.history_date": "Date",
        "crew.punch.history_in": "In",
        "crew.punch.history_out": "Out",
        "crew.punch.history_hours": "Hours",
        "crew.punch.history_status": "Status",
        "crew.punch.deviation_note": "Deviation / note",
        "crew.punch.deviation_note_placeholder": "Deviation, missing checklist item or note for the next leader...",
        "crew.punch.open": "Open",
        "crew.punch.closed": "Closed",
        "crew.punch.no_history": "No time punches in this period.",
        "crew.kiosk.title": "Kiosk / PIN",
        "crew.kiosk.help": "Use a shared signed-in device and personal PIN for employees.",
        "crew.kiosk.open": "Open PIN verification",
        "crew.kiosk.employee_number": "Employee number",
        "crew.kiosk.pin": "PIN",
        "crew.kiosk.verify": "Verify",
        "crew.kiosk.verify_title": "Verify PIN",
        "crew.kiosk.pin_admin_title": "Manage employee PIN",
        "crew.kiosk.save_pin": "Save PIN",
        "crew.kiosk.clear_pin": "Clear PIN",
        "crew.payroll.planned": "Planned",
        "crew.payroll.actual": "Actual",
        "crew.empty.shifts": "No shifts in the selected period.",
        "crew.empty.assignments": "No shift offers or assignments.",
        "crew.empty.alerts": "No alerts.",
        "crew.empty.payroll": "No payroll basis in this period.",
        "crew.checklists.handover_title": "Checklist handover",
        "crew.checklists.mark_completed": "Mark completed",
        "crew.checklists.no_runs": "No required shift checklists in this period.",
        "crew.checklists.kind.start": "Startup",
        "crew.checklists.kind.end": "Shutdown",
        "crew.checklists.status.pending": "Pending",
        "crew.checklists.status.in_progress": "In progress",
        "crew.checklists.status.completed": "Completed",
        "crew.alerts.time_punch_deviation_note": "Time punch deviation/note",
        "crew.alerts.required_shift_checklist_pending": "Required checklist is not completed",
        "crew.alerts.long_open_punch": "Long open time punch",
        "crew.alerts.planned_shift_missing_break": "Planned shift is missing break",
        "crew.alerts.high_hours_last_12_months": "High actual hours last 12 months",
        "crew.toast.saved": "Saved",
        "crew.toast.assignment_saved": "Crew added",
        "crew.toast.pin_verified": "PIN verified",
        "crew.toast.pin_saved": "PIN saved",
        "crew.toast.pin_cleared": "PIN cleared",
        "crew.toast.published": "Shift published",
        "crew.toast.cancelled": "Shift cancelled",
        "crew.toast.accepted": "Shift accepted",
        "crew.toast.declined": "Shift declined",
        "crew.toast.availability_saved": "Availability saved",
        "crew.toast.clocked_in": "Clocked in",
        "crew.toast.clocked_out": "Clocked out",
        "crew.toast.checklists_seeded": "Checklist types created",
        "crew.toast.checklist_completed": "Checklist marked completed",
        "crew.weekdays.monday": "Mon",
        "crew.weekdays.tuesday": "Tue",
        "crew.weekdays.wednesday": "Wed",
        "crew.weekdays.thursday": "Thu",
        "crew.weekdays.friday": "Fri",
        "crew.weekdays.saturday": "Sat",
        "crew.weekdays.sunday": "Sun",
        
        // Project Event translations (English)
        "project.event.create": "Create Event",
        "project.event.edit": "Edit Event",
        "project.event.title": "Title",
        "project.event.title_required": "Title is required",
        "project.event.title_placeholder": "Enter event title",
        "project.event.description": "Description",
        "project.event.description_placeholder": "Enter event description",
        "project.event.start_date": "Start Date",
        "project.event.start_date_required": "Start date is required",
        "project.event.end_date": "End Date",
        "project.event.end_date_invalid": "End date must be after start date",
        "project.event.days": "Days",
        "project.event.days_placeholder": "Number of days",
        "project.event.project": "Project",
        "project.event.work_order": "Work Order",
        "project.event.resources": "Resources (Employees)",
        "project.event.add_resource": "Add Resource",
        "project.event.no_resources": "No resources added. Add employees who will work on this event.",
        "project.event.resource": "Resource",
        "project.event.resource_employee": "Employee",
        "project.event.resource_start_time": "Start Time",
        "project.event.resource_end_time": "End Time",
        "project.event.save_error": "An error occurred while saving the event. Please try again.",
        
        // Meeting Minutes translations
        "meeting_minutes": "Meeting Minutes",
        "meeting_minutes.list": "Meeting Minutes",
        "meeting_minutes.new": "New Meeting Minutes",
        "meeting_minutes.edit": "Edit Meeting Minutes",
        "meeting_minutes.create": "Create Meeting Minutes",
        "meeting_minutes.update": "Update Meeting Minutes",
        "meeting_minutes.delete": "Delete Meeting Minutes",
        "meeting_minutes.search": "Search meeting minutes...",
        "meeting_minutes.no_results": "No meeting minutes found",
        "meeting_minutes.meeting_date": "Meeting Date",
        "meeting_minutes.meeting_type": "Meeting Type",
        "meeting_minutes.select_type": "Select meeting type",
        "meeting_minutes.type.employee_interview": "Employee Interview",
        "meeting_minutes.type.project_meeting": "Project Meeting",
        "meeting_minutes.type.other": "Other Meeting",
        "meeting_minutes.employee": "Employee",
        "meeting_minutes.select_employee": "Select employee",
        "meeting_minutes.participants": "Participants",
        "meeting_minutes.select_participants": "Select participants",
        "meeting_minutes.manual_participants": "Manual participants",
        "meeting_minutes.manual_participants.description": "Enter participants manually (comma separated)",
        "meeting_minutes.project": "Project",
        "meeting_minutes.select_project": "Select project",
        "meeting_minutes.title": "Title",
        "meeting_minutes.title.required": "Title is required",
        "meeting_minutes.description": "Description",
        "meeting_minutes.groups": "Groups",
        "meeting_minutes.add_group": "Add Group",
        "meeting_minutes.group.title": "Group Title",
        "meeting_minutes.group.title.required": "Group title is required",
        "meeting_minutes.group.description": "Group Description",
        "meeting_minutes.group.entries": "Entries",
        "meeting_minutes.group.add_entry": "Add Entry",
        "meeting_minutes.entry.description": "Description",
        "meeting_minutes.entry.description.required": "Description is required",
        "meeting_minutes.entry.deadline": "Deadline",
        "meeting_minutes.entry.responsible": "Responsible",
        "meeting_minutes.entry.select_responsible": "Select responsible person",
        "meeting_minutes.meeting_number": "Meeting #",
        "meeting_minutes.continue_meeting": "Continue Meeting",
        "meeting_minutes.continue_meeting.description": "Continue on the same meeting minutes (creates a new meeting entry)",
        "meeting_minutes.continue_success": "Meeting continued successfully",
        "meeting_minutes.continue_error": "Could not continue meeting",
        "meeting_minutes.basic_info": "Basic Information",
        "meeting_minutes.templates": "Templates",
        "meeting_minutes.templates.list": "Templates",
        "meeting_minutes.templates.new": "New Template",
        "meeting_minutes.templates.edit": "Edit Template",
        "meeting_minutes.templates.create": "Create Template",
        "meeting_minutes.templates.update": "Update Template",
        "meeting_minutes.templates.delete": "Delete Template",
        "meeting_minutes.templates.search": "Search templates...",
        "meeting_minutes.templates.no_results": "No templates found",
        "meeting_minutes.templates.use_template": "Use Template",
        "meeting_minutes.templates.copy_from": "Copy from previous meeting",
        "meeting_minutes.templates.select_template": "Select Template",
        "meeting_minutes.created": "Meeting minutes created successfully",
        "meeting_minutes.updated": "Meeting minutes updated successfully",
        "meeting_minutes.deleted": "Meeting minutes deleted successfully",
        "meeting_minutes.delete_confirm": "Are you sure you want to delete this meeting minutes?",
        "meeting_minutes.meetings": "Meetings",
        "meeting_minutes.create_error": "Could not create meeting minutes",
        "meeting_minutes.update_error": "Could not update meeting minutes",
        "meeting_minutes.delete_error": "Could not delete meeting minutes",
        "meeting_minutes.load_error": "Could not load meeting minutes",
        "meeting_minutes.template.created": "Template created successfully",
        "meeting_minutes.template.updated": "Template updated successfully",
        "meeting_minutes.template.deleted": "Template deleted successfully",
        "meeting_minutes.template.create_error": "Could not create template",
        "meeting_minutes.template.update_error": "Could not update template",
        "meeting_minutes.template.delete_error": "Could not delete template",
        "meeting_minutes.template.delete_confirm": "Are you sure you want to delete this template?",
        "meeting_minutes.template.load_error": "Could not load template",
        "meeting_minutes.add_meeting": "Add Meeting",
        "meeting_minutes.add_first_meeting": "Add First Meeting",
        "meeting_minutes.no_meetings": "No meetings yet",
        "meeting_minutes.points": "points",
        "meeting_minutes.add_point": "Add Point",
        "meeting_minutes.point.title": "Point Title",
        "meeting_minutes.point.description": "Point Description",
        "meeting_minutes.point.untitled": "Untitled Point",
        "meeting_minutes.point.create_error": "Could not create point",
        "meeting_minutes.point.update_error": "Could not update point",
        "meeting_minutes.point.delete_error": "Could not delete point",
        "meeting_minutes.point.delete_confirm": "Are you sure you want to delete this point?",
        "meeting_minutes.entry.add": "Add Entry",
        "meeting_minutes.entry.remove": "Remove",
        "meeting_minutes.entry.create_error": "Could not create entry",
        "meeting_minutes.entry.update_error": "Could not update entry",
        "meeting_minutes.entry.delete_error": "Could not delete entry",
        "meeting_minutes.entry.delete_confirm": "Are you sure you want to delete this entry?",
        "meeting_minutes.meeting.created": "Meeting created successfully",
        "meeting_minutes.meeting.create_error": "Could not create meeting",
        "meeting_minutes.meeting.load_error": "Could not load meeting",
        "meeting_minutes.meeting.finished": "Finished",
        "meeting_minutes.meeting.mark_finished": "Mark as Finished",
        "meeting_minutes.meeting.marked_finished": "Meeting marked as finished",
        "meeting_minutes.meeting.mark_finished_error": "Could not mark meeting as finished",
        "meeting_minutes.meeting.no_points": "No points added yet",
        "meeting_minutes.meeting.no_points_add_first": "No points added yet. Add your first point to get started.",
        "meeting_minutes.meeting.copy_options": "Copy Options",
        "meeting_minutes.meeting.copy_from_previous": "Copy from Previous Meeting",
        "meeting_minutes.meeting.no_copy": "Don't copy",
        "meeting_minutes.meeting.or": "OR",
        "meeting_minutes.meeting.no_template": "Don't use template",
        "meeting_minutes.employee.add_manual": "Add Manual Participant",
        "meeting_minutes.employee.manual_name": "Name",
        "meeting_minutes.employee.manual_email": "Email",
        "meeting_minutes.employee.manual_mobile": "Mobile",
        "meeting_minutes.employee.remove": "Remove",
        "meeting_minutes.meetings_created_separately": "Meetings are created separately. Go to the meetings list to add new meetings.",
        "meeting_minutes.group.update_error": "Could not update group",
        "meeting_minutes.group.delete_confirm": "Are you sure you want to delete this group?",
        "meeting_minutes.group.deleted": "Group deleted successfully",
        "meeting_minutes.group.delete_error": "Could not delete group",
        "meeting_minutes.group.delete": "Delete Group",
        "meeting_minutes.group.documents": "Group Documents",
        "meeting_minutes.entry.deleted": "Entry deleted successfully",
        "meeting_minutes.entry.documents": "Entry Documents",
        "meeting_minutes.changes_saved": "Changes saved",
        "meeting_minutes.from_previous_meeting": "From Previous Meeting",
        "meeting_minutes.read_only_reference": "Read-only reference",
        "meeting_minutes.collapse": "Collapse",
        "meeting_minutes.expand": "Expand",
        "meeting_minutes.entry.singular": "entry",
        "meeting_minutes.entry.plural": "entries",
        "meeting_minutes.image.uploaded": "{{count}} image(s) uploaded successfully",
        "meeting_minutes.others_editing": "Others are editing this meeting. Changes may be overwritten.",
        "meeting_minutes.point.edit": "Edit Point",
        "meeting_minutes.group.created": "Group created successfully",
        "meeting_minutes.group.updated": "Group updated successfully",
        "Saving...": "Saving...",
        
        // Drawings translations
        "drawings": "Drawings",
        "drawings.list": "Drawings",
        "drawings.new": "New Drawing",
        "drawings.edit": "Edit Drawing",
        "drawings.create": "Create Drawing",
        "drawings.update": "Update Drawing",
        "drawings.delete": "Delete Drawing",
        "drawings.search": "Search drawings...",
        "drawings.no_results": "No drawings found",
        "drawings.title": "Title",
        "drawings.title.required": "Title is required",
        "drawings.description": "Description",
        "drawings.project": "Project",
        "drawings.select_project": "Select project",
        "drawings.floor": "Floor",
        "drawings.floor.placeholder": "Enter floor number or name",
        "drawings.house": "House",
        "drawings.house.placeholder": "Enter house number or identifier",
        "drawings.document": "Drawing Document",
        "drawings.document.required": "Drawing document is required",
        "drawings.created": "Drawing created successfully",
        "drawings.updated": "Drawing updated successfully",
        "drawings.save_changes": "Save Changes",
        "drawings.no_changes": "No changes to save",
        "drawings.deleted": "Drawing deleted successfully",
        "drawings.delete_confirm": "Are you sure you want to delete this drawing?",
        "drawings.create_error": "Could not create drawing",
        "drawings.update_error": "Could not update drawing",
        "drawings.delete_error": "Could not delete drawing",
        "drawings.load_error": "Could not load drawing",
        "drawings.module.add": "Add Module",
        "drawings.module.arrow": "Arrow",
        "drawings.module.circle": "Circle",
        "drawings.module.rectangular": "Rectangular",
        "drawings.module.delete": "Delete Module",
        "drawings.module.delete_confirm": "Are you sure you want to delete this module?",
        "drawings.module.color": "Color",
        "drawings.module.filled": "Filled",
        "drawings.module.not_filled": "Not Filled",
        "drawings.module.move": "Move Module",
        
        // Events sidebar and scheduling
        "Events": "Events",
        "Your schedule for the selected day": "Your schedule for the selected day",
        "Loading events...": "Loading events...",
        "No events to show": "No events to show",
        "Event": "Event",
        "Conflict": "Conflict",
        "item_list_handling.pick_progress_short": "{{picked}}/{{total}} picked",
        "item_list_handling.pick_progress_tooltip": "Handling list: {{picked}} of {{total}} lines picked. List status: {{status}}.",
        "Planned time": "Planned time",
        "Start": "Start",
        "End": "End",
        "Location": "Location",
        "Assumed 60 min duration for conflict check": "Assumed 60 min duration for conflict check",
        "Executing Employee": "Executing Employee",
        "Agreement date": "Agreement date",
        "Fixed time": "Fixed time",
        "Timeframe from": "Timeframe from",
        "Timeframe to": "Timeframe to",
        "Appointment confirmation required": "Appointment confirmation required",
        "Send email to customer": "Send email to customer",
        "Phone number": "Phone number",
        "Email address": "Email address",
        "Manually confirm agreement": "Manually confirm agreement",
        "Send confirmation reminder": "Send confirmation reminder",
  
        // Customer Handler translations
        "customer.handler": "Customer Handler",
        "customer.handler.description": "Search for customers, create conversations and manage customer communications",
        "customer.handler.selected.section": "Selected customer",
        "customer.handler.related.information": "Related information",
        "customer.handler.open.customer.profile": "Open customer profile",
        "customer.handler.open.customer.profile.hint": "Opens the customer profile in a new tab",
        "customer.handler.no.contact.info": "No address, email or mobile on file",
        "customer.handler.edit.customer": "Edit customer",
        "customer.handler.edit.communication": "Edit",
        "customer.handler.communication.subject": "Subject",
        "customer.handler.communication.body": "Content",
        "customer.handler.communication.update.success": "Communication updated",
        "search.customer": "Search customer",
        "search.by.mobile.or.address": "Search by mobile number or address",
        "search.by.mobile.or.address.hint": "Enter mobile number or address to search",
        "searching": "Searching...",
        "search": "Search",
        "search.results": "Search results",
        "search.failed": "Search failed",
        "search.failed.server.error": "Server error occurred",
        "search.failed.server.error.message": "An error occurred while searching. Please try again. Do not create a new customer if you believe the customer already exists.",
        "search.failed.unexpected.response": "Unexpected response from server",
        "search.error.title": "Search Error",
        "search.error.hint": "Please try searching again. If the problem persists, contact support. Do not create a duplicate customer.",
        "create.conversation": "Create conversation",
        "name.or.mobile.required": "Name or mobile number is required",
        "unknown.customer": "Unknown customer",
        "conversation.saved": "Conversation saved",
        "conversation.saved.and.handled": "Conversation saved and handled",
        "failed.to.create.customer": "Failed to create customer",
        "communication.added": "Communication added",
        "failed.to.add.communication": "Failed to add communication",
        "communication.marked.processed": "Communication marked as processed",
        "communication.marked.unprocessed": "Communication marked as unprocessed",
        "failed.to.update.communication": "Failed to update communication",
        "no.communications.selected": "No communications selected",
        "communications.linked.to.case": "Communications linked to case",
        "failed.to.link.communications": "Failed to link communications",
        "selected.communications": "Selected communications",
        "link.to.case": "Link to case",
        "see.more": "See more",
        "mark.as.processed": "Mark as processed",
        "channel": "Channel",
        "direction": "Direction",
        "sent.at": "Sent",
        "start.time": "Start time",
        "end.time": "End time",
        "related": "Related",
        "processed": "Processed",
        "unprocessed": "Unprocessed",
        "created.by": "Created by",
        "street.address": "Gateadresse",
        "postal.code": "Postnummer",
        "city": "By",
        "conversation.date": "Samtaledato",
        "conversation.time": "Samtaletid",
        "conversation.note.placeholder": "Legg til notat om samtalen...",
        "save": "Lagre",
        "handle": "Behandle",
        "selected.customer": "Valgt kunde",
        "loading": "Laster...",
        "loading.customer": "Laster kunde...",
        "communications": "Kommunikasjoner",
        "inbound": "Innkommende",
        "outbound": "Utgående",
        "no.communications": "Ingen kommunikasjoner funnet",
        "no.cases": "Ingen saker funnet",
        "upcoming.events": "Kommende hendelser",
        "no.events": "Ingen hendelser funnet",
        "add.communication": "Legg til kommunikasjon",
        "pending": "Venter",
        "handled": "Behandlet",
        "Communication": "Communication",
        "Message": "Message",
        "Channel": "Channel",
        "Direction": "Direction",
        "Customer": "Customer",
        "link.to.case.choice.description": "Do you want to link to an existing case or create a new one?",
        "link.to.existing.case": "Link to existing case",
        "link.to.existing.case.description": "Search and select an existing case",
        "create.new.case": "Create new case",
        "create.new.case.description": "Create a new case and link communications",
        "search.case": "Search case",
        "search.case.placeholder": "Search by case number, title, or customer...",
        "no.cases.found": "No cases found",
        "cases": "Cases",
        "customer.cases": "Customer's cases",
        "case.empty.updates": "Ingen oppdateringer ennå",
        "case.empty.hint": "Skriv en oppdatering nedenfor for å komme i gang",
        "linking.communications": "Linking communications...",
        "treatment.section": "Treatment Section",
        "treatment.section.description": "All communications requiring treatment",
        "search.communications": "Search communications...",
        "all.statuses": "All statuses",
        "all.channels": "All channels",
        "phone": "Phone",
        "email": "Email",
        "sms": "SMS",
        "showing": "Showing",
        "of": "of",
        "customer.loaded": "Customer loaded",
        "customer.not.found": "Customer not found",
        "failed.to.load.communications": "Failed to load communications",
        "failed.to.load.customer": "Failed to load customer",
  
        // Inventory Count translations (English)
        "inventory.counts.title": "Inventory Counts",
        "inventory.counts.description": "Manage inventory counts and stocktaking",
        "inventory.count.title": "Inventory Count",
        "inventory.count.create": "New Count",
        "inventory.count.count_number": "Count Number",
        "inventory.count.date": "Date",
        "inventory.count.status": "Status",
        "inventory.count.status.draft": "Draft",
        "inventory.count.status.pending_approval": "Pending Approval",
        "inventory.count.status.approved": "Approved",
        "inventory.count.status.completed": "Completed",
        "inventory.count.add_item": "Add Item",
        "inventory.count.select_product": "Select Product",
        "inventory.count.scan_qr": "Scan QR Code",
        "inventory.count.import_csv": "Import CSV/Excel",
        "inventory.count.selected_products": "Selected Products",
        "inventory.count.item_number": "Item Number",
        "inventory.count.remove": "Remove",
        "inventory.count.note_optional": "Note (optional)",
        "inventory.count.note_placeholder": "Add note...",
        "inventory.count.reset": "Reset",
        "inventory.count.add_products": "Add Products",
        "inventory.count.add_product": "Add Product",
        "inventory.count.add_scanned_product": "Add Scanned Product",
        "inventory.count.scan_another": "Scan Another",
        "inventory.count.select_products": "Select Products",
        "inventory.count.products_selected": "{{count}} product(s) selected",
        "inventory.count.qr.required": "Enter or scan a QR code",
        "inventory.count.qr.placeholder": "Enter product number or scan QR code",
        "inventory.count.product.already_selected": "Product already selected",
        "inventory.count.product.added": "Product added",
        "inventory.count.product.not_found": "Product not found. Try manual search.",
        "inventory.count.product.search_error": "Could not search for product",
        "inventory.count.product.select_required": "Select at least one product",
        "inventory.count.items": "Items",
        "inventory.count.product": "Product",
        "inventory.count.quantity": "Quantity",
        "inventory.count.purchase_price": "Purchase Price",
        "inventory.count.total": "Total",
        "inventory.count.note": "Note",
        "inventory.count.total_items": "Total Items",
        "inventory.count.total_quantity": "Total Quantity",
        "inventory.count.no_items": "No Items",
        "inventory.count.no_items_description": "Add items to start the count",
        "inventory.count.item.added": "Item added successfully",
        "inventory.count.item.add_error": "Could not add item",
        "inventory.count.item.updated": "Item updated successfully",
        "inventory.count.item.update_error": "Could not update item",
        "inventory.count.item.deleted": "Item deleted successfully",
        "inventory.count.item.delete_error": "Could not delete item",
        "inventory.count.item.delete_confirm": "Are you sure you want to remove this item?",
        "inventory.count.quantity_required": "Quantity must be greater than 0",
        "inventory.count.csv.import_title": "Import Items from CSV/Excel",
        "inventory.count.csv.drop_here": "Drop file here",
        "inventory.count.csv.drop_or_select": "Drag and drop a file here, or click to select",
        "inventory.count.csv.supported_formats": "CSV, XLS, XLSX",
        "inventory.count.csv.file_selected": "File selected",
        "inventory.count.csv.change_file": "Change File",
        "inventory.count.csv.column_mapping": "Column Mapping",
        "inventory.count.csv.field.product_id": "Product ID",
        "inventory.count.csv.field.item_number": "Item Number",
        "inventory.count.csv.field.title": "Title",
        "inventory.count.csv.field.quantity": "Quantity",
        "inventory.count.csv.field.purchase_price": "Purchase Price",
        "inventory.count.csv.field.note": "Note",
        "inventory.count.csv.not_mapped": "Not mapped",
        "inventory.count.csv.preview": "Preview",
        "inventory.count.csv.first_rows": "first rows",
        "inventory.count.csv.import": "Import",
        "inventory.count.csv.importing": "Importing...",
        "inventory.count.csv.import_success": "Successfully imported {{count}} items",
        "inventory.count.csv.import_error": "Could not import items",
        "inventory.count.csv.bulk_create_error": "Could not create products in bulk",
        "inventory.count.csv.mapping_required": "Please map at least Product ID or Item Number",
        "inventory.count.csv.no_headers": "Could not detect CSV headers",
        "inventory.count.csv.read_error": "Error reading file",
        "inventory.count.csv.processing_error": "Error processing file",
        "inventory.count.csv.product_not_found": "Product not found",
        "inventory.count.csv.product_search_error": "Error searching for product",
        "inventory.count.csv.product_id_required": "Product ID or Item Number required",
        "inventory.count.csv.no_valid_items": "No valid items found in file",
        "inventory.count.csv.missing_products_title": "Products Not Found",
        "inventory.count.csv.missing_products_message": "{{count}} product(s) were not found in the system. Choose an action for each:",
        "inventory.count.csv.action": "Action",
        "inventory.count.csv.add_as_new": "Add as New Product",
        "inventory.count.csv.skip": "Skip",
        "inventory.count.csv.continue_import": "Continue Import",
        "inventory.count.csv.processing_items": "Processing {{current}} of {{total}} products",
        "inventory.count.csv.processing": "Processing...",
        "inventory.count.csv.partial_import_success": "Imported {{imported}} items, {{missing}} products not found",
        "inventory.count.csv.no_items_to_import": "No items to import",
        "inventory.count.duplicate.title": "Product Already in List",
        "inventory.count.duplicate.message": "This product is already in the count list. Do you want to add another line?",
        "inventory.count.duplicate.added_at": "Added at",
        "inventory.count.duplicate.confirm": "Add Another Line",
        "inventory.counts.search_placeholder": "Search inventory counts...",
        "inventory.counts.filter_title": "Filter by Status",
        "inventory.count.new_title": "New Inventory Count",
        "inventory.count.title_required": "Title is required",
        "inventory.count.date_required": "Date is required",
        "inventory.count.storage_required": "Storage is required",
        "inventory.count.storage": "Storage",
        "inventory.count.select_storage": "Select storage",
        "inventory.count.create_success": "Inventory count created successfully",
        "inventory.count.create_error": "Could not create inventory count",
        "inventory.count.approve": "Approve",
        "inventory.count.unapprove": "Unapprove",
        "inventory.count.approve_all": "Approve All",
        "inventory.count.unapprove_all": "Unapprove All",
        "inventory.count.approve_all_success": "{{count}} items approved successfully",
        "inventory.count.approve_all_error": "Could not approve all items",
        "inventory.count.all_items_already_approved": "All items are already approved",
        "inventory.count.approved": "Approved",
        "inventory.count.approved_at": "Approved at",
        "inventory.count.approved_by": "Approved by",
        "inventory.count.approve_success": "Count approved successfully",
        "inventory.count.approve_error": "Could not approve count",
        "inventory.count.unapprove_success": "Count unapproved successfully",
        "inventory.count.unapprove_error": "Could not unapprove count",
        "inventory.count.copy": "Copy Count",
        "inventory.count.no_title": "No title",
        "inventory.count.could_not_load": "Could not load inventory counts",
        "inventory.count.no_counts_found": "No inventory counts found",
        "inventory.count.create_new": "Create a new inventory count",
        "selected": "selected",
        "Select": "Select",
        "Select all": "Select all",
        "Updated": "Updated",
        "Created": "Created",
        "inventory.count.copy_from_previous": "Copy from Previous Count",
        "inventory.count.copy_all_products": "Copy All Products from Stock",
        "inventory.count.select_count_to_copy": "Select Count to Copy",
        "inventory.count.copy_success": "Count copied successfully",
        "inventory.count.copy_error": "Could not copy count",
        "inventory.count.copy_products_success": "Products copied successfully",
        "inventory.count.copy_products_error": "Could not copy products",
        "inventory.count.approved_items": "Approved Items",
        "inventory.count.approve_count": "Approve Count",
        "inventory.count.date_updated": "Date updated successfully",
        "inventory.count.date_update_error": "Could not update date",
        "inventory.count.storage_updated": "Storage updated successfully",
        "inventory.count.storage_update_error": "Could not update storage",
        "inventory.count.no_storage": "No storage",
        "inventory.count.export_pdf": "Export PDF",
        "inventory.count.export_csv": "Export CSV/Excel",
        "inventory.count.export_pdf_success": "PDF exported successfully",
        "inventory.count.export_pdf_error": "Could not export PDF",
        "inventory.count.export_csv_success": "CSV exported successfully",
        "inventory.count.export_csv_error": "Could not export CSV",
        "inventory.count.product_stock": "Product Stock",
        "product.stock_report.title": "Stock Report",
        "product.stock_report.description": "Complete overview of all stock transactions (in/out) and where the product is registered (counts, corrections, orders, reports, etc.)",
        "product.stock_report.date": "Date",
        "product.stock_report.type": "Type",
        "product.stock_report.transaction_title": "Title",
        "product.stock_report.quantity": "Quantity",
        "product.stock_report.storage": "Storage",
        "product.stock_report.status": "Status",
        "product.stock_report.approved": "Approved",
        "product.stock_report.pending": "Pending",
        "product.stock_report.no_transactions": "No transactions",
        "product.stock_report.no_transactions_description": "No stock transactions found for this product",
        "inventory.count.tracked_quantity": "Tracked Quantity",
        "inventory.count.available_quantity": "Available Quantity",
        "inventory.count.incoming_quantity": "Incoming Quantity",
        "inventory.count.outgoing_quantity": "Outgoing Quantity",
        "inventory.count.sales_price": "Sales Price",

        "inventory.settings.title": "Inventory settings",
        "inventory.settings.subtitle": "Manage storages and picking list options",
        "inventory.settings.new_storage": "New storage",
        "inventory.settings.storages": "Storages",

        "inventory.picking.title": "Picking list",
        "inventory.picking.subtitle": "Orders, work orders and service reports — lines that need picking",
        "inventory.picking.hero_kicker": "Inventory",
        "inventory.picking.filters_heading": "Filters & search",
        "inventory.picking.filters_description": "Narrow which document types and lines appear. Orders are off by default — select Order to include them.",
        "inventory.picking.list_kicker": "Picking",
        "inventory.picking.list_title": "Documents & lines",
        "inventory.picking.list_description": "Expand each document to see product lines, choose warehouse, and record picks.",
        "inventory.picking.loading": "Loading…",
        "inventory.picking.empty_title": "Nothing to show",
        "inventory.picking.picked_label": "Picked",
        "inventory.picking.meta.groups": "Groups",
        "inventory.picking.meta.lines": "Lines",
        "inventory.picking.search_placeholder": "Search order, product, item number…",
        "inventory.picking.filter.unpicked_only": "Only unpicked / partial",
        "inventory.picking.filter.warehouse_only": "Warehouse products only",
        "inventory.picking.filter.warehouse_only_help": "When on, only lines whose product is marked for warehouse tracking are shown — if every product is warehouse-tracked, the list looks the same as when this is off. When off, all lines appear; non-warehouse products get an amber row and the “Not warehouse-tracked” badge.",
        "inventory.picking.filter.include_skipped": "Show “do not pick” lines",
        "inventory.picking.filter.include_skipped_help": "Lines marked as not to be picked are hidden by default so the list stays focused. Turn this on to see them again (e.g. to clear the flag).",
        "inventory.picking.non_warehouse_badge": "Not warehouse-tracked",
        "inventory.picking.non_warehouse_hint": "This product is not marked for warehouse/inventory tracking. You can still pick it and choose storage if needed.",
        "inventory.picking.refresh": "Refresh",
        "inventory.picking.empty": "Nothing to pick with the current filters.",
        "inventory.picking.load_error": "Could not load picking list",
        "inventory.picking.open_source": "Open document",
        "inventory.picking.open_document_short": "Open",
        "inventory.picking.open_item_list": "Item list",
        "inventory.picking.qty": "Qty",
        "inventory.picking.qty_picked": "Picked",
        "inventory.picking.storage": "Storage",
        "inventory.picking.pick_storage": "Warehouse",
        "inventory.picking.storage_placeholder": "Select warehouse…",
        "inventory.picking.storage_required": "Select a warehouse before marking as picked",
        "inventory.picking.toggle_picked": "Mark picked",
        "inventory.picking.marked_picked": "Marked as picked",
        "inventory.picking.marked_unpicked": "Picking cleared",
        "inventory.picking.toggle_error": "Could not update line",
        "inventory.picking.skip.label": "Do not pick",
        "inventory.picking.skip.badge": "Not for picking",
        "inventory.picking.skip.row_hint": "This line is excluded from warehouse picking. Clear “Do not pick” to require a pick again.",
        "inventory.picking.skip.blocks_pick": "Clear “Do not pick” before marking as picked.",
        "inventory.picking.skip.on": "Marked as not for picking",
        "inventory.picking.skip.off": "Line is pickable again",
        "inventory.picking.skip.error": "Could not update “do not pick”",
        "inventory.picking.send_reminder": "Send reminder",
        "inventory.picking.reminder_sent": "Reminder queued",
        "inventory.picking.reminder_error": "Could not send reminder",
        "inventory.picking.quick_print.tooltip": "Quick print label (PDF)",
        "inventory.picking.quick_print.document_tooltip": "Quick print document label (number, customer, address, type)",
        "inventory.picking.quick_print.opened": "Label opened in a new tab",
        "inventory.picking.quick_print.no_product": "Missing product",
        "inventory.picking.quick_print.no_types": "No label types configured",
        "inventory.picking.quick_print.failed": "Could not create label PDF",
        "inventory.picking.delivery_note.tooltip": "Print delivery note (følgeseddel, PDF)",
        "inventory.picking.delivery_note.opened": "Delivery note opened in a new tab",
        "inventory.picking.delivery_note.failed": "Could not create delivery note PDF",
        "inventory.picking.delivery_note.missing_id": "Missing document id",
        "inventory.picking.delivery_note.unsupported": "Delivery note is not available for this document type yet",
        "inventory.picking.module.order": "Order",
        "inventory.picking.module.work_order": "Work order",
        "inventory.picking.module.report": "Report",
        "inventory.picking.execution_on": "Execution date",
        "inventory.picking.status.invoiced": "Invoiced",
        "inventory.picking.status.used_job": "Used on job",
        "inventory.picking.status.in_vehicle": "Taken in vehicle",
        "inventory.picking.status.not_used": "Not used",
        "inventory.picking.status.returned": "Returned to storage",
        "inventory.picking.status.left_vehicle": "Left in vehicle",
        "inventory.picking.status.picked": "Picked",
        "inventory.picking.status.not_picked": "Not picked",
        "inventory.picking.settings.title": "Picking list reminders",
        "inventory.picking.settings.description": "Users who receive email when you use “Send reminder” on the picking list.",
        "inventory.picking.settings.recipients": "Recipients",
        "inventory.picking.settings.recipients_placeholder": "Select users…",
        "inventory.picking.settings.save": "Save",
        "inventory.picking.settings.saving": "Saving…",
        "inventory.picking.settings.saved": "Settings saved",
        "inventory.picking.settings.save_error": "Could not save settings",
        "inventory.picking.settings.load_error": "Could not load picking settings",

        "Exporting...": "Exporting...",
        "Processing...": "Processing...",
        
        // Offer Calculation translations (English)
        "offer.calculation.title": "Calculations / Offer Items",
        "offer.calculation.subtitle": "Manage calculations and offer items",
        "offer.calculation.new": "New Calculation",
        "offer.calculation.search_placeholder": "Search calculations...",
        "offer.calculation.name": "Name",
        "offer.calculation.type": "Type",
        "offer.calculation.status": "Status",
        "offer.calculation.total": "Total",
        "offer.calculation.actions": "Actions",
        "offer.calculation.view": "View",
        "offer.calculation.edit": "Edit",
        "offer.calculation.delete": "Delete",
        "offer.calculation.delete_confirm": "Are you sure you want to delete this calculation?",
        "offer.calculation.no_results": "No calculations found",
        "offer.calculation.active": "Active",
        "offer.calculation.inactive": "Inactive",
        "offer.calculation.type.standard": "Standard",
        "offer.calculation.type.product": "Product",
        "offer.calculation.type.hours": "Hours",
        "offer.calculation.type.car_allowance": "Car Allowance",
        "offer.calculation.type.nested": "Nested",
        "offer.calculation.line": "line",
        "offer.calculation.lines": "lines",
        "offer.calculation.delete_success": "Calculation deleted successfully",
        "offer.calculation.delete_error": "Could not delete calculation",
        "offer.calculation.untitled": "Untitled",
        "offer.calculation.mode.title": "Choose calculation setup",
        "offer.calculation.mode.subtitle": "Choose whether this calculation should use regular lines or the module builder. This is locked after the calculation is saved.",
        "offer.calculation.mode.lines_title": "Line calculation",
        "offer.calculation.mode.lines_hint": "Use the existing line-based calculation with products, hours and manual rows.",
        "offer.calculation.mode.modules_title": "Module builder",
        "offer.calculation.mode.modules_hint": "Build a visual flow with products, hours, formulas and arrows.",
        "offer.calculation.mode.locked_hint": "Calculation setup is locked after creation to avoid mixing lines and the module builder.",
        "offer.calculation.builder.section_title": "Calculation builder",
        "offer.calculation.builder.section_hint": "Keep the existing lines, or build a visual module-based calculation that can connect to the backend later.",
        "offer.calculation.builder.section_hint_lines": "This calculation is line-based. Use lines, products, hours and manual rows.",
        "offer.calculation.builder.section_hint_modules": "This calculation uses the module builder. Build the flow visually and test it in user insert view.",
        "offer.calculation.builder.tab_lines": "Lines",
        "offer.calculation.builder.tab_modules": "Module builder",
        "offer.calculation.builder.tab_insert": "User insert view",
        "offer.calculation.page.kicker": "Offer calculation",
        "offer.calculation.page.subtitle": "Build, test and use calculations in a full-width workspace with lines, modules and a dedicated insert view.",
        "offer.calculation.insert.title": "User insert view",
        "offer.calculation.insert.subtitle": "This is how the calculation feels when pasted into offers, modules or other flows.",
        "offer.calculation.insert.inputs_title": "Adjustable fields",
        "offer.calculation.insert.inputs_hint": "Only unlocked fields can be changed here, for example kilometers, percent and distribution.",
        "offer.calculation.insert.flow_title": "How the calculation connects",
        "offer.calculation.insert.flow_hint": "Boxes and connections are shown as a readonly map while numbers update live.",
        "offer.calculation.insert.fields_tab": "Adjust fields",
        "offer.calculation.insert.map_tab": "Map",
        "offer.calculation.insert.offer_dialog_title": "Adjust calculation before adding it to the offer",
        "offer.calculation.insert.offer_cancel": "Cancel",
        "offer.calculation.insert.offer_add": "Add to offer",
        "offer.calculation.insert.adjust_fields": "Adjust fields",
        "offer.calculation.insert.edit_lines": "Edit calculation",
        "offer.calculation.insert.adjustable_fields": "Adjustable fields",
        "offer.calculation.insert.adjustable_fields_hint": "This calculation uses the module builder. Open adjustments to change quantity, kilometers, percent and other open fields.",
        "offer.calculation.module.palette_title": "Modules",
        "offer.calculation.module.palette_hint": "Drag modules onto the canvas, or click to add them.",
        "offer.calculation.module.canvas_title": "Module map",
        "offer.calculation.module.canvas_hint": "Move boxes, connect them with arrows, and choose whether each connection adds or subtracts.",
        "offer.calculation.module.connecting_hint": "Choose the next box to create a connection.",
        "offer.calculation.module.reset_example": "Reset to example",
        "offer.calculation.module.zoom_out": "Zoom out",
        "offer.calculation.module.zoom_in": "Zoom in",
        "offer.calculation.module.reset_view": "Reset view",
        "offer.calculation.module.result_title": "Result",
        "offer.calculation.module.result_hint": "This is a frontend preview. The backend becomes the source of truth for totals when implemented.",
        "offer.calculation.module.editor_title": "Edit selected module",
        "offer.calculation.module.edge_title": "Edit arrow",
        "offer.calculation.module.breakdown_title": "Breakdown",
        "offer.calculation.module.connect": "Connect",
        "offer.calculation.module.connect_here": "Connect here",
        "offer.calculation.module.remove": "Remove",
        "offer.calculation.module.remove_edge": "Remove arrow",
        "offer.calculation.module.locked": "Locked",
        "offer.calculation.module.unlocked": "Open",
        "offer.calculation.module.enabled": "Active",
        "offer.calculation.module.disabled": "Inactive",
        "offer.calculation.module.operation.add": "Add",
        "offer.calculation.module.operation.subtract": "Subtract",
        "offer.calculation.module.scope.all": "Whole job",
        "offer.calculation.module.scope.work": "Work only",
        "offer.calculation.module.scope.driving": "Driving only",
        "offer.calculation.module.scope.selected": "Selected modules",
        "offer.calculation.module.field.title": "Title",
        "offer.calculation.module.field.amount": "Amount",
        "offer.calculation.module.field.enabled": "Status",
        "offer.calculation.module.field.quantity": "Quantity",
        "offer.calculation.module.field.unit_price": "Unit price",
        "offer.calculation.module.field.product_name": "Product name",
        "offer.calculation.module.field.hours": "Hours",
        "offer.calculation.module.field.hourly_rate": "Hourly rate",
        "offer.calculation.module.field.cost_hourly_rate": "Cost hourly rate",
        "offer.calculation.module.field.percent": "Percent",
        "offer.calculation.module.field.scope": "Applies to",
        "offer.calculation.module.field.divisor": "Distribute by",
        "offer.calculation.module.field.expression": "Formula",
        "offer.calculation.module.field.note": "Note",
        "offer.calculation.module.field.operation": "Operation",
        "offer.calculation.module.formula.assistant_title": "Formula help",
        "offer.calculation.module.formula.assistant_subtitle": "Choose a ready-made template, or click variables and functions. You do not need to remember Excel syntax.",
        "offer.calculation.module.formula.templates": "Ready-made templates",
        "offer.calculation.module.formula.variables": "Insert value",
        "offer.calculation.module.formula.functions": "Smart functions",
        "offer.calculation.module.formula.example_title": "Tip",
        "offer.calculation.module.formula.example_text": "`input` is the sum from arrows going into {{title}}. Start with a template and adjust the numbers.",
        "offer.calculation.module.formula.variable.input": "Sum from incoming arrows",
        "offer.calculation.module.formula.variable.quantity": "Own quantity",
        "offer.calculation.module.formula.variable.price": "Own price",
        "offer.calculation.module.formula.variable.percent": "Own percent",
        "offer.calculation.module.formula.function.sum": "Sum several numbers",
        "offer.calculation.module.formula.function.round": "Round to whole number",
        "offer.calculation.module.formula.function.min": "Maximum price cap",
        "offer.calculation.module.formula.function.max": "Minimum price",
        "offer.calculation.module.formula.template.same": "Use the sum as-is",
        "offer.calculation.module.formula.template.fixed_add": "Add fixed amount",
        "offer.calculation.module.formula.template.fixed_subtract": "Subtract fixed amount",
        "offer.calculation.module.formula.template.ten_percent": "Add 10%",
        "offer.calculation.module.formula.template.custom_percent": "Add custom %",
        "offer.calculation.module.formula.template.quantity_price": "Quantity times price",
        "offer.calculation.module.formula.template.split_two": "Split by 2",
        "offer.calculation.module.formula.template.round": "Round the total",
        "offer.calculation.module.node.service": "Service",
        "offer.calculation.module.node.service_hint": "Fixed amount that can be locked, e.g. apartment.",
        "offer.calculation.module.node.quantity": "Quantity x price",
        "offer.calculation.module.node.quantity_hint": "Quantity multiplied by unit price, e.g. kilometers.",
        "offer.calculation.module.node.product_price": "Product price",
        "offer.calculation.module.node.product_price_hint": "Product name, quantity and price in one module.",
        "offer.calculation.module.node.product_catalog": "Product list",
        "offer.calculation.module.node.product_catalog_hint": "Add products from the product register or manual product lines.",
        "offer.calculation.module.node.labor_hours": "Hours field",
        "offer.calculation.module.node.labor_hours_hint": "Hours multiplied by hourly rate, e.g. additional work or service work.",
        "offer.calculation.module.node.percentage": "Percentage",
        "offer.calculation.module.node.percentage_hint": "Markup or discount on incoming modules.",
        "offer.calculation.module.node.distribution": "Distribution",
        "offer.calculation.module.node.distribution_hint": "Distribute incoming amount by X.",
        "offer.calculation.module.node.formula": "Excel formula",
        "offer.calculation.module.node.formula_hint": "Use input, quantity, price, percent, SUM and ROUND.",
        "offer.calculation.module.node.subtotal": "Subtotal",
        "offer.calculation.module.node.subtotal_hint": "Collects several incoming modules.",
        "offer.calculation.module.node.total": "Total",
        "offer.calculation.module.node.total_hint": "End point for the calculation.",
        "offer.calculation.module.node.note": "Note",
        "offer.calculation.module.node.note_hint": "Explanation box without amount.",
        "offer.calculation.module.product.title": "Products",
        "offer.calculation.module.product.hint": "Choose products from the register or add your own product lines.",
        "offer.calculation.module.product.add_from_catalog": "Add from product register",
        "offer.calculation.module.product.add_manual": "Manual line",
        "offer.calculation.module.product.empty": "No products added yet.",
        "offer.calculation.module.product.manual_title": "Manual product",
        "offer.calculation.module.product.include": "Include",
        "offer.calculation.module.product.exclude": "Exclude",
        "offer.calculation.module.product.total": "Product total",
        "offer.calculation.module.product.cancel": "Cancel",
        "offer.calculation.module.product.add_selected": "Add selected",
        
        // Accounting Summary translations
        "accounting.summary.title": "Accounting Summary",
        "accounting.summary.costs": "Costs",
        "accounting.summary.income": "Income",
        "accounting.summary.profit": "Profit",
        "accounting.summary.profit_margin": "margin",
        "accounting.summary.projects": "Projects",
        "accounting.summary.labor": "Labor Costs",
        "accounting.summary.material": "Material Costs",
        "accounting.summary.supplier_invoices": "Supplier Invoices",
        "accounting.summary.item_lists": "Item Lists",
        "accounting.summary.customer_invoices": "Customer Invoices",
        "accounting.summary.reports": "Reports",
        "accounting.summary.total": "Total",
        "accounting.summary.calculated_at": "Calculated",
        "accounting.summary.cached": "Cached",
        "accounting.summary.load_error": "Failed to load accounting summary",
        "accounting.summary.monthly_overview": "Monthly Overview",
        "accounting.summary.chart_description": "Bars: income & costs · Line: monthly profit (income − costs)",
        "accounting.summary.no_monthly_data": "No monthly data available",
        "accounting.summary.months.january": "Jan",
        "accounting.summary.months.february": "Feb",
        "accounting.summary.months.march": "Mar",
        "accounting.summary.months.april": "Apr",
        "accounting.summary.months.may": "May",
        "accounting.summary.months.june": "Jun",
        "accounting.summary.months.july": "Jul",
        "accounting.summary.months.august": "Aug",
        "accounting.summary.months.september": "Sep",
        "accounting.summary.months.october": "Oct",
        "accounting.summary.months.november": "Nov",
        "accounting.summary.months.december": "Dec",
        "accounting.summary.expected_report_income": "Expected Assignment Income",
        "accounting.summary.expected_income": "Expected Income",
        "accounting.summary.expected_costs": "Expected Costs",
        "accounting.summary.expected_profit": "Expected Profit",

        // Microsoft / Outlook
        "microsoft.explain.title": "What does connecting mean?",
        "microsoft.explain.company.1":
          "Connects your company’s primary email (e.g. post@company.com) to Microsoft so Promang can read and handle incoming email for cases.",
        "microsoft.explain.company.2":
          "Provides a basis for creating and updating cases from email threads.",
        "microsoft.explain.company.3":
          "Requires admin rights and Microsoft consent for the selected mailbox.",
        "microsoft.explain.company.4":
          "Secrets and token exchange happen only in the Promang API — not in the browser.",
        "microsoft.explain.company.5":
          "Sending email and AI features for company mail will arrive when server-side token storage is complete.",
        "microsoft.explain.user.1":
          "Connects your own Microsoft / Outlook account to the Promang user you’re signed in as.",
        "microsoft.explain.user.2":
          "Lets you send email from your address where enabled in Promang, and use AI/context from your mail.",
        "microsoft.explain.user.3":
          "You must be signed in to Promang before you click «Connect Microsoft».",
        "microsoft.explain.user.4":
          "The email address in Microsoft should match your user wherever practical.",
        "microsoft.explain.user.5":
          "You can disconnect anytime under Settings or on the Microsoft / Outlook page.",
        "microsoft.company.page_title": "Microsoft — company mail",
        "microsoft.company.page_subtitle": "Connect the company’s primary email (admin).",
        "microsoft.company.card_title": "Company mail (Microsoft 365)",
        "microsoft.company.subtitle": "For shared inbox and cases on behalf of the business.",
        "microsoft.user.page_title": "Microsoft / Outlook",
        "microsoft.user.page_subtitle": "Connect your Microsoft account to this Promang user.",
        "microsoft.user.card_title": "Your Outlook account",
        "microsoft.user.subtitle":
          "Email is sent from your account where supported; also provides context to AI and cases.",
        "microsoft.user.settings_section_title": "Microsoft / Outlook",
        "microsoft.user.settings_section_intro":
          "Connect Microsoft to the account you’re signed in with. This is not the same as «Sign in with Microsoft» on the login page — you stay in Promang and grant access to email for dashboard features.",
        "microsoft.user.open_full_page": "Open dedicated connection page",
        "microsoft.user.calendar_heading": "Calendar for events",
        "microsoft.user.calendar_intro":
          "All calendars you can open in Outlook for this account are listed (your own and shared). Pick where Promang should create events. Use search if you have many calendars.",
        "microsoft.user.calendar_refresh": "Load calendars",
        "microsoft.user.calendar_need_refresh":
          "Connect Microsoft with a refresh token (full link) to load calendars.",
        "microsoft.user.calendar_select_label": "Calendar",
        "microsoft.user.calendar_none": "None selected",
        "microsoft.user.calendar_choose": "Search…",
        "microsoft.user.calendar_modal_title": "Choose calendar",
        "microsoft.user.calendar_modal_close": "Close",
        "microsoft.user.calendar_modal_hint":
          "Search by name or owner email. Shared calendars show a badge; read-only calendars cannot be saved for event sync.",
        "microsoft.user.calendar_search_placeholder": "Search calendars…",
        "microsoft.user.calendar_search_empty": "No calendars match your search.",
        "microsoft.user.calendar_modal_empty": "No calendars returned from Microsoft.",
        "microsoft.user.calendar_badge_own": "Yours",
        "microsoft.user.calendar_badge_shared": "Shared",
        "microsoft.user.calendar_badge_readonly": "Read-only",
        "microsoft.user.calendar_readonly_hint":
          "This calendar is read-only in Microsoft. Choose one you can edit to sync events.",
        "microsoft.user.calendar_readonly_save":
          "Cannot save a read-only calendar for events. Pick a calendar you can edit.",
        "microsoft.user.calendar_current": "Previously selected: {{name}}{{email}}",
        "microsoft.user.calendar_save": "Save calendar",
        "microsoft.user.calendar_saved": "Calendar saved.",
        "microsoft.user.calendar_save_failed": "Could not save calendar.",
        "microsoft.user.calendar_load_failed": "Could not load calendars.",
        "microsoft.user.personal_mail_ai.title": "Your mailbox — AI rules and processing",
        "microsoft.user.personal_mail_ai.intro":
          "Configure sorting, manual rules, AI routing, and run processing on your linked Microsoft mailbox — same options as shared company inboxes. Cases and customers are created in the current company.",
        "microsoft.user.personal_mail_ai.no_permission":
          "Your role does not include personal inbox AI. Ask an administrator to assign the «microsoft_personal_mail_ai» role for this company or give you admin access.",
        "microsoft.user.personal_mail_ai.forbidden_toast": "You are not allowed to open these settings.",
        "microsoft.user.personal_mail_ai.load_failed": "Could not load mail AI settings.",
        "microsoft.user.personal_mail_ai.no_refresh":
          "Connect Microsoft with a refresh token (full mail link) to load messages and run processing.",
        "microsoft.user.personal_mail_ai.connect_first":
          "Connect Microsoft above to configure inbox rules, AI routing, and processing for your own mailbox.",
        "microsoft.status.loading": "Loading status…",
        "microsoft.status.api_pending":
          "The API for saving tokens is still rolling out. You can still complete sign-in at Microsoft; contact an admin if something fails.",
        "microsoft.status.connected": "Connected",
        "microsoft.action.disconnect": "Disconnect",
        "microsoft.action.connect_microsoft": "Connect Microsoft",
        "microsoft.action.redirect_hint":
          "You’ll be sent to Microsoft to approve access, then back to Promang.",
        "microsoft.toast.login_required": "You must be signed in to Promang to connect.",
        "microsoft.toast.missing_env": "Microsoft is not configured on the server.",
        "microsoft.toast.start_failed": "Could not start Microsoft connection.",
        "microsoft.toast.disconnected": "Disconnected.",
        "microsoft.toast.disconnect_failed": "Could not disconnect.",
        "microsoft.callback.working": "Completing connection…",
        "microsoft.callback.error_microsoft": "Microsoft cancelled or failed.",
        "microsoft.callback.missing_params": "Missing code or state from Microsoft.",
        "microsoft.callback.success_login": "Signed in with Microsoft.",
        "microsoft.callback.success_link": "Microsoft account is connected.",
        "microsoft.callback.api_not_ready": "The API is not ready for this step yet.",
        "microsoft.callback.exchange_failed": "Could not complete the connection.",
        "microsoft.callback.unknown_intent": "Unknown connection type.",
        "microsoft.callback.title": "Microsoft & Promang",
        "microsoft.callback.subtitle_loading":
          "Completing a secure connection. This usually takes a few seconds.",
        "microsoft.callback.success_title": "Connection complete",
        "microsoft.callback.error_title": "Something went wrong",
        "microsoft.callback.redirecting_note": "Taking you back to Promang…",
        "microsoft.callback.continue_now": "Go to Promang now",
        "microsoft.callback.back_to_promang": "Back to Promang",
        "microsoft.callback.back_to_login": "Back to sign in",
        "microsoft.callback.debug_heading": "Technical detail (troubleshooting)",
        "microsoft.callback.wait_hint": "Do not close this tab while we finish.",
        "microsoft.login.or": "or",
        "microsoft.login.redirecting": "Redirecting…",
        "microsoft.login.with_microsoft": "Sign in with Microsoft",
        "microsoft.test_mail.button": "Send test email to myself",
        "microsoft.test_mail.hint":
          "Sends one message from your linked mailbox to the same address, to verify Mail.Send and tokens.",
        "microsoft.test_mail.success": "Test email sent. Check your inbox.",
        "microsoft.test_mail.failed": "Could not send test email.",
        "microsoft.ai_mailboxes.title": "Shared inboxes for AI",
        "microsoft.ai_mailboxes.admin_page_title": "Shared inboxes (Microsoft 365)",
        "microsoft.ai_mailboxes.admin_page_subtitle":
          "Register shared addresses, connect Microsoft, view the inbox, and configure how mail should be handled (sorting, cases, archive, auto-reply, signature, rules). Processing and optional move to Archive/Arkiv run when the job is on or you use “Run processing” (not simulation).",
        "microsoft.ai_mailboxes.intro":
          "Register shared addresses (e.g. post@, service@). Each mailbox must be linked with Microsoft so Promang can read the inbox and send tests via Graph.",
        "microsoft.ai_mailboxes.how_link_works":
          "Sign in as yourself (e.g. you@company.com) — not as the shared address. Shared mailboxes (e.g. post@…) usually have no password login. Use an account that can already open that shared mailbox in Outlook (full access / delegate). Promang stores a refresh token for the account you sign in with; Graph reads/sends for the address on this row.",
        "microsoft.ai_mailboxes.mail_safety_dev_notice":
          "We do not auto-archive, delete, or move mail in Microsoft. We read the inbox for display. “Run processing”, the scheduled job, and test mail can send **new** messages (e.g. notification forwards to addresses in rules) via Graph — use “Simulate job” to test without sending.",
        "microsoft.ai_mailboxes.linked_as": "Microsoft linked as {{email}}",
        "microsoft.ai_mailboxes.not_linked": "Not linked to Microsoft — connect to load inbox and send tests.",
        "microsoft.ai_mailboxes.connect_microsoft": "Connect Microsoft",
        "microsoft.ai_mailboxes.disconnect_microsoft": "Disconnect Microsoft",
        "microsoft.ai_mailboxes.send_test": "Send test email",
        "microsoft.ai_mailboxes.go_to_mailbox": "Go to mailbox",
        "microsoft.ai_mailboxes.go_to_mailbox_hint":
          "Opens Outlook on the web for this address in a new tab (folder tree: Inbox, Archive, etc.). Sign in to Microsoft in the browser with an account that can open this mailbox.",
        "microsoft.ai_mailboxes.go_to_mailbox_missing_email": "No mailbox address to open.",
        "microsoft.ai_mailboxes.multi_inbox_hint":
          "You can expand several mailboxes at the same time. Open a message in Promang to read it and view processing logs side by side.",
        "microsoft.ai_mailboxes.reader.title": "Message (Promang)",
        "microsoft.ai_mailboxes.reader.close": "Close",
        "microsoft.ai_mailboxes.reader.tab_message": "Content",
        "microsoft.ai_mailboxes.reader.tab_reply_draft": "AI reply draft",
        "microsoft.ai_mailboxes.reader.tab_logs": "Processing log",
        "microsoft.ai_mailboxes.reader.reply_draft_hint":
          "Edits the Outlook draft body (HTML). Sending from Outlook keeps the thread below your text.",
        "microsoft.ai_mailboxes.reader.reply_draft_load_failed": "Could not load reply draft.",
        "microsoft.ai_mailboxes.reader.reply_draft_saved": "Draft saved.",
        "microsoft.ai_mailboxes.reader.reply_draft_save": "Save draft",
        "microsoft.ai_mailboxes.reader.reply_draft_saving": "Saving…",
        "microsoft.ai_mailboxes.reader.reply_draft_none": "No AI reply draft for this message.",
        "microsoft.ai_mailboxes.reader.field_from": "From",
        "microsoft.ai_mailboxes.reader.field_to": "To",
        "microsoft.ai_mailboxes.reader.field_cc": "Cc",
        "microsoft.ai_mailboxes.reader.field_date": "Received",
        "microsoft.ai_mailboxes.reader.attachments_notice":
          "This message has attachments. Files are not shown here — use Outlook on the web if you need to download them.",
        "microsoft.ai_mailboxes.reader.body_iframe_title": "Email body",
        "microsoft.ai_mailboxes.reader.no_body": "No body content.",
        "microsoft.ai_mailboxes.reader.load_failed": "Could not load message.",
        "microsoft.ai_mailboxes.reader.inbox_only_hint":
          "The list above is inbox only. For Archive, Junk, and other folders, use Outlook on the web (link below) if needed.",
        "microsoft.ai_mailboxes.reader.folder_hint":
          "You can pick Archive, Sent, and other folders in the mailbox list above. Use Outlook on the web (link below) for full folder management if needed.",
        "microsoft.ai_mailboxes.reader.open_in_owa": "Open mailbox in Outlook on the web…",
        "microsoft.ai_mailboxes.reader.open_short": "Open",
        "microsoft.ai_mailboxes.reader.open_tooltip":
          "Open in Promang: read the email and view processing logs (tabs).",
        "microsoft.ai_mailboxes.show_inbox": "Mail folders",
        "microsoft.ai_mailboxes.inbox_requires_link": "Connect Microsoft for this address first.",
        "microsoft.ai_mailboxes.no_messages": "No messages in this folder (or folder is empty).",
        "microsoft.ai_mailboxes.messages_failed": "Could not load messages for this folder.",
        "microsoft.ai_mailboxes.process_folder_hint":
          "Select messages below, then simulate or run processing. The scheduled job still processes the Inbox only unless you change that separately.",
        "microsoft.ai_mailboxes.folder.select_label": "Folder",
        "microsoft.ai_mailboxes.folder.group_shortcuts": "Shortcuts",
        "microsoft.ai_mailboxes.folder.group_tree": "All folders",
        "microsoft.ai_mailboxes.folder.loading_tree": "Loading folder list…",
        "microsoft.ai_mailboxes.folder.folders_failed": "Could not load folder list.",
        "microsoft.ai_mailboxes.folder.seg_inbox": "Inbox",
        "microsoft.ai_mailboxes.folder.seg_archive": "Archive",
        "microsoft.ai_mailboxes.folder.seg_sentitems": "Sent",
        "microsoft.ai_mailboxes.folder.seg_deleteditems": "Deleted",
        "microsoft.ai_mailboxes.folder.seg_junkemail": "Junk email",
        "microsoft.ai_mailboxes.folder.seg_drafts": "Drafts",
        "microsoft.ai_mailboxes.folder.seg_outbox": "Outbox",
        "microsoft.ai_mailboxes.col.received": "Received",
        "microsoft.ai_mailboxes.col.from": "From",
        "microsoft.ai_mailboxes.col.subject": "Subject",
        "microsoft.ai_mailboxes.microsoft_disconnected": "Microsoft disconnected for this mailbox.",
        "microsoft.ai_mailboxes.microsoft_disconnect_failed": "Could not disconnect Microsoft.",
        "microsoft.ai_mailboxes.shared_test_ok": "Test email sent.",
        "microsoft.ai_mailboxes.shared_test_failed": "Could not send test email.",
        "microsoft.ai_mailboxes.email_label": "Email address",
        "microsoft.ai_mailboxes.email_placeholder": "post@company.com",
        "microsoft.ai_mailboxes.add": "Add",
        "microsoft.ai_mailboxes.empty": "No addresses added yet.",
        "microsoft.ai_mailboxes.remove": "Remove",
        "microsoft.ai_mailboxes.added": "Address added.",
        "microsoft.ai_mailboxes.add_failed": "Could not add address.",
        "microsoft.ai_mailboxes.removed": "Address removed.",
        "microsoft.ai_mailboxes.remove_failed": "Could not remove address.",
        "microsoft.ai_mailboxes.load_failed": "Could not load addresses.",
        "microsoft.ai_mailboxes.email_required": "Enter an email address.",
        "microsoft.ai_mailboxes.settings.toggle": "Settings",
        "microsoft.ai_mailboxes.settings.heading": "Mail handling",
        "microsoft.ai_mailboxes.settings.intro":
          "These options apply to this mailbox only. The inbox list uses Microsoft Graph ordering immediately after save.",
        "microsoft.ai_mailboxes.settings.processing_job_title": "Job: process inbox",
        "microsoft.ai_mailboxes.settings.processing_job_hint":
          "When “On” is saved, a scheduled task (e.g. Heroku Scheduler + `rake microsoft:enqueue_ai_mailbox_processing`) can process up to 50 recent messages and apply rules (including forward as a text notification). Use “Simulate job” on the inbox list to test safely.",
        "microsoft.ai_mailboxes.settings.processing_job_off": "Off",
        "microsoft.ai_mailboxes.settings.processing_job_on": "On",
        "microsoft.ai_mailboxes.settings.mail_sort": "Inbox sort order",
        "microsoft.ai_mailboxes.settings.sort_received_desc": "Newest first",
        "microsoft.ai_mailboxes.settings.sort_received_asc": "Oldest first",
        "microsoft.ai_mailboxes.settings.sort_subject_asc": "Subject A–Z",
        "microsoft.ai_mailboxes.settings.auto_create_case": "Create a case for new mail (when enabled in Promang)",
        "microsoft.ai_mailboxes.settings.auto_create_case_hint":
          "When the feature ships, exclusions below avoid cases from ads, newsletters, etc.",
        "microsoft.ai_mailboxes.settings.skip_promotional_hint": "Treat likely promo/newsletter mail as non-case (recommended)",
        "microsoft.ai_mailboxes.settings.ignore_subject_keywords": "Do not create a case if subject contains (comma or newline)",
        "microsoft.ai_mailboxes.settings.ignore_subject_placeholder": "e.g. promo, unsubscribe, newsletter",
        "microsoft.ai_mailboxes.settings.ignore_from_domains": "Do not create a case if sender domain is (comma or newline)",
        "microsoft.ai_mailboxes.settings.ignore_domains_placeholder": "e.g. mailchimp.com, sendgrid.net",
        "microsoft.ai_mailboxes.settings.archive_after_processing": "Archive after processing",
        "microsoft.ai_mailboxes.settings.archive_hint":
          "Moves processed mail from Inbox to **Archive** or **Arkiv** via Microsoft Graph after successful processing (manual rule or AI). Applies in development too — requires running processing with real actions, not “Simulate job”.",
        "microsoft.ai_mailboxes.settings.auto_reply_enabled": "Automatic reply after a new case is created (customer inquiry)",
        "microsoft.ai_mailboxes.settings.auto_reply_body_ph":
          "HTML body (optional). Placeholders: %{case_number}, %{sak}. If empty, a default text with the case number is used.",
        "microsoft.ai_mailboxes.settings.auto_reply_note":
          "When auto-reply is on, Promang replies in the same email thread (Graph reply), not as a separate new message. The reply subject line gets [SAK-<number>]. Signature HTML is appended when set.",
        "microsoft.ai_mailboxes.settings.signature_html": "Signature (HTML)",
        "microsoft.ai_mailboxes.settings.signature_ph": "<p>Kind regards<br/>…</p>",
        "microsoft.ai_mailboxes.settings.rules_heading": "Rules",
        "microsoft.ai_mailboxes.settings.rules_intro":
          "Extra rules (e.g. skip case or forward copy to an address) for when the inbox job runs. Matching uses simple text checks.",
        "microsoft.ai_mailboxes.settings.rules_forward_hint":
          "Forward rules are stored; during development the background job does not send mail automatically yet.",
        "microsoft.ai_mailboxes.settings.add_rule": "Add rule",
        "microsoft.ai_mailboxes.settings.no_rules": "No custom rules yet.",
        "microsoft.ai_mailboxes.settings.rule_name": "Name",
        "microsoft.ai_mailboxes.settings.rule_match": "Match",
        "microsoft.ai_mailboxes.settings.rule_value": "Value",
        "microsoft.ai_mailboxes.settings.rule_action": "Action",
        "microsoft.ai_mailboxes.settings.rule_on": "On",
        "microsoft.ai_mailboxes.settings.remove_rule": "Remove rule",
        "microsoft.ai_mailboxes.settings.match_subject_contains": "Subject contains",
        "microsoft.ai_mailboxes.settings.match_from_domain": "From domain",
        "microsoft.ai_mailboxes.settings.match_from_contains": "From address contains",
        "microsoft.ai_mailboxes.settings.action_skip_case": "Do not create case",
        "microsoft.ai_mailboxes.settings.action_forward_to": "Forward / send copy to email",
        "microsoft.ai_mailboxes.settings.rule_forward_to_email": "Send to (email)",
        "microsoft.ai_mailboxes.settings.rule_forward_to_placeholder": "e.g. orders@company.com",
        "microsoft.ai_mailboxes.settings.save": "Save settings",
        "microsoft.ai_mailboxes.settings.saved": "Settings saved.",
        "microsoft.ai_mailboxes.settings.save_failed": "Could not save settings.",
        "microsoft.ai_mailboxes.settings.ai_routing_heading": "AI routing",
        "microsoft.ai_mailboxes.settings.ai_routing_hint":
          "Choose what happens for each mail type. Settings are stored as JSON behind the scenes. When routing is on, OpenAI/Grok (env vars) classifies when available — otherwise heuristics. Manual rules override AI actions.",
        "microsoft.ai_mailboxes.settings.ai_routing_invalid_json": "Invalid JSON in AI routing.",
        "microsoft.ai_mailboxes.settings.ai_routing_raw_json": "Edit as raw JSON (advanced)",
        "microsoft.ai_mailboxes.settings.ai_routing_raw_json_hint":
          "The form and JSON are equivalent. When you turn raw JSON off, the text is parsed back into the form (must be valid JSON).",
        "microsoft.ai_mailboxes.ai_routing.master_enable": "Enable AI routing and automatic actions",
        "microsoft.ai_mailboxes.ai_routing.master_hint":
          "When off, messages are still classified for display, but no automatic AI actions run.",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_title": "AI reply draft (Outlook)",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_desc":
          "After a successful customer inquiry or case-reply handling, a reply draft is created in your Microsoft mailbox. You send when ready.",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_enable": "Create AI-generated reply draft when processing",
        "microsoft.ai_mailboxes.ai_routing.reply_draft_requires_ai":
          "Turn on “Enable AI routing” above to use this (classification and case steps must run first).",
        "microsoft.ai_mailboxes.ai_routing.provider_label": "Classification provider",
        "microsoft.ai_mailboxes.ai_routing.provider_chatgpt": "ChatGPT (OpenAI)",
        "microsoft.ai_mailboxes.ai_routing.provider_grok": "Grok (xAI)",
        "microsoft.ai_mailboxes.ai_routing.model_label": "Model (optional)",
        "microsoft.ai_mailboxes.ai_routing.model_placeholder": "e.g. gpt-4o-mini",
        "microsoft.ai_mailboxes.ai_routing.model_hint": "Empty = server/environment default.",
        "microsoft.ai_mailboxes.ai_routing.action_label": "Action",
        "microsoft.ai_mailboxes.ai_routing.action_none": "Nothing (classify only)",
        "microsoft.ai_mailboxes.ai_routing.action_forward": "Forward to email",
        "microsoft.ai_mailboxes.ai_routing.action_move_archive": "Move to archive folder",
        "microsoft.ai_mailboxes.ai_routing.action_move_junk": "Move to junk email",
        "microsoft.ai_mailboxes.ai_routing.action_delete_graph": "Delete in Microsoft (Graph)",
        "microsoft.ai_mailboxes.ai_routing.action_move_folder": "Move to a folder",
        "microsoft.ai_mailboxes.ai_routing.action_create_case": "Create case in Promang",
        "microsoft.ai_mailboxes.ai_routing.action_append_case_note": "Add case line (CAS / case no.)",
        "microsoft.ai_mailboxes.ai_routing.action_customer_communication": "Log as customer communication on case",
        "microsoft.ai_mailboxes.ai_routing.action_reply_draft_only": "Log communication only (and AI reply draft if enabled)",
        "microsoft.ai_mailboxes.ai_routing.forward_to_label": "Forward to (email)",
        "microsoft.ai_mailboxes.ai_routing.folder_optional_label": "Folder name (optional)",
        "microsoft.ai_mailboxes.ai_routing.folder_optional_hint": "Empty uses default (Archive / Junk Email).",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_archive": "Archive",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_junk": "Junk Email",
        "microsoft.ai_mailboxes.ai_routing.folder_name_label": "Folder display name",
        "microsoft.ai_mailboxes.ai_routing.folder_placeholder_order": "Orders",
        "microsoft.ai_mailboxes.ai_routing.folder_order_hint": "The folder must exist in the Microsoft mailbox.",
        "microsoft.ai_mailboxes.ai_routing.cat_promotional_title": "Promotional / newsletter",
        "microsoft.ai_mailboxes.ai_routing.cat_promotional_desc": "Typical bulk marketing mail.",
        "microsoft.ai_mailboxes.ai_routing.cat_order_title": "Order confirmation",
        "microsoft.ai_mailboxes.ai_routing.cat_order_desc": "Orders and order documents.",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_title": "New customer inquiry",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_desc": "General inquiry without an existing case id in the thread.",
        "microsoft.ai_mailboxes.ai_routing.cat_inquiry_auto_reply_note":
          "Auto-reply and signature are configured in the sections further up on this page.",
        "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_title": "Supplier (CAS reference)",
        "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_desc":
          "Matches a case by CAS token or Promang case number in content. Fill “if no match” to avoid orphan mail.",
        "microsoft.ai_mailboxes.ai_routing.forward_unmatched_label": "If no match — forward to (email)",
        "microsoft.ai_mailboxes.ai_routing.forward_unmatched_hint": "Recommended so mail is not left without a case.",
        "microsoft.ai_mailboxes.ai_routing.cas_reference_label": "Fixed CAS reference (optional)",
        "microsoft.ai_mailboxes.ai_routing.cas_reference_hint": "Only if the reference is not in the email.",
        "microsoft.ai_mailboxes.ai_routing.case_number_fallback_label": "Fixed case number (optional)",
        "microsoft.ai_mailboxes.ai_routing.case_number_fallback_hint": "Numeric part, e.g. 1234, if not found in text.",
        "microsoft.ai_mailboxes.ai_routing.cat_case_reply_title": "Reply on existing case",
        "microsoft.ai_mailboxes.ai_routing.cat_case_reply_desc": "Mail that appears to relate to an open case (SAK id in thread).",
        "microsoft.ai_mailboxes.ai_routing.cat_project_title": "Project correspondence",
        "microsoft.ai_mailboxes.ai_routing.cat_project_desc":
          "Mail from a known customer / site contact about progress, deviations, site management, etc. — not a new generic customer inquiry.",
        "microsoft.ai_mailboxes.ai_routing.cat_project_reply_draft_note":
          "Requires the sender to match a Promang customer. Enable “AI reply draft” above for an Outlook draft.",
        "microsoft.ai_mailboxes.ai_routing.json_preview_toggle": "Show JSON to be saved (read-only)",
        "microsoft.ai_mailboxes.process_inbox_hint":
          "Select one or more messages and run processing (simulate sends no mail; Run may send forwards when a rule matches).",
        "microsoft.ai_mailboxes.process_select_all": "Select all",
        "microsoft.ai_mailboxes.process_clear_selection": "Clear selection",
        "microsoft.ai_mailboxes.process_select_column": "Select",
        "microsoft.ai_mailboxes.process_select_row": "Select message",
        "microsoft.ai_mailboxes.process_simulate": "Simulate job",
        "microsoft.ai_mailboxes.process_run": "Run processing",
        "microsoft.ai_mailboxes.process_need_selection": "Select at least one message in the list.",
        "microsoft.ai_mailboxes.process_run_confirm":
          "This may send real email (forwards) when rules match. Continue?",
        "microsoft.ai_mailboxes.process_ok_simulated":
          "Simulation done for {{count}} message(s). Forward rules that would fire: {{sim}}. Skip-case matches: {{skips}}.",
        "microsoft.ai_mailboxes.process_ok_executed":
          "Processing done for {{count}} message(s). Forwards sent: {{sent}}. Skip-case matches: {{skips}}.",
        "microsoft.ai_mailboxes.process_failed": "Could not process selected messages.",
        "microsoft.ai_mailboxes.processing_log.open_tooltip": "View processing log (dev tools)",
        "microsoft.ai_mailboxes.processing_log.title": "Processing log",
        "microsoft.ai_mailboxes.processing_log.close": "Close",
        "microsoft.ai_mailboxes.processing_log.load_failed": "Could not load processing logs.",
        "microsoft.ai_mailboxes.processing_log.empty":
          "No saved runs for this message yet. Use Simulate / Run processing, or wait for the scheduled job.",
        "microsoft.ai_mailboxes.processing_log.dry_run": "Dry run",
        "microsoft.ai_mailboxes.processing_log.live_run": "Live",
        "microsoft.ai_mailboxes.processing_log.failed": "Failed",
        "microsoft.ai_mailboxes.processing_log.ok": "OK",
        "microsoft.ai_mailboxes.processing_log.ai_category": "Classification",
        "microsoft.ai_mailboxes.processing_log.confidence": "confidence",
        "microsoft.ai_mailboxes.processing_log.actions": "Actions",
        "microsoft.ai_mailboxes.processing_log.raw_json": "Raw payload (JSON)",
        "microsoft.ai_mailboxes.processing_log.col_dev": "Log",
        "microsoft.ai_mailboxes.processing_log.sum.ai_classification":
          "AI: {{category}} ({{source}}, confidence {{confidence}})",
        "microsoft.ai_mailboxes.processing_log.sum.forward_dry": "Forward (dry run) → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.forward_sent": "Forwarded → {{to}}",
        "microsoft.ai_mailboxes.processing_log.sum.forward_failed": "Forward failed → {{to}}: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_dry": "Move (dry run){{target}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_ok": "Moved → {{folder}}",
        "microsoft.ai_mailboxes.processing_log.sum.move_failed": "Move failed: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.skip_case": "Rule: do not create case",
        "microsoft.ai_mailboxes.processing_log.sum.skip_case_unused": "skip_case (not applied)",
        "microsoft.ai_mailboxes.processing_log.sum.ai_routing_skipped": "AI routing skipped: {{reason}}",
        "microsoft.ai_mailboxes.processing_log.sum.generic_error": "{{type}}: {{error}}",
        "microsoft.ai_mailboxes.processing_log.sum.generic_not_applied": "{{type}}: not applied",
        "subscription.ai_usage.loading": "Loading…",
        "subscription.ai_usage.title": "AI usage & estimates",
        "subscription.ai_usage.subtitle":
          "Token usage, indicative cost and estimated time saved for your company (successful AI calls only).",
        "subscription.ai_usage.period.this_month": "This month",
        "subscription.ai_usage.period.this_year": "This year",
        "subscription.ai_usage.period.last_30_days": "Last 30 days",
        "subscription.ai_usage.period.last_12_months": "Last 12 months",
        "subscription.ai_usage.load_failed": "Could not load AI usage statistics.",
        "subscription.ai_usage.forbidden": "You do not have access to AI usage for this company.",
        "subscription.ai_usage.empty": "No AI usage recorded in this period.",
        "subscription.ai_usage.tokens": "Tokens (total)",
        "subscription.ai_usage.calls_ok": "Successful calls",
        "subscription.ai_usage.calls_fail": "Failed calls",
        "subscription.ai_usage.estimated_cost": "Estimated cost (NOK)",
        "subscription.ai_usage.cost_hint":
          "Internal estimate: {{rate}} NOK per 1M tokens. Not an invoice — actual provider pricing may differ.",
        "subscription.ai_usage.time_saved": "Estimated time saved",
        "subscription.ai_usage.time_hint":
          "Rough manual-equivalent minutes per successful call, by feature type. For planning only.",
        "subscription.ai_usage.minutes_only": "{{minutes}} min",
        "subscription.ai_usage.hours_minutes": "{{hours}} h {{minutes}} min",
        "subscription.ai_usage.by_feature": "By feature",
        "subscription.ai_usage.col_feature": "Feature",
        "subscription.ai_usage.col_calls": "Calls",
        "subscription.ai_usage.col_tokens": "Tokens",
        "subscription.ai_usage.col_cost": "Est. NOK",
        "subscription.ai_usage.col_time": "Est. time saved",
        "subscription.ai_usage.monthly_overview": "Per month (in period)",
        "subscription.ai_usage.feature.microsoft_ai_mailbox_classify": "AI inbox — classify",
        "subscription.ai_usage.feature.microsoft_ai_mailbox_case_title": "AI inbox — case title",
        "subscription.ai_usage.feature.service_report_invoice_description_generate":
          "Service report — invoice bullets",
        "subscription.ai_usage.feature.service_report_invoice_description_format_report":
          "Service report — HTML format",
        "subscription.ai_usage.feature.ai_generator_todo": "Tasks — AI assistant",
        "subscription.ai_usage.feature.ai_generator_hse_document": "HSE/KS — AI document fields",
        "subscription.ai_usage.feature.other": "{{feature}}",

        "todo.pageTitle": "Workspace — tasks & journal",
        "todo.tabTasks": "Tasks",
        "todo.loadingMoreTodos": "Loading more tasks…",
        "todo.loadMoreError": "Could not load more tasks.",
        "todo.filterAll": "All",
        "todo.filterActive": "Active",
        "todo.filterFinished": "Done",
        "todo.filterMine": "My tasks",
        "todo.due": "Due",
        "todo.todayPlanBadge": "Today’s plan",
        "todo.taskDetails": "Task details",
        "todo.descriptionPlaceholder": "Add a description…",
        "todo.dueDate": "Due date",
        "todo.reminder": "Reminder",
        "todo.onTodayPlan": "On today’s plan",
        "todo.recurrence": "Repeat when completed",
        "todo.recurrenceNone": "None",
        "todo.recurrenceDaily": "Daily",
        "todo.recurrenceWeekdays": "Weekdays",
        "todo.recurrenceWeekly": "Weekly",
        "todo.recurrenceMonthly": "Monthly",
        "todo.estimatedHours": "Estimated hours",
        "todo.labels": "Labels",
        "todo.aiAssistant": "AI assistant",
        "todo.hoursAvailable": "Hours available today (for day plan)",
        "todo.aiSuggestions": "Suggestions",
        "todo.aiEstimate": "Time estimate",
        "todo.aiPlan": "Day plan",
        "todo.aiResultTitle": "AI result",
        "todo.aiLoading": "Generating…",
        "todo.aiError": "Could not get AI suggestions.",
        "todo.hseDocumentTaskManualFinish":
          "HSE/KS document tasks cannot be completed here. Confirm that you have read and understood the document on the document view page.",
        "todo.hseDocumentOpenLink": "Open HSE/KS document",
        "hse.document.acknowledge_read": "I confirm that I have read and understood",
        "hse.document.acknowledge_read_submitting": "Saving…",
        "hse.document.acknowledge_read_success": "Recorded as read/understood",
        "hse.document.acknowledge_read_error": "Could not record read/understood",
        "hse.document.acknowledge_read_hint":
          "After you have reviewed the content, confirm here. The task in your to-do list is completed automatically.",
        "hse.document.acknowledge_read_done": "You are recorded as having read and understood this version.",
        "hse.document.approval_stuck_retry_hint":
          "Approval may not have finished publishing the version. Click Approve again to complete the step.",
        "hse.document.file_missing": "Attached file could not be found.",
        "hse.document.file_processing": "The file is still being processed. Please try again in a moment.",
        "hse.document.file_failed": "The file upload failed. Please upload the document again.",
        "hse.document.open_file": "Open file",
        "hse.document.download_file": "Download file",
        "hse.document.attached_file": "Attached file",
        "todo.journalTitle": "Journal",
        "todo.journalDate": "Date",
        "todo.journalHint": "Notes for the selected day (HTML). Auto-saved.",
        "todo.journalHintRich":
          "Select text to format (Notion-style). You can paste HTML from the web or OneNote — unsafe markup is stripped on save.",
        "todo.journalPlaceholder": "Write notes for this day…",
        "todo.journalFullscreen": "Full screen",
        "todo.journalExitFullscreen": "Exit full screen",
        "todo.journalOpenInFullscreen": "You’re editing in full screen. Close that window when you’re done.",
        "todo.journalSaveError": "Could not save journal.",
        "todo.journalImageTitle": "Image",
        "todo.journalImageWidth": "Width",
        "todo.journalImageWidthHint": "Pixels (320) or percent (50%).",
        "todo.journalImageHeight": "Height",
        "todo.journalImageHeightPlaceholder": "Optional (auto if empty)",
        "todo.journalImageAlt": "Description (alt text)",
        "todo.journalImageSizePresets": "Quick size",
        "todo.journalImageOriginal": "Reset size",
        "todo.journalImageAlign": "Alignment",
        "todo.journalImageAlignLeft": "Left",
        "todo.journalImageAlignCenter": "Center",
        "todo.journalImageAlignRight": "Right",
        "todo.journalImageApply": "Apply",
        "todo.journalImageRemove": "Remove image",
        "todo.digestTitle": "Email reminders",
        "todo.digestMorning": "Morning (approx. 07:00, your timezone)",
        "todo.digestEvening": "Evening (approx. 17:00)",
        "todo.digestTimezone": "Timezone",
        "todo.digestSaved": "Settings saved",
        "todo.digestSaveError": "Could not save email settings.",
        "todo.prevDay": "Previous day",
        "todo.nextDay": "Next day",
        "todo.today": "Today",
        "richTextEditor.contextMenu.ariaLabel": "Rich text actions",
        "richTextEditor.contextMenu.insertImage": "Insert image…",
        "richTextEditor.contextMenu.moveSelectionToPage": "Move selection to page…",
        "richTextEditor.contextMenu.createPageWithSelection": "New page from selection…",
        "richTextEditor.contextMenu.handlerMissing": "Connect a handler in the parent component to enable this action.",
        "richTextEditor.table.insert": "Insert table",
        "richTextEditor.table.hint": "Adds a 3 x 3 editable table.",
        "richTextEditor.table.defaultHeader": "Column",
        "automile.checkoutConfirmTitle": "Check out of vehicle?",
        "automile.checkoutConfirmMessage": "Are you sure you want to check out? The vehicle will be available for other drivers.",
        "automile.checkoutConfirm": "Yes, check out",
        "automile.checkoutCancel": "Cancel",
        "automile.checkInDriver": "Check in driver",
        "automile.checkOutVehicle": "Check out driver",
        "automile.linkUser": "Link user",
        "automile.selectEmployee": "Select employee",
        "automile.noVehiclesAvailable": "No available vehicles (active and no driver checked in).",
        "automile.settingsHint": "Complete Automile under Company → Integrations.",
        "automile.driverNeedsSync": "The driver must be synced with Automile before check-in.",
        "automile.onlyAvailableVehiclesSubtitle": "Only active vehicles with no driver checked in are shown.",
        "automile.noDriversFreeForCheckin": "No drivers available without a checked-in vehicle (with a linked user).",
        "automile.adminVehiclePickerSubtitle":
          "All active vehicles are listed. If a vehicle is checked in to someone else, assigning it here will move it to this driver (fleet managers).",
        "automile.noActiveVehiclesForFleet": "No active vehicles found.",
        "automile.vehicleOccupiedBadge": "Checked in — reassign will check out the current driver first",

        "platformBroadcast.scheduledLabel": "Scheduled update",
        "platformBroadcast.countdownPrefix": "In {{time}}",
        "platformBroadcast.scheduledOverdue": "Start time reached — please save your work",
        "platformBroadcast.activeNoticesRegion": "Active Promang notices",
        "platformBroadcast.noticeWarningTag": "Warning",
        "platformBroadcast.noticeInfoTag": "Info",
        "platformBroadcast.updatingTitle": "Promang is updating",
        "platformBroadcast.updatingHint": "We will be back as soon as the update finishes. Thank you for your patience.",
        "platformBroadcast.updatingAdminHint":
          "Administrator: When the deployment is finished, use the wrench button (bottom right) and choose «Confirm Promang has been updated».",
        "platformBroadcast.dev.menuAria": "Platform dev menu",
        "platformBroadcast.dev.noActiveUpdate": "No active maintenance session.",
        "platformBroadcast.dev.statusLine": "{{phase}}: {{title}}",
        "platformBroadcast.dev.scheduleUpdate": "Schedule update",
        "platformBroadcast.dev.startMaintenance": "Start maintenance (updating)",
        "platformBroadcast.dev.confirmComplete": "Confirm Promang has been updated",
        "platformBroadcast.dev.addNotice": "Add notice (info / warning)",
        "platformBroadcast.dev.manageNotices": "Manage notices",
        "platformBroadcast.dev.fieldTitle": "Title",
        "platformBroadcast.dev.fieldDescription": "Description",
        "platformBroadcast.dev.fieldScheduledAt": "Update time",
        "platformBroadcast.dev.fieldExpectedEnd": "Expected finished around",
        "platformBroadcast.dev.fieldKind": "Type",
        "platformBroadcast.dev.kindInfo": "Info",
        "platformBroadcast.dev.kindWarning": "Warning",
        "platformBroadcast.dev.cancel": "Cancel",
        "platformBroadcast.dev.save": "Save",
        "platformBroadcast.dev.start": "Start",
        "platformBroadcast.dev.close": "Close",
        "platformBroadcast.dev.maintenanceHint": "Users will see a full-screen “Promang is updating” view with a countdown to the expected end.",
        "platformBroadcast.dev.validationTitleTime": "Enter title and time.",
        "platformBroadcast.dev.validationTitle": "Enter a title.",
        "platformBroadcast.dev.invalidTime": "Invalid date or time.",
        "platformBroadcast.dev.saved": "Scheduled update saved.",
        "platformBroadcast.dev.maintenanceStarted": "Maintenance started.",
        "platformBroadcast.dev.confirmCompletePrompt": "Confirm the update is finished and clear this maintenance round for everyone?",
        "platformBroadcast.dev.confirmed": "Confirmed.",
        "platformBroadcast.dev.noticeCreated": "Notice created.",
        "platformBroadcast.dev.noticeHidden": "Notice hidden.",
        "platformBroadcast.dev.noticeShown": "Notice shown again.",
        "platformBroadcast.dev.requestFailed": "Request failed.",
        "platformBroadcast.dev.historyHint": "Hide notices when an issue is resolved. Update history is kept in the database.",
        "platformBroadcast.dev.recentUpdates": "Recent scheduled updates",
        "platformBroadcast.dev.allNotices": "All notices",
        "platformBroadcast.dev.hidden": "hidden",
        "platformBroadcast.dev.hide": "Hide",
        "platformBroadcast.dev.show": "Show",
        "platformBroadcast.dev.roleViewMenu": "Simulate role view (UI only)",
        "platformBroadcast.dev.roleViewTitle": "How Promang looks for you",
        "platformBroadcast.dev.roleViewTabPresets": "Presets",
        "platformBroadcast.dev.roleViewTabCustom": "Custom (like user admin)",
        "platformBroadcast.dev.roleViewHintCustom":
          "Same switches as under Company → Users. Use «Apply simulation» at the bottom when you are done.",
        "platformBroadcast.dev.roleViewCustomApply": "Apply simulation",
        "platformBroadcast.dev.roleViewHint":
          "Only affects this browser: sidebar, route guards, RoleOnly, and related hooks. The API still uses your real permissions.",
        "platformBroadcast.dev.roleViewApply": "Apply",
        "platformBroadcast.dev.roleViewReset": "Clear simulation",
        "platformBroadcast.dev.roleViewResetNow": "Clear simulation",
        "platformBroadcast.dev.roleViewActiveBanner":
          "Role simulation is on — the UI does not reflect your real access.",
        "platformBroadcast.dev.roleViewToastApplied": "Role simulation updated.",
        "platformBroadcast.dev.roleViewToastReset": "Role simulation cleared.",
        "platformBroadcast.dev.roleViewPreset.off.label": "Real permissions",
        "platformBroadcast.dev.roleViewPreset.off.description":
          "Use roles from the server (default).",
        "platformBroadcast.dev.roleViewPreset.none.label": "No roles",
        "platformBroadcast.dev.roleViewPreset.none.description":
          "Empty role list — almost no modules in the menu.",
        "platformBroadcast.dev.roleViewPreset.hours_time_only.label":
          "Time registration only",
        "platformBroadcast.dev.roleViewPreset.hours_time_only.description":
          "Hours module with register/edit own time — no approval, settings, or absence extras.",
        "platformBroadcast.dev.roleViewPreset.hours_extended.label":
          "Hours + approval & absence",
        "platformBroadcast.dev.roleViewPreset.hours_extended.description":
          "Broad hours persona: lists, approval, settings read, absence registration.",
        "platformBroadcast.dev.roleViewPreset.service_field.label":
          "Service field staff",
        "platformBroadcast.dev.roleViewPreset.service_field.description":
          "Service overview and reports focus; limited agreements access.",
        "platformBroadcast.dev.roleViewPreset.projects_participant.label":
          "Project participant",
        "platformBroadcast.dev.roleViewPreset.projects_participant.description":
          "Projects and work orders with typical executor-style actions.",
        "Send Offer": "Send offer",
        "Choose recipient, offer PDF version and customer message before sending.":
          "Choose recipient, offer PDF version and customer message before sending.",
        "Offer sending has been queued. You will be notified when it's complete.":
          "Offer sending has been queued. You will be notified when it's complete.",
        "Something went wrong. Could not send offer.":
          "Something went wrong. Could not send offer.",
        "Offer Type": "Offer type",
        "Internal offer": "Internal offer",
        "Customer offer": "Customer offer",
        "Open selected offer PDF": "Open selected offer PDF",
        "PDF preview will be available when the selected offer type is generated.":
          "PDF preview will be available when the selected offer type is generated.",
        "Message to customer": "Message to customer",
        "Offer sent successfully!": "Offer sent successfully!",
        "Offer sending queued...": "Offer sending queued...",
        "Generating PDF and sending offer...":
          "Generating PDF and sending offer...",
        "Failed to send offer": "Failed to send offer",
        "Failed to send offer. Please try again.":
          "Failed to send offer. Please try again.",
        "Request timed out. Please check the offer status manually.":
          "Request timed out. Please check the offer status manually.",
        "publicAppointment.title": "Confirm appointment",
        "publicAppointment.subtitle": "Review the details and confirm that the appointment still suits you.",
        "publicAppointment.sectionAppointment": "Appointment",
        "publicAppointment.sectionWork": "What we will do",
        "publicAppointment.reportType": "Job type",
        "publicAppointment.serviceAddress": "Service address",
        "publicAppointment.workDescription": "Description of work",
        "publicAppointment.timeExactHint": "We aim to arrive close to this time.",
        "publicAppointment.timeWindowHint": "We will arrive somewhere within this time window.",
        "publicAppointment.reportNumber": "Job / report no.",
        "publicAppointment.date": "Date",
        "publicAppointment.time": "Time",
        "publicAppointment.companyFallback": "Service provider",
        "publicAppointment.confirmHint":
          "When you confirm, we register the appointment as agreed. If something is wrong, please contact us by phone or email.",
        "publicAppointment.termsAcceptPlain":
          "By confirming this appointment, you accept our terms for use of services, sales and service agreements.",
        "publicAppointment.termsAcceptPrefix": "By confirming this appointment, you accept our ",
        "publicAppointment.termsAcceptLink": "terms for use of services, sales and service agreements",
        "publicAppointment.termsAcceptSuffix": ".",
        "publicAppointment.confirmButton": "Confirm appointment",
        "publicAppointment.submitting": "Confirming…",
        "publicAppointment.successTitle": "Thank you — the appointment is confirmed",
        "publicAppointment.successBody": "You can close this page. If you need to make changes, contact the company directly.",
        "publicAppointment.alreadyConfirmed": "This appointment is already confirmed.",
        "publicAppointment.loadFailed": "We could not load this appointment. The link may be invalid or expired.",
        "publicAppointment.confirmFailed": "We could not register your confirmation. Please try again or contact us.",
        "publicAppointment.missingToken": "This confirmation link is missing required information.",
      },
}